/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	__webpack_require__(48);
	module.exports = __webpack_require__(52);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	
	__webpack_require__(3);
	
	__webpack_require__(4);
	
	__webpack_require__(5);
	
	__webpack_require__(6);
	
	__webpack_require__(7);
	
	__webpack_require__(8);
	
	__webpack_require__(9);
	
	__webpack_require__(10);
	
	__webpack_require__(11);
	
	__webpack_require__(12);
	
	__webpack_require__(13);
	
	__webpack_require__(14);
	
	__webpack_require__(15);
	
	__webpack_require__(16);
	
	__webpack_require__(18);
	
	__webpack_require__(19);
	
	__webpack_require__(20);
	
	__webpack_require__(21);
	
	__webpack_require__(22);
	
	__webpack_require__(23);
	
	__webpack_require__(24);
	
	__webpack_require__(25);
	
	__webpack_require__(26);
	
	__webpack_require__(27);
	
	__webpack_require__(28);
	
	__webpack_require__(29);
	
	__webpack_require__(30);
	
	__webpack_require__(31);
	
	__webpack_require__(32);
	
	__webpack_require__(33);
	
	__webpack_require__(34);
	
	__webpack_require__(35);
	
	__webpack_require__(36);
	
	__webpack_require__(37);
	
	__webpack_require__(38);
	
	__webpack_require__(39);
	
	__webpack_require__(40);
	
	__webpack_require__(41);
	
	__webpack_require__(42);
	
	__webpack_require__(43);
	
	__webpack_require__(44);
	
	__webpack_require__(45);
	
	__webpack_require__(46);
	
	__webpack_require__(47);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.3.7
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function Affix(element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options);
	
	    this.$target = $(this.options.target).on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this)).on('click.bs.affix.data-api', $.proxy(this.checkPositionWithEventLoop, this));
	
	    this.$element = $(element);
	    this.affixed = null;
	    this.unpin = null;
	    this.pinnedOffset = null;
	
	    this.checkPosition();
	  };
	
	  Affix.VERSION = '3.3.7';
	
	  Affix.RESET = 'affix affix-top affix-bottom';
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  };
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop = this.$target.scrollTop();
	    var position = this.$element.offset();
	    var targetHeight = this.$target.height();
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false;
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return scrollTop + this.unpin <= position.top ? false : 'bottom';
	      return scrollTop + targetHeight <= scrollHeight - offsetBottom ? false : 'bottom';
	    }
	
	    var initializing = this.affixed == null;
	    var colliderTop = initializing ? scrollTop : position.top;
	    var colliderHeight = initializing ? targetHeight : height;
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top';
	    if (offsetBottom != null && colliderTop + colliderHeight >= scrollHeight - offsetBottom) return 'bottom';
	
	    return false;
	  };
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset;
	    this.$element.removeClass(Affix.RESET).addClass('affix');
	    var scrollTop = this.$target.scrollTop();
	    var position = this.$element.offset();
	    return this.pinnedOffset = position.top - scrollTop;
	  };
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1);
	  };
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return;
	
	    var height = this.$element.height();
	    var offset = this.options.offset;
	    var offsetTop = offset.top;
	    var offsetBottom = offset.bottom;
	    var scrollHeight = Math.max($(document).height(), $(document.body).height());
	
	    if ((typeof offset === 'undefined' ? 'undefined' : _typeof(offset)) != 'object') offsetBottom = offsetTop = offset;
	    if (typeof offsetTop == 'function') offsetTop = offset.top(this.$element);
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element);
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom);
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '');
	
	      var affixType = 'affix' + (affix ? '-' + affix : '');
	      var e = $.Event(affixType + '.bs.affix');
	
	      this.$element.trigger(e);
	
	      if (e.isDefaultPrevented()) return;
	
	      this.affixed = affix;
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null;
	
	      this.$element.removeClass(Affix.RESET).addClass(affixType).trigger(affixType.replace('affix', 'affixed') + '.bs.affix');
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      });
	    }
	  };
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.affix');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.affix', data = new Affix(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.affix;
	
	  $.fn.affix = Plugin;
	  $.fn.affix.Constructor = Affix;
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old;
	    return this;
	  };
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this);
	      var data = $spy.data();
	
	      data.offset = data.offset || {};
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom;
	      if (data.offsetTop != null) data.offset.top = data.offsetTop;
	
	      Plugin.call($spy, data);
	    });
	  });
	}(jQuery);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.3.7
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]';
	  var Alert = function Alert(el) {
	    $(el).on('click', dismiss, this.close);
	  };
	
	  Alert.VERSION = '3.3.7';
	
	  Alert.TRANSITION_DURATION = 150;
	
	  Alert.prototype.close = function (e) {
	    var $this = $(this);
	    var selector = $this.attr('data-target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
	    }
	
	    var $parent = $(selector === '#' ? [] : selector);
	
	    if (e) e.preventDefault();
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert');
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'));
	
	    if (e.isDefaultPrevented()) return;
	
	    $parent.removeClass('in');
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove();
	    }
	
	    $.support.transition && $parent.hasClass('fade') ? $parent.one('bsTransitionEnd', removeElement).emulateTransitionEnd(Alert.TRANSITION_DURATION) : removeElement();
	  };
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.alert');
	
	      if (!data) $this.data('bs.alert', data = new Alert(this));
	      if (typeof option == 'string') data[option].call($this);
	    });
	  }
	
	  var old = $.fn.alert;
	
	  $.fn.alert = Plugin;
	  $.fn.alert.Constructor = Alert;
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old;
	    return this;
	  };
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close);
	}(jQuery);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* ========================================================================
	 * Bootstrap: button.js v3.3.7
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function Button(element, options) {
	    this.$element = $(element);
	    this.options = $.extend({}, Button.DEFAULTS, options);
	    this.isLoading = false;
	  };
	
	  Button.VERSION = '3.3.7';
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  };
	
	  Button.prototype.setState = function (state) {
	    var d = 'disabled';
	    var $el = this.$element;
	    var val = $el.is('input') ? 'val' : 'html';
	    var data = $el.data();
	
	    state += 'Text';
	
	    if (data.resetText == null) $el.data('resetText', $el[val]());
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state]);
	
	      if (state == 'loadingText') {
	        this.isLoading = true;
	        $el.addClass(d).attr(d, d).prop(d, true);
	      } else if (this.isLoading) {
	        this.isLoading = false;
	        $el.removeClass(d).removeAttr(d).prop(d, false);
	      }
	    }, this), 0);
	  };
	
	  Button.prototype.toggle = function () {
	    var changed = true;
	    var $parent = this.$element.closest('[data-toggle="buttons"]');
	
	    if ($parent.length) {
	      var $input = this.$element.find('input');
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false;
	        $parent.find('.active').removeClass('active');
	        this.$element.addClass('active');
	      } else if ($input.prop('type') == 'checkbox') {
	        if ($input.prop('checked') !== this.$element.hasClass('active')) changed = false;
	        this.$element.toggleClass('active');
	      }
	      $input.prop('checked', this.$element.hasClass('active'));
	      if (changed) $input.trigger('change');
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'));
	      this.$element.toggleClass('active');
	    }
	  };
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.button');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.button', data = new Button(this, options));
	
	      if (option == 'toggle') data.toggle();else if (option) data.setState(option);
	    });
	  }
	
	  var old = $.fn.button;
	
	  $.fn.button = Plugin;
	  $.fn.button.Constructor = Button;
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old;
	    return this;
	  };
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document).on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	    var $btn = $(e.target).closest('.btn');
	    Plugin.call($btn, 'toggle');
	    if (!$(e.target).is('input[type="radio"], input[type="checkbox"]')) {
	      // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	      e.preventDefault();
	      // The target component still receive the focus
	      if ($btn.is('input,button')) $btn.trigger('focus');else $btn.find('input:visible,button:visible').first().trigger('focus');
	    }
	  }).on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	    $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type));
	  });
	}(jQuery);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.7
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function Carousel(element, options) {
	    this.$element = $(element);
	    this.$indicators = this.$element.find('.carousel-indicators');
	    this.options = options;
	    this.paused = null;
	    this.sliding = null;
	    this.interval = null;
	    this.$active = null;
	    this.$items = null;
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this));
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element.on('mouseenter.bs.carousel', $.proxy(this.pause, this)).on('mouseleave.bs.carousel', $.proxy(this.cycle, this));
	  };
	
	  Carousel.VERSION = '3.3.7';
	
	  Carousel.TRANSITION_DURATION = 600;
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  };
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return;
	    switch (e.which) {
	      case 37:
	        this.prev();break;
	      case 39:
	        this.next();break;
	      default:
	        return;
	    }
	
	    e.preventDefault();
	  };
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false);
	
	    this.interval && clearInterval(this.interval);
	
	    this.options.interval && !this.paused && (this.interval = setInterval($.proxy(this.next, this), this.options.interval));
	
	    return this;
	  };
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item');
	    return this.$items.index(item || this.$active);
	  };
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active);
	    var willWrap = direction == 'prev' && activeIndex === 0 || direction == 'next' && activeIndex == this.$items.length - 1;
	    if (willWrap && !this.options.wrap) return active;
	    var delta = direction == 'prev' ? -1 : 1;
	    var itemIndex = (activeIndex + delta) % this.$items.length;
	    return this.$items.eq(itemIndex);
	  };
	
	  Carousel.prototype.to = function (pos) {
	    var that = this;
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'));
	
	    if (pos > this.$items.length - 1 || pos < 0) return;
	
	    if (this.sliding) return this.$element.one('slid.bs.carousel', function () {
	      that.to(pos);
	    }); // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle();
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos));
	  };
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true);
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end);
	      this.cycle(true);
	    }
	
	    this.interval = clearInterval(this.interval);
	
	    return this;
	  };
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return;
	    return this.slide('next');
	  };
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return;
	    return this.slide('prev');
	  };
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active = this.$element.find('.item.active');
	    var $next = next || this.getItemForDirection(type, $active);
	    var isCycling = this.interval;
	    var direction = type == 'next' ? 'left' : 'right';
	    var that = this;
	
	    if ($next.hasClass('active')) return this.sliding = false;
	
	    var relatedTarget = $next[0];
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    });
	    this.$element.trigger(slideEvent);
	    if (slideEvent.isDefaultPrevented()) return;
	
	    this.sliding = true;
	
	    isCycling && this.pause();
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active');
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)]);
	      $nextIndicator && $nextIndicator.addClass('active');
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }); // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type);
	      $next[0].offsetWidth; // force reflow
	      $active.addClass(direction);
	      $next.addClass(direction);
	      $active.one('bsTransitionEnd', function () {
	        $next.removeClass([type, direction].join(' ')).addClass('active');
	        $active.removeClass(['active', direction].join(' '));
	        that.sliding = false;
	        setTimeout(function () {
	          that.$element.trigger(slidEvent);
	        }, 0);
	      }).emulateTransitionEnd(Carousel.TRANSITION_DURATION);
	    } else {
	      $active.removeClass('active');
	      $next.addClass('active');
	      this.sliding = false;
	      this.$element.trigger(slidEvent);
	    }
	
	    isCycling && this.cycle();
	
	    return this;
	  };
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.carousel');
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);
	      var action = typeof option == 'string' ? option : options.slide;
	
	      if (!data) $this.data('bs.carousel', data = new Carousel(this, options));
	      if (typeof option == 'number') data.to(option);else if (action) data[action]();else if (options.interval) data.pause().cycle();
	    });
	  }
	
	  var old = $.fn.carousel;
	
	  $.fn.carousel = Plugin;
	  $.fn.carousel.Constructor = Carousel;
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old;
	    return this;
	  };
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function clickHandler(e) {
	    var href;
	    var $this = $(this);
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')); // strip for ie7
	    if (!$target.hasClass('carousel')) return;
	    var options = $.extend({}, $target.data(), $this.data());
	    var slideIndex = $this.attr('data-slide-to');
	    if (slideIndex) options.interval = false;
	
	    Plugin.call($target, options);
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex);
	    }
	
	    e.preventDefault();
	  };
	
	  $(document).on('click.bs.carousel.data-api', '[data-slide]', clickHandler).on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler);
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this);
	      Plugin.call($carousel, $carousel.data());
	    });
	  });
	}(jQuery);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.3.7
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function Collapse(element, options) {
	    this.$element = $(element);
	    this.options = $.extend({}, Collapse.DEFAULTS, options);
	    this.$trigger = $('[data-toggle="collapse"][href="#' + element.id + '"],' + '[data-toggle="collapse"][data-target="#' + element.id + '"]');
	    this.transitioning = null;
	
	    if (this.options.parent) {
	      this.$parent = this.getParent();
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger);
	    }
	
	    if (this.options.toggle) this.toggle();
	  };
	
	  Collapse.VERSION = '3.3.7';
	
	  Collapse.TRANSITION_DURATION = 350;
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  };
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width');
	    return hasWidth ? 'width' : 'height';
	  };
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return;
	
	    var activesData;
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing');
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse');
	      if (activesData && activesData.transitioning) return;
	    }
	
	    var startEvent = $.Event('show.bs.collapse');
	    this.$element.trigger(startEvent);
	    if (startEvent.isDefaultPrevented()) return;
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide');
	      activesData || actives.data('bs.collapse', null);
	    }
	
	    var dimension = this.dimension();
	
	    this.$element.removeClass('collapse').addClass('collapsing')[dimension](0).attr('aria-expanded', true);
	
	    this.$trigger.removeClass('collapsed').attr('aria-expanded', true);
	
	    this.transitioning = 1;
	
	    var complete = function complete() {
	      this.$element.removeClass('collapsing').addClass('collapse in')[dimension]('');
	      this.transitioning = 0;
	      this.$element.trigger('shown.bs.collapse');
	    };
	
	    if (!$.support.transition) return complete.call(this);
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'));
	
	    this.$element.one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize]);
	  };
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return;
	
	    var startEvent = $.Event('hide.bs.collapse');
	    this.$element.trigger(startEvent);
	    if (startEvent.isDefaultPrevented()) return;
	
	    var dimension = this.dimension();
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight;
	
	    this.$element.addClass('collapsing').removeClass('collapse in').attr('aria-expanded', false);
	
	    this.$trigger.addClass('collapsed').attr('aria-expanded', false);
	
	    this.transitioning = 1;
	
	    var complete = function complete() {
	      this.transitioning = 0;
	      this.$element.removeClass('collapsing').addClass('collapse').trigger('hidden.bs.collapse');
	    };
	
	    if (!$.support.transition) return complete.call(this);
	
	    this.$element[dimension](0).one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION);
	  };
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']();
	  };
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each($.proxy(function (i, element) {
	      var $element = $(element);
	      this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element);
	    }, this)).end();
	  };
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in');
	
	    $element.attr('aria-expanded', isOpen);
	    $trigger.toggleClass('collapsed', !isOpen).attr('aria-expanded', isOpen);
	  };
	
	  function getTargetFromTrigger($trigger) {
	    var href;
	    var target = $trigger.attr('data-target') || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, ''); // strip for ie7
	
	    return $(target);
	  }
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.collapse');
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false;
	      if (!data) $this.data('bs.collapse', data = new Collapse(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.collapse;
	
	  $.fn.collapse = Plugin;
	  $.fn.collapse.Constructor = Collapse;
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old;
	    return this;
	  };
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this = $(this);
	
	    if (!$this.attr('data-target')) e.preventDefault();
	
	    var $target = getTargetFromTrigger($this);
	    var data = $target.data('bs.collapse');
	    var option = data ? 'toggle' : $this.data();
	
	    Plugin.call($target, option);
	  });
	}(jQuery);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.7
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop';
	  var toggle = '[data-toggle="dropdown"]';
	  var Dropdown = function Dropdown(element) {
	    $(element).on('click.bs.dropdown', this.toggle);
	  };
	
	  Dropdown.VERSION = '3.3.7';
	
	  function getParent($this) {
	    var selector = $this.attr('data-target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
	    }
	
	    var $parent = selector && $(selector);
	
	    return $parent && $parent.length ? $parent : $this.parent();
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return;
	    $(backdrop).remove();
	    $(toggle).each(function () {
	      var $this = $(this);
	      var $parent = getParent($this);
	      var relatedTarget = { relatedTarget: this };
	
	      if (!$parent.hasClass('open')) return;
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return;
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget));
	
	      if (e.isDefaultPrevented()) return;
	
	      $this.attr('aria-expanded', 'false');
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget));
	    });
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this);
	
	    if ($this.is('.disabled, :disabled')) return;
	
	    var $parent = getParent($this);
	    var isActive = $parent.hasClass('open');
	
	    clearMenus();
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div')).addClass('dropdown-backdrop').insertAfter($(this)).on('click', clearMenus);
	      }
	
	      var relatedTarget = { relatedTarget: this };
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget));
	
	      if (e.isDefaultPrevented()) return;
	
	      $this.trigger('focus').attr('aria-expanded', 'true');
	
	      $parent.toggleClass('open').trigger($.Event('shown.bs.dropdown', relatedTarget));
	    }
	
	    return false;
	  };
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return;
	
	    var $this = $(this);
	
	    e.preventDefault();
	    e.stopPropagation();
	
	    if ($this.is('.disabled, :disabled')) return;
	
	    var $parent = getParent($this);
	    var isActive = $parent.hasClass('open');
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus');
	      return $this.trigger('click');
	    }
	
	    var desc = ' li:not(.disabled):visible a';
	    var $items = $parent.find('.dropdown-menu' + desc);
	
	    if (!$items.length) return;
	
	    var index = $items.index(e.target);
	
	    if (e.which == 38 && index > 0) index--; // up
	    if (e.which == 40 && index < $items.length - 1) index++; // down
	    if (!~index) index = 0;
	
	    $items.eq(index).trigger('focus');
	  };
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.dropdown');
	
	      if (!data) $this.data('bs.dropdown', data = new Dropdown(this));
	      if (typeof option == 'string') data[option].call($this);
	    });
	  }
	
	  var old = $.fn.dropdown;
	
	  $.fn.dropdown = Plugin;
	  $.fn.dropdown.Constructor = Dropdown;
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old;
	    return this;
	  };
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document).on('click.bs.dropdown.data-api', clearMenus).on('click.bs.dropdown.data-api', '.dropdown form', function (e) {
	    e.stopPropagation();
	  }).on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle).on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown).on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown);
	}(jQuery);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.3.7
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function Modal(element, options) {
	    this.options = options;
	    this.$body = $(document.body);
	    this.$element = $(element);
	    this.$dialog = this.$element.find('.modal-dialog');
	    this.$backdrop = null;
	    this.isShown = null;
	    this.originalBodyPad = null;
	    this.scrollbarWidth = 0;
	    this.ignoreBackdropClick = false;
	
	    if (this.options.remote) {
	      this.$element.find('.modal-content').load(this.options.remote, $.proxy(function () {
	        this.$element.trigger('loaded.bs.modal');
	      }, this));
	    }
	  };
	
	  Modal.VERSION = '3.3.7';
	
	  Modal.TRANSITION_DURATION = 300;
	  Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  };
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget);
	  };
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this;
	    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget });
	
	    this.$element.trigger(e);
	
	    if (this.isShown || e.isDefaultPrevented()) return;
	
	    this.isShown = true;
	
	    this.checkScrollbar();
	    this.setScrollbar();
	    this.$body.addClass('modal-open');
	
	    this.escape();
	    this.resize();
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this));
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true;
	      });
	    });
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade');
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body); // don't move modals dom position
	      }
	
	      that.$element.show().scrollTop(0);
	
	      that.adjustDialog();
	
	      if (transition) {
	        that.$element[0].offsetWidth; // force reflow
	      }
	
	      that.$element.addClass('in');
	
	      that.enforceFocus();
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget });
	
	      transition ? that.$dialog // wait for modal to slide in
	      .one('bsTransitionEnd', function () {
	        that.$element.trigger('focus').trigger(e);
	      }).emulateTransitionEnd(Modal.TRANSITION_DURATION) : that.$element.trigger('focus').trigger(e);
	    });
	  };
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault();
	
	    e = $.Event('hide.bs.modal');
	
	    this.$element.trigger(e);
	
	    if (!this.isShown || e.isDefaultPrevented()) return;
	
	    this.isShown = false;
	
	    this.escape();
	    this.resize();
	
	    $(document).off('focusin.bs.modal');
	
	    this.$element.removeClass('in').off('click.dismiss.bs.modal').off('mouseup.dismiss.bs.modal');
	
	    this.$dialog.off('mousedown.dismiss.bs.modal');
	
	    $.support.transition && this.$element.hasClass('fade') ? this.$element.one('bsTransitionEnd', $.proxy(this.hideModal, this)).emulateTransitionEnd(Modal.TRANSITION_DURATION) : this.hideModal();
	  };
	
	  Modal.prototype.enforceFocus = function () {
	    $(document).off('focusin.bs.modal') // guard against infinite focus loop
	    .on('focusin.bs.modal', $.proxy(function (e) {
	      if (document !== e.target && this.$element[0] !== e.target && !this.$element.has(e.target).length) {
	        this.$element.trigger('focus');
	      }
	    }, this));
	  };
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide();
	      }, this));
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal');
	    }
	  };
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this));
	    } else {
	      $(window).off('resize.bs.modal');
	    }
	  };
	
	  Modal.prototype.hideModal = function () {
	    var that = this;
	    this.$element.hide();
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open');
	      that.resetAdjustments();
	      that.resetScrollbar();
	      that.$element.trigger('hidden.bs.modal');
	    });
	  };
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove();
	    this.$backdrop = null;
	  };
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this;
	    var animate = this.$element.hasClass('fade') ? 'fade' : '';
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate;
	
	      this.$backdrop = $(document.createElement('div')).addClass('modal-backdrop ' + animate).appendTo(this.$body);
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false;
	          return;
	        }
	        if (e.target !== e.currentTarget) return;
	        this.options.backdrop == 'static' ? this.$element[0].focus() : this.hide();
	      }, this));
	
	      if (doAnimate) this.$backdrop[0].offsetWidth; // force reflow
	
	      this.$backdrop.addClass('in');
	
	      if (!callback) return;
	
	      doAnimate ? this.$backdrop.one('bsTransitionEnd', callback).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callback();
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in');
	
	      var callbackRemove = function callbackRemove() {
	        that.removeBackdrop();
	        callback && callback();
	      };
	      $.support.transition && this.$element.hasClass('fade') ? this.$backdrop.one('bsTransitionEnd', callbackRemove).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callbackRemove();
	    } else if (callback) {
	      callback();
	    }
	  };
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog();
	  };
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight;
	
	    this.$element.css({
	      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    });
	  };
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    });
	  };
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth;
	    if (!fullWindowWidth) {
	      // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect();
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
	    this.scrollbarWidth = this.measureScrollbar();
	  };
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt(this.$body.css('padding-right') || 0, 10);
	    this.originalBodyPad = document.body.style.paddingRight || '';
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth);
	  };
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad);
	  };
	
	  Modal.prototype.measureScrollbar = function () {
	    // thx walsh
	    var scrollDiv = document.createElement('div');
	    scrollDiv.className = 'modal-scrollbar-measure';
	    this.$body.append(scrollDiv);
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	    this.$body[0].removeChild(scrollDiv);
	    return scrollbarWidth;
	  };
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.modal');
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);
	
	      if (!data) $this.data('bs.modal', data = new Modal(this, options));
	      if (typeof option == 'string') data[option](_relatedTarget);else if (options.show) data.show(_relatedTarget);
	    });
	  }
	
	  var old = $.fn.modal;
	
	  $.fn.modal = Plugin;
	  $.fn.modal.Constructor = Modal;
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old;
	    return this;
	  };
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this = $(this);
	    var href = $this.attr('href');
	    var $target = $($this.attr('data-target') || href && href.replace(/.*(?=#[^\s]+$)/, '')); // strip for ie7
	    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());
	
	    if ($this.is('a')) e.preventDefault();
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return; // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus');
	      });
	    });
	    Plugin.call($target, option, this);
	  });
	}(jQuery);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.7
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body = $(document.body);
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element);
	    this.options = $.extend({}, ScrollSpy.DEFAULTS, options);
	    this.selector = (this.options.target || '') + ' .nav li > a';
	    this.offsets = [];
	    this.targets = [];
	    this.activeTarget = null;
	    this.scrollHeight = 0;
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this));
	    this.refresh();
	    this.process();
	  }
	
	  ScrollSpy.VERSION = '3.3.7';
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  };
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
	  };
	
	  ScrollSpy.prototype.refresh = function () {
	    var that = this;
	    var offsetMethod = 'offset';
	    var offsetBase = 0;
	
	    this.offsets = [];
	    this.targets = [];
	    this.scrollHeight = this.getScrollHeight();
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position';
	      offsetBase = this.$scrollElement.scrollTop();
	    }
	
	    this.$body.find(this.selector).map(function () {
	      var $el = $(this);
	      var href = $el.data('target') || $el.attr('href');
	      var $href = /^#./.test(href) && $(href);
	
	      return $href && $href.length && $href.is(':visible') && [[$href[offsetMethod]().top + offsetBase, href]] || null;
	    }).sort(function (a, b) {
	      return a[0] - b[0];
	    }).each(function () {
	      that.offsets.push(this[0]);
	      that.targets.push(this[1]);
	    });
	  };
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop = this.$scrollElement.scrollTop() + this.options.offset;
	    var scrollHeight = this.getScrollHeight();
	    var maxScroll = this.options.offset + scrollHeight - this.$scrollElement.height();
	    var offsets = this.offsets;
	    var targets = this.targets;
	    var activeTarget = this.activeTarget;
	    var i;
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh();
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i);
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null;
	      return this.clear();
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i] && scrollTop >= offsets[i] && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1]) && this.activate(targets[i]);
	    }
	  };
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target;
	
	    this.clear();
	
	    var selector = this.selector + '[data-target="' + target + '"],' + this.selector + '[href="' + target + '"]';
	
	    var active = $(selector).parents('li').addClass('active');
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active.closest('li.dropdown').addClass('active');
	    }
	
	    active.trigger('activate.bs.scrollspy');
	  };
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector).parentsUntil(this.options.target, '.active').removeClass('active');
	  };
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.scrollspy');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.scrollspy', data = new ScrollSpy(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.scrollspy;
	
	  $.fn.scrollspy = Plugin;
	  $.fn.scrollspy.Constructor = ScrollSpy;
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old;
	    return this;
	  };
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this);
	      Plugin.call($spy, $spy.data());
	    });
	  });
	}(jQuery);

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.3.7
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function Tab(element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element);
	    // jscs:enable requireDollarBeforejQueryAssignment
	  };
	
	  Tab.VERSION = '3.3.7';
	
	  Tab.TRANSITION_DURATION = 150;
	
	  Tab.prototype.show = function () {
	    var $this = this.element;
	    var $ul = $this.closest('ul:not(.dropdown-menu)');
	    var selector = $this.data('target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return;
	
	    var $previous = $ul.find('.active:last a');
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    });
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    });
	
	    $previous.trigger(hideEvent);
	    $this.trigger(showEvent);
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return;
	
	    var $target = $(selector);
	
	    this.activate($this.closest('li'), $ul);
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      });
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      });
	    });
	  };
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active = container.find('> .active');
	    var transition = callback && $.support.transition && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length);
	
	    function next() {
	      $active.removeClass('active').find('> .dropdown-menu > .active').removeClass('active').end().find('[data-toggle="tab"]').attr('aria-expanded', false);
	
	      element.addClass('active').find('[data-toggle="tab"]').attr('aria-expanded', true);
	
	      if (transition) {
	        element[0].offsetWidth; // reflow for transition
	        element.addClass('in');
	      } else {
	        element.removeClass('fade');
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element.closest('li.dropdown').addClass('active').end().find('[data-toggle="tab"]').attr('aria-expanded', true);
	      }
	
	      callback && callback();
	    }
	
	    $active.length && transition ? $active.one('bsTransitionEnd', next).emulateTransitionEnd(Tab.TRANSITION_DURATION) : next();
	
	    $active.removeClass('in');
	  };
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.tab');
	
	      if (!data) $this.data('bs.tab', data = new Tab(this));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.tab;
	
	  $.fn.tab = Plugin;
	  $.fn.tab.Constructor = Tab;
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old;
	    return this;
	  };
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function clickHandler(e) {
	    e.preventDefault();
	    Plugin.call($(this), 'show');
	  };
	
	  $(document).on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler).on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler);
	}(jQuery);

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.3.7
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap');
	
	    var transEndEventNames = {
	      WebkitTransition: 'webkitTransitionEnd',
	      MozTransition: 'transitionend',
	      OTransition: 'oTransitionEnd otransitionend',
	      transition: 'transitionend'
	    };
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] };
	      }
	    }
	
	    return false; // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false;
	    var $el = this;
	    $(this).one('bsTransitionEnd', function () {
	      called = true;
	    });
	    var callback = function callback() {
	      if (!called) $($el).trigger($.support.transition.end);
	    };
	    setTimeout(callback, duration);
	    return this;
	  };
	
	  $(function () {
	    $.support.transition = transitionEnd();
	
	    if (!$.support.transition) return;
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function handle(e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
	      }
	    };
	  });
	}(jQuery);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Swiper 3.4.2
	 * Most modern mobile touch slider and framework with hardware accelerated transitions
	 * 
	 * http://www.idangero.us/swiper/
	 * 
	 * Copyright 2017, Vladimir Kharlampidi
	 * The iDangero.us
	 * http://www.idangero.us/
	 * 
	 * Licensed under MIT
	 * 
	 * Released on: March 10, 2017
	 */
	!function () {
	  "use strict";
	  var e,
	      a = function a(t, s) {
	    function r(e) {
	      return Math.floor(e);
	    }function i() {
	      var e = x.params.autoplay,
	          a = x.slides.eq(x.activeIndex);a.attr("data-swiper-autoplay") && (e = a.attr("data-swiper-autoplay") || x.params.autoplay), x.autoplayTimeoutId = setTimeout(function () {
	        x.params.loop ? (x.fixLoop(), x._slideNext(), x.emit("onAutoplay", x)) : x.isEnd ? s.autoplayStopOnLast ? x.stopAutoplay() : (x._slideTo(0), x.emit("onAutoplay", x)) : (x._slideNext(), x.emit("onAutoplay", x));
	      }, e);
	    }function n(a, t) {
	      var s = e(a.target);if (!s.is(t)) if ("string" == typeof t) s = s.parents(t);else if (t.nodeType) {
	        var r;return s.parents().each(function (e, a) {
	          a === t && (r = t);
	        }), r ? t : void 0;
	      }if (0 !== s.length) return s[0];
	    }function o(e, a) {
	      a = a || {};var t = window.MutationObserver || window.WebkitMutationObserver,
	          s = new t(function (e) {
	        e.forEach(function (e) {
	          x.onResize(!0), x.emit("onObserverUpdate", x, e);
	        });
	      });s.observe(e, { attributes: void 0 === a.attributes || a.attributes, childList: void 0 === a.childList || a.childList, characterData: void 0 === a.characterData || a.characterData }), x.observers.push(s);
	    }function l(e) {
	      e.originalEvent && (e = e.originalEvent);var a = e.keyCode || e.charCode;if (!x.params.allowSwipeToNext && (x.isHorizontal() && 39 === a || !x.isHorizontal() && 40 === a)) return !1;if (!x.params.allowSwipeToPrev && (x.isHorizontal() && 37 === a || !x.isHorizontal() && 38 === a)) return !1;if (!(e.shiftKey || e.altKey || e.ctrlKey || e.metaKey || document.activeElement && document.activeElement.nodeName && ("input" === document.activeElement.nodeName.toLowerCase() || "textarea" === document.activeElement.nodeName.toLowerCase()))) {
	        if (37 === a || 39 === a || 38 === a || 40 === a) {
	          var t = !1;if (x.container.parents("." + x.params.slideClass).length > 0 && 0 === x.container.parents("." + x.params.slideActiveClass).length) return;var s = { left: window.pageXOffset, top: window.pageYOffset },
	              r = window.innerWidth,
	              i = window.innerHeight,
	              n = x.container.offset();x.rtl && (n.left = n.left - x.container[0].scrollLeft);for (var o = [[n.left, n.top], [n.left + x.width, n.top], [n.left, n.top + x.height], [n.left + x.width, n.top + x.height]], l = 0; l < o.length; l++) {
	            var p = o[l];p[0] >= s.left && p[0] <= s.left + r && p[1] >= s.top && p[1] <= s.top + i && (t = !0);
	          }if (!t) return;
	        }x.isHorizontal() ? (37 !== a && 39 !== a || (e.preventDefault ? e.preventDefault() : e.returnValue = !1), (39 === a && !x.rtl || 37 === a && x.rtl) && x.slideNext(), (37 === a && !x.rtl || 39 === a && x.rtl) && x.slidePrev()) : (38 !== a && 40 !== a || (e.preventDefault ? e.preventDefault() : e.returnValue = !1), 40 === a && x.slideNext(), 38 === a && x.slidePrev()), x.emit("onKeyPress", x, a);
	      }
	    }function p(e) {
	      var a = 0,
	          t = 0,
	          s = 0,
	          r = 0;return "detail" in e && (t = e.detail), "wheelDelta" in e && (t = -e.wheelDelta / 120), "wheelDeltaY" in e && (t = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (a = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (a = t, t = 0), s = 10 * a, r = 10 * t, "deltaY" in e && (r = e.deltaY), "deltaX" in e && (s = e.deltaX), (s || r) && e.deltaMode && (1 === e.deltaMode ? (s *= 40, r *= 40) : (s *= 800, r *= 800)), s && !a && (a = s < 1 ? -1 : 1), r && !t && (t = r < 1 ? -1 : 1), { spinX: a, spinY: t, pixelX: s, pixelY: r };
	    }function d(e) {
	      e.originalEvent && (e = e.originalEvent);var a = 0,
	          t = x.rtl ? -1 : 1,
	          s = p(e);if (x.params.mousewheelForceToAxis) {
	        if (x.isHorizontal()) {
	          if (!(Math.abs(s.pixelX) > Math.abs(s.pixelY))) return;a = s.pixelX * t;
	        } else {
	          if (!(Math.abs(s.pixelY) > Math.abs(s.pixelX))) return;a = s.pixelY;
	        }
	      } else a = Math.abs(s.pixelX) > Math.abs(s.pixelY) ? -s.pixelX * t : -s.pixelY;if (0 !== a) {
	        if (x.params.mousewheelInvert && (a = -a), x.params.freeMode) {
	          var r = x.getWrapperTranslate() + a * x.params.mousewheelSensitivity,
	              i = x.isBeginning,
	              n = x.isEnd;if (r >= x.minTranslate() && (r = x.minTranslate()), r <= x.maxTranslate() && (r = x.maxTranslate()), x.setWrapperTransition(0), x.setWrapperTranslate(r), x.updateProgress(), x.updateActiveIndex(), (!i && x.isBeginning || !n && x.isEnd) && x.updateClasses(), x.params.freeModeSticky ? (clearTimeout(x.mousewheel.timeout), x.mousewheel.timeout = setTimeout(function () {
	            x.slideReset();
	          }, 300)) : x.params.lazyLoading && x.lazy && x.lazy.load(), x.emit("onScroll", x, e), x.params.autoplay && x.params.autoplayDisableOnInteraction && x.stopAutoplay(), 0 === r || r === x.maxTranslate()) return;
	        } else {
	          if (new window.Date().getTime() - x.mousewheel.lastScrollTime > 60) if (a < 0) {
	            if (x.isEnd && !x.params.loop || x.animating) {
	              if (x.params.mousewheelReleaseOnEdges) return !0;
	            } else x.slideNext(), x.emit("onScroll", x, e);
	          } else if (x.isBeginning && !x.params.loop || x.animating) {
	            if (x.params.mousewheelReleaseOnEdges) return !0;
	          } else x.slidePrev(), x.emit("onScroll", x, e);x.mousewheel.lastScrollTime = new window.Date().getTime();
	        }return e.preventDefault ? e.preventDefault() : e.returnValue = !1, !1;
	      }
	    }function m(a, t) {
	      a = e(a);var s,
	          r,
	          i,
	          n = x.rtl ? -1 : 1;s = a.attr("data-swiper-parallax") || "0", r = a.attr("data-swiper-parallax-x"), i = a.attr("data-swiper-parallax-y"), r || i ? (r = r || "0", i = i || "0") : x.isHorizontal() ? (r = s, i = "0") : (i = s, r = "0"), r = r.indexOf("%") >= 0 ? parseInt(r, 10) * t * n + "%" : r * t * n + "px", i = i.indexOf("%") >= 0 ? parseInt(i, 10) * t + "%" : i * t + "px", a.transform("translate3d(" + r + ", " + i + ",0px)");
	    }function u(e) {
	      return 0 !== e.indexOf("on") && (e = e[0] !== e[0].toUpperCase() ? "on" + e[0].toUpperCase() + e.substring(1) : "on" + e), e;
	    }if (!(this instanceof a)) return new a(t, s);var c = { direction: "horizontal", touchEventsTarget: "container", initialSlide: 0, speed: 300, autoplay: !1, autoplayDisableOnInteraction: !0, autoplayStopOnLast: !1, iOSEdgeSwipeDetection: !1, iOSEdgeSwipeThreshold: 20, freeMode: !1, freeModeMomentum: !0, freeModeMomentumRatio: 1, freeModeMomentumBounce: !0, freeModeMomentumBounceRatio: 1, freeModeMomentumVelocityRatio: 1, freeModeSticky: !1, freeModeMinimumVelocity: .02, autoHeight: !1, setWrapperSize: !1, virtualTranslate: !1, effect: "slide", coverflow: { rotate: 50, stretch: 0, depth: 100, modifier: 1, slideShadows: !0 }, flip: { slideShadows: !0, limitRotation: !0 }, cube: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: .94 }, fade: { crossFade: !1 }, parallax: !1, zoom: !1, zoomMax: 3, zoomMin: 1, zoomToggle: !0, scrollbar: null, scrollbarHide: !0, scrollbarDraggable: !1, scrollbarSnapOnRelease: !1, keyboardControl: !1, mousewheelControl: !1, mousewheelReleaseOnEdges: !1, mousewheelInvert: !1, mousewheelForceToAxis: !1, mousewheelSensitivity: 1, mousewheelEventsTarged: "container", hashnav: !1, hashnavWatchState: !1, history: !1, replaceState: !1, breakpoints: void 0, spaceBetween: 0, slidesPerView: 1, slidesPerColumn: 1, slidesPerColumnFill: "column", slidesPerGroup: 1, centeredSlides: !1, slidesOffsetBefore: 0, slidesOffsetAfter: 0, roundLengths: !1, touchRatio: 1, touchAngle: 45, simulateTouch: !0, shortSwipes: !0, longSwipes: !0, longSwipesRatio: .5, longSwipesMs: 300, followFinger: !0, onlyExternal: !1, threshold: 0, touchMoveStopPropagation: !0, touchReleaseOnEdges: !1, uniqueNavElements: !0, pagination: null, paginationElement: "span", paginationClickable: !1, paginationHide: !1, paginationBulletRender: null, paginationProgressRender: null, paginationFractionRender: null, paginationCustomRender: null, paginationType: "bullets", resistance: !0, resistanceRatio: .85, nextButton: null, prevButton: null, watchSlidesProgress: !1, watchSlidesVisibility: !1, grabCursor: !1, preventClicks: !0, preventClicksPropagation: !0, slideToClickedSlide: !1, lazyLoading: !1, lazyLoadingInPrevNext: !1, lazyLoadingInPrevNextAmount: 1, lazyLoadingOnTransitionStart: !1, preloadImages: !0, updateOnImagesReady: !0, loop: !1, loopAdditionalSlides: 0, loopedSlides: null, control: void 0, controlInverse: !1, controlBy: "slide", normalizeSlideIndex: !0, allowSwipeToPrev: !0, allowSwipeToNext: !0, swipeHandler: null, noSwiping: !0, noSwipingClass: "swiper-no-swiping", passiveListeners: !0, containerModifierClass: "swiper-container-", slideClass: "swiper-slide", slideActiveClass: "swiper-slide-active", slideDuplicateActiveClass: "swiper-slide-duplicate-active", slideVisibleClass: "swiper-slide-visible", slideDuplicateClass: "swiper-slide-duplicate", slideNextClass: "swiper-slide-next", slideDuplicateNextClass: "swiper-slide-duplicate-next", slidePrevClass: "swiper-slide-prev", slideDuplicatePrevClass: "swiper-slide-duplicate-prev", wrapperClass: "swiper-wrapper", bulletClass: "swiper-pagination-bullet", bulletActiveClass: "swiper-pagination-bullet-active", buttonDisabledClass: "swiper-button-disabled", paginationCurrentClass: "swiper-pagination-current", paginationTotalClass: "swiper-pagination-total", paginationHiddenClass: "swiper-pagination-hidden", paginationProgressbarClass: "swiper-pagination-progressbar", paginationClickableClass: "swiper-pagination-clickable", paginationModifierClass: "swiper-pagination-", lazyLoadingClass: "swiper-lazy", lazyStatusLoadingClass: "swiper-lazy-loading", lazyStatusLoadedClass: "swiper-lazy-loaded", lazyPreloaderClass: "swiper-lazy-preloader", notificationClass: "swiper-notification", preloaderClass: "preloader", zoomContainerClass: "swiper-zoom-container", observer: !1, observeParents: !1, a11y: !1, prevSlideMessage: "Previous slide", nextSlideMessage: "Next slide", firstSlideMessage: "This is the first slide", lastSlideMessage: "This is the last slide", paginationBulletMessage: "Go to slide {{index}}", runCallbacksOnInit: !0 },
	        g = s && s.virtualTranslate;s = s || {};var h = {};for (var v in s) {
	      if ("object" != _typeof(s[v]) || null === s[v] || s[v].nodeType || s[v] === window || s[v] === document || "undefined" != typeof Dom7 && s[v] instanceof Dom7 || "undefined" != typeof jQuery && s[v] instanceof jQuery) h[v] = s[v];else {
	        h[v] = {};for (var f in s[v]) {
	          h[v][f] = s[v][f];
	        }
	      }
	    }for (var w in c) {
	      if (void 0 === s[w]) s[w] = c[w];else if ("object" == _typeof(s[w])) for (var y in c[w]) {
	        void 0 === s[w][y] && (s[w][y] = c[w][y]);
	      }
	    }var x = this;if (x.params = s, x.originalParams = h, x.classNames = [], void 0 !== e && "undefined" != typeof Dom7 && (e = Dom7), (void 0 !== e || (e = "undefined" == typeof Dom7 ? window.Dom7 || window.Zepto || window.jQuery : Dom7)) && (x.$ = e, x.currentBreakpoint = void 0, x.getActiveBreakpoint = function () {
	      if (!x.params.breakpoints) return !1;var e,
	          a = !1,
	          t = [];for (e in x.params.breakpoints) {
	        x.params.breakpoints.hasOwnProperty(e) && t.push(e);
	      }t.sort(function (e, a) {
	        return parseInt(e, 10) > parseInt(a, 10);
	      });for (var s = 0; s < t.length; s++) {
	        (e = t[s]) >= window.innerWidth && !a && (a = e);
	      }return a || "max";
	    }, x.setBreakpoint = function () {
	      var e = x.getActiveBreakpoint();if (e && x.currentBreakpoint !== e) {
	        var a = e in x.params.breakpoints ? x.params.breakpoints[e] : x.originalParams,
	            t = x.params.loop && a.slidesPerView !== x.params.slidesPerView;for (var s in a) {
	          x.params[s] = a[s];
	        }x.currentBreakpoint = e, t && x.destroyLoop && x.reLoop(!0);
	      }
	    }, x.params.breakpoints && x.setBreakpoint(), x.container = e(t), 0 !== x.container.length)) {
	      if (x.container.length > 1) {
	        var T = [];return x.container.each(function () {
	          T.push(new a(this, s));
	        }), T;
	      }x.container[0].swiper = x, x.container.data("swiper", x), x.classNames.push(x.params.containerModifierClass + x.params.direction), x.params.freeMode && x.classNames.push(x.params.containerModifierClass + "free-mode"), x.support.flexbox || (x.classNames.push(x.params.containerModifierClass + "no-flexbox"), x.params.slidesPerColumn = 1), x.params.autoHeight && x.classNames.push(x.params.containerModifierClass + "autoheight"), (x.params.parallax || x.params.watchSlidesVisibility) && (x.params.watchSlidesProgress = !0), x.params.touchReleaseOnEdges && (x.params.resistanceRatio = 0), ["cube", "coverflow", "flip"].indexOf(x.params.effect) >= 0 && (x.support.transforms3d ? (x.params.watchSlidesProgress = !0, x.classNames.push(x.params.containerModifierClass + "3d")) : x.params.effect = "slide"), "slide" !== x.params.effect && x.classNames.push(x.params.containerModifierClass + x.params.effect), "cube" === x.params.effect && (x.params.resistanceRatio = 0, x.params.slidesPerView = 1, x.params.slidesPerColumn = 1, x.params.slidesPerGroup = 1, x.params.centeredSlides = !1, x.params.spaceBetween = 0, x.params.virtualTranslate = !0), "fade" !== x.params.effect && "flip" !== x.params.effect || (x.params.slidesPerView = 1, x.params.slidesPerColumn = 1, x.params.slidesPerGroup = 1, x.params.watchSlidesProgress = !0, x.params.spaceBetween = 0, void 0 === g && (x.params.virtualTranslate = !0)), x.params.grabCursor && x.support.touch && (x.params.grabCursor = !1), x.wrapper = x.container.children("." + x.params.wrapperClass), x.params.pagination && (x.paginationContainer = e(x.params.pagination), x.params.uniqueNavElements && "string" == typeof x.params.pagination && x.paginationContainer.length > 1 && 1 === x.container.find(x.params.pagination).length && (x.paginationContainer = x.container.find(x.params.pagination)), "bullets" === x.params.paginationType && x.params.paginationClickable ? x.paginationContainer.addClass(x.params.paginationModifierClass + "clickable") : x.params.paginationClickable = !1, x.paginationContainer.addClass(x.params.paginationModifierClass + x.params.paginationType)), (x.params.nextButton || x.params.prevButton) && (x.params.nextButton && (x.nextButton = e(x.params.nextButton), x.params.uniqueNavElements && "string" == typeof x.params.nextButton && x.nextButton.length > 1 && 1 === x.container.find(x.params.nextButton).length && (x.nextButton = x.container.find(x.params.nextButton))), x.params.prevButton && (x.prevButton = e(x.params.prevButton), x.params.uniqueNavElements && "string" == typeof x.params.prevButton && x.prevButton.length > 1 && 1 === x.container.find(x.params.prevButton).length && (x.prevButton = x.container.find(x.params.prevButton)))), x.isHorizontal = function () {
	        return "horizontal" === x.params.direction;
	      }, x.rtl = x.isHorizontal() && ("rtl" === x.container[0].dir.toLowerCase() || "rtl" === x.container.css("direction")), x.rtl && x.classNames.push(x.params.containerModifierClass + "rtl"), x.rtl && (x.wrongRTL = "-webkit-box" === x.wrapper.css("display")), x.params.slidesPerColumn > 1 && x.classNames.push(x.params.containerModifierClass + "multirow"), x.device.android && x.classNames.push(x.params.containerModifierClass + "android"), x.container.addClass(x.classNames.join(" ")), x.translate = 0, x.progress = 0, x.velocity = 0, x.lockSwipeToNext = function () {
	        x.params.allowSwipeToNext = !1, x.params.allowSwipeToPrev === !1 && x.params.grabCursor && x.unsetGrabCursor();
	      }, x.lockSwipeToPrev = function () {
	        x.params.allowSwipeToPrev = !1, x.params.allowSwipeToNext === !1 && x.params.grabCursor && x.unsetGrabCursor();
	      }, x.lockSwipes = function () {
	        x.params.allowSwipeToNext = x.params.allowSwipeToPrev = !1, x.params.grabCursor && x.unsetGrabCursor();
	      }, x.unlockSwipeToNext = function () {
	        x.params.allowSwipeToNext = !0, x.params.allowSwipeToPrev === !0 && x.params.grabCursor && x.setGrabCursor();
	      }, x.unlockSwipeToPrev = function () {
	        x.params.allowSwipeToPrev = !0, x.params.allowSwipeToNext === !0 && x.params.grabCursor && x.setGrabCursor();
	      }, x.unlockSwipes = function () {
	        x.params.allowSwipeToNext = x.params.allowSwipeToPrev = !0, x.params.grabCursor && x.setGrabCursor();
	      }, x.setGrabCursor = function (e) {
	        x.container[0].style.cursor = "move", x.container[0].style.cursor = e ? "-webkit-grabbing" : "-webkit-grab", x.container[0].style.cursor = e ? "-moz-grabbin" : "-moz-grab", x.container[0].style.cursor = e ? "grabbing" : "grab";
	      }, x.unsetGrabCursor = function () {
	        x.container[0].style.cursor = "";
	      }, x.params.grabCursor && x.setGrabCursor(), x.imagesToLoad = [], x.imagesLoaded = 0, x.loadImage = function (e, a, t, s, r, i) {
	        function n() {
	          i && i();
	        }var o;e.complete && r ? n() : a ? (o = new window.Image(), o.onload = n, o.onerror = n, s && (o.sizes = s), t && (o.srcset = t), a && (o.src = a)) : n();
	      }, x.preloadImages = function () {
	        function e() {
	          void 0 !== x && null !== x && x && (void 0 !== x.imagesLoaded && x.imagesLoaded++, x.imagesLoaded === x.imagesToLoad.length && (x.params.updateOnImagesReady && x.update(), x.emit("onImagesReady", x)));
	        }x.imagesToLoad = x.container.find("img");for (var a = 0; a < x.imagesToLoad.length; a++) {
	          x.loadImage(x.imagesToLoad[a], x.imagesToLoad[a].currentSrc || x.imagesToLoad[a].getAttribute("src"), x.imagesToLoad[a].srcset || x.imagesToLoad[a].getAttribute("srcset"), x.imagesToLoad[a].sizes || x.imagesToLoad[a].getAttribute("sizes"), !0, e);
	        }
	      }, x.autoplayTimeoutId = void 0, x.autoplaying = !1, x.autoplayPaused = !1, x.startAutoplay = function () {
	        return void 0 === x.autoplayTimeoutId && !!x.params.autoplay && !x.autoplaying && (x.autoplaying = !0, x.emit("onAutoplayStart", x), void i());
	      }, x.stopAutoplay = function (e) {
	        x.autoplayTimeoutId && (x.autoplayTimeoutId && clearTimeout(x.autoplayTimeoutId), x.autoplaying = !1, x.autoplayTimeoutId = void 0, x.emit("onAutoplayStop", x));
	      }, x.pauseAutoplay = function (e) {
	        x.autoplayPaused || (x.autoplayTimeoutId && clearTimeout(x.autoplayTimeoutId), x.autoplayPaused = !0, 0 === e ? (x.autoplayPaused = !1, i()) : x.wrapper.transitionEnd(function () {
	          x && (x.autoplayPaused = !1, x.autoplaying ? i() : x.stopAutoplay());
	        }));
	      }, x.minTranslate = function () {
	        return -x.snapGrid[0];
	      }, x.maxTranslate = function () {
	        return -x.snapGrid[x.snapGrid.length - 1];
	      }, x.updateAutoHeight = function () {
	        var e,
	            a = [],
	            t = 0;if ("auto" !== x.params.slidesPerView && x.params.slidesPerView > 1) for (e = 0; e < Math.ceil(x.params.slidesPerView); e++) {
	          var s = x.activeIndex + e;if (s > x.slides.length) break;a.push(x.slides.eq(s)[0]);
	        } else a.push(x.slides.eq(x.activeIndex)[0]);for (e = 0; e < a.length; e++) {
	          if (void 0 !== a[e]) {
	            var r = a[e].offsetHeight;t = r > t ? r : t;
	          }
	        }t && x.wrapper.css("height", t + "px");
	      }, x.updateContainerSize = function () {
	        var e, a;e = void 0 !== x.params.width ? x.params.width : x.container[0].clientWidth, a = void 0 !== x.params.height ? x.params.height : x.container[0].clientHeight, 0 === e && x.isHorizontal() || 0 === a && !x.isHorizontal() || (e = e - parseInt(x.container.css("padding-left"), 10) - parseInt(x.container.css("padding-right"), 10), a = a - parseInt(x.container.css("padding-top"), 10) - parseInt(x.container.css("padding-bottom"), 10), x.width = e, x.height = a, x.size = x.isHorizontal() ? x.width : x.height);
	      }, x.updateSlidesSize = function () {
	        x.slides = x.wrapper.children("." + x.params.slideClass), x.snapGrid = [], x.slidesGrid = [], x.slidesSizesGrid = [];var e,
	            a = x.params.spaceBetween,
	            t = -x.params.slidesOffsetBefore,
	            s = 0,
	            i = 0;if (void 0 !== x.size) {
	          "string" == typeof a && a.indexOf("%") >= 0 && (a = parseFloat(a.replace("%", "")) / 100 * x.size), x.virtualSize = -a, x.rtl ? x.slides.css({ marginLeft: "", marginTop: "" }) : x.slides.css({ marginRight: "", marginBottom: "" });var n;x.params.slidesPerColumn > 1 && (n = Math.floor(x.slides.length / x.params.slidesPerColumn) === x.slides.length / x.params.slidesPerColumn ? x.slides.length : Math.ceil(x.slides.length / x.params.slidesPerColumn) * x.params.slidesPerColumn, "auto" !== x.params.slidesPerView && "row" === x.params.slidesPerColumnFill && (n = Math.max(n, x.params.slidesPerView * x.params.slidesPerColumn)));var o,
	              l = x.params.slidesPerColumn,
	              p = n / l,
	              d = p - (x.params.slidesPerColumn * p - x.slides.length);for (e = 0; e < x.slides.length; e++) {
	            o = 0;var m = x.slides.eq(e);if (x.params.slidesPerColumn > 1) {
	              var u, c, g;"column" === x.params.slidesPerColumnFill ? (c = Math.floor(e / l), g = e - c * l, (c > d || c === d && g === l - 1) && ++g >= l && (g = 0, c++), u = c + g * n / l, m.css({ "-webkit-box-ordinal-group": u, "-moz-box-ordinal-group": u, "-ms-flex-order": u, "-webkit-order": u, order: u })) : (g = Math.floor(e / p), c = e - g * p), m.css("margin-" + (x.isHorizontal() ? "top" : "left"), 0 !== g && x.params.spaceBetween && x.params.spaceBetween + "px").attr("data-swiper-column", c).attr("data-swiper-row", g);
	            }"none" !== m.css("display") && ("auto" === x.params.slidesPerView ? (o = x.isHorizontal() ? m.outerWidth(!0) : m.outerHeight(!0), x.params.roundLengths && (o = r(o))) : (o = (x.size - (x.params.slidesPerView - 1) * a) / x.params.slidesPerView, x.params.roundLengths && (o = r(o)), x.isHorizontal() ? x.slides[e].style.width = o + "px" : x.slides[e].style.height = o + "px"), x.slides[e].swiperSlideSize = o, x.slidesSizesGrid.push(o), x.params.centeredSlides ? (t = t + o / 2 + s / 2 + a, 0 === s && 0 !== e && (t = t - x.size / 2 - a), 0 === e && (t = t - x.size / 2 - a), Math.abs(t) < .001 && (t = 0), i % x.params.slidesPerGroup == 0 && x.snapGrid.push(t), x.slidesGrid.push(t)) : (i % x.params.slidesPerGroup == 0 && x.snapGrid.push(t), x.slidesGrid.push(t), t = t + o + a), x.virtualSize += o + a, s = o, i++);
	          }x.virtualSize = Math.max(x.virtualSize, x.size) + x.params.slidesOffsetAfter;var h;if (x.rtl && x.wrongRTL && ("slide" === x.params.effect || "coverflow" === x.params.effect) && x.wrapper.css({ width: x.virtualSize + x.params.spaceBetween + "px" }), x.support.flexbox && !x.params.setWrapperSize || (x.isHorizontal() ? x.wrapper.css({ width: x.virtualSize + x.params.spaceBetween + "px" }) : x.wrapper.css({ height: x.virtualSize + x.params.spaceBetween + "px" })), x.params.slidesPerColumn > 1 && (x.virtualSize = (o + x.params.spaceBetween) * n, x.virtualSize = Math.ceil(x.virtualSize / x.params.slidesPerColumn) - x.params.spaceBetween, x.isHorizontal() ? x.wrapper.css({ width: x.virtualSize + x.params.spaceBetween + "px" }) : x.wrapper.css({ height: x.virtualSize + x.params.spaceBetween + "px" }), x.params.centeredSlides)) {
	            for (h = [], e = 0; e < x.snapGrid.length; e++) {
	              x.snapGrid[e] < x.virtualSize + x.snapGrid[0] && h.push(x.snapGrid[e]);
	            }x.snapGrid = h;
	          }if (!x.params.centeredSlides) {
	            for (h = [], e = 0; e < x.snapGrid.length; e++) {
	              x.snapGrid[e] <= x.virtualSize - x.size && h.push(x.snapGrid[e]);
	            }x.snapGrid = h, Math.floor(x.virtualSize - x.size) - Math.floor(x.snapGrid[x.snapGrid.length - 1]) > 1 && x.snapGrid.push(x.virtualSize - x.size);
	          }0 === x.snapGrid.length && (x.snapGrid = [0]), 0 !== x.params.spaceBetween && (x.isHorizontal() ? x.rtl ? x.slides.css({ marginLeft: a + "px" }) : x.slides.css({ marginRight: a + "px" }) : x.slides.css({ marginBottom: a + "px" })), x.params.watchSlidesProgress && x.updateSlidesOffset();
	        }
	      }, x.updateSlidesOffset = function () {
	        for (var e = 0; e < x.slides.length; e++) {
	          x.slides[e].swiperSlideOffset = x.isHorizontal() ? x.slides[e].offsetLeft : x.slides[e].offsetTop;
	        }
	      }, x.currentSlidesPerView = function () {
	        var e,
	            a,
	            t = 1;if (x.params.centeredSlides) {
	          var s,
	              r = x.slides[x.activeIndex].swiperSlideSize;for (e = x.activeIndex + 1; e < x.slides.length; e++) {
	            x.slides[e] && !s && (r += x.slides[e].swiperSlideSize, t++, r > x.size && (s = !0));
	          }for (a = x.activeIndex - 1; a >= 0; a--) {
	            x.slides[a] && !s && (r += x.slides[a].swiperSlideSize, t++, r > x.size && (s = !0));
	          }
	        } else for (e = x.activeIndex + 1; e < x.slides.length; e++) {
	          x.slidesGrid[e] - x.slidesGrid[x.activeIndex] < x.size && t++;
	        }return t;
	      }, x.updateSlidesProgress = function (e) {
	        if (void 0 === e && (e = x.translate || 0), 0 !== x.slides.length) {
	          void 0 === x.slides[0].swiperSlideOffset && x.updateSlidesOffset();var a = -e;x.rtl && (a = e), x.slides.removeClass(x.params.slideVisibleClass);for (var t = 0; t < x.slides.length; t++) {
	            var s = x.slides[t],
	                r = (a + (x.params.centeredSlides ? x.minTranslate() : 0) - s.swiperSlideOffset) / (s.swiperSlideSize + x.params.spaceBetween);if (x.params.watchSlidesVisibility) {
	              var i = -(a - s.swiperSlideOffset),
	                  n = i + x.slidesSizesGrid[t];(i >= 0 && i < x.size || n > 0 && n <= x.size || i <= 0 && n >= x.size) && x.slides.eq(t).addClass(x.params.slideVisibleClass);
	            }s.progress = x.rtl ? -r : r;
	          }
	        }
	      }, x.updateProgress = function (e) {
	        void 0 === e && (e = x.translate || 0);var a = x.maxTranslate() - x.minTranslate(),
	            t = x.isBeginning,
	            s = x.isEnd;0 === a ? (x.progress = 0, x.isBeginning = x.isEnd = !0) : (x.progress = (e - x.minTranslate()) / a, x.isBeginning = x.progress <= 0, x.isEnd = x.progress >= 1), x.isBeginning && !t && x.emit("onReachBeginning", x), x.isEnd && !s && x.emit("onReachEnd", x), x.params.watchSlidesProgress && x.updateSlidesProgress(e), x.emit("onProgress", x, x.progress);
	      }, x.updateActiveIndex = function () {
	        var e,
	            a,
	            t,
	            s = x.rtl ? x.translate : -x.translate;for (a = 0; a < x.slidesGrid.length; a++) {
	          void 0 !== x.slidesGrid[a + 1] ? s >= x.slidesGrid[a] && s < x.slidesGrid[a + 1] - (x.slidesGrid[a + 1] - x.slidesGrid[a]) / 2 ? e = a : s >= x.slidesGrid[a] && s < x.slidesGrid[a + 1] && (e = a + 1) : s >= x.slidesGrid[a] && (e = a);
	        }x.params.normalizeSlideIndex && (e < 0 || void 0 === e) && (e = 0), t = Math.floor(e / x.params.slidesPerGroup), t >= x.snapGrid.length && (t = x.snapGrid.length - 1), e !== x.activeIndex && (x.snapIndex = t, x.previousIndex = x.activeIndex, x.activeIndex = e, x.updateClasses(), x.updateRealIndex());
	      }, x.updateRealIndex = function () {
	        x.realIndex = parseInt(x.slides.eq(x.activeIndex).attr("data-swiper-slide-index") || x.activeIndex, 10);
	      }, x.updateClasses = function () {
	        x.slides.removeClass(x.params.slideActiveClass + " " + x.params.slideNextClass + " " + x.params.slidePrevClass + " " + x.params.slideDuplicateActiveClass + " " + x.params.slideDuplicateNextClass + " " + x.params.slideDuplicatePrevClass);var a = x.slides.eq(x.activeIndex);a.addClass(x.params.slideActiveClass), s.loop && (a.hasClass(x.params.slideDuplicateClass) ? x.wrapper.children("." + x.params.slideClass + ":not(." + x.params.slideDuplicateClass + ')[data-swiper-slide-index="' + x.realIndex + '"]').addClass(x.params.slideDuplicateActiveClass) : x.wrapper.children("." + x.params.slideClass + "." + x.params.slideDuplicateClass + '[data-swiper-slide-index="' + x.realIndex + '"]').addClass(x.params.slideDuplicateActiveClass));var t = a.next("." + x.params.slideClass).addClass(x.params.slideNextClass);x.params.loop && 0 === t.length && (t = x.slides.eq(0), t.addClass(x.params.slideNextClass));var r = a.prev("." + x.params.slideClass).addClass(x.params.slidePrevClass);if (x.params.loop && 0 === r.length && (r = x.slides.eq(-1), r.addClass(x.params.slidePrevClass)), s.loop && (t.hasClass(x.params.slideDuplicateClass) ? x.wrapper.children("." + x.params.slideClass + ":not(." + x.params.slideDuplicateClass + ')[data-swiper-slide-index="' + t.attr("data-swiper-slide-index") + '"]').addClass(x.params.slideDuplicateNextClass) : x.wrapper.children("." + x.params.slideClass + "." + x.params.slideDuplicateClass + '[data-swiper-slide-index="' + t.attr("data-swiper-slide-index") + '"]').addClass(x.params.slideDuplicateNextClass), r.hasClass(x.params.slideDuplicateClass) ? x.wrapper.children("." + x.params.slideClass + ":not(." + x.params.slideDuplicateClass + ')[data-swiper-slide-index="' + r.attr("data-swiper-slide-index") + '"]').addClass(x.params.slideDuplicatePrevClass) : x.wrapper.children("." + x.params.slideClass + "." + x.params.slideDuplicateClass + '[data-swiper-slide-index="' + r.attr("data-swiper-slide-index") + '"]').addClass(x.params.slideDuplicatePrevClass)), x.paginationContainer && x.paginationContainer.length > 0) {
	          var i,
	              n = x.params.loop ? Math.ceil((x.slides.length - 2 * x.loopedSlides) / x.params.slidesPerGroup) : x.snapGrid.length;if (x.params.loop ? (i = Math.ceil((x.activeIndex - x.loopedSlides) / x.params.slidesPerGroup), i > x.slides.length - 1 - 2 * x.loopedSlides && (i -= x.slides.length - 2 * x.loopedSlides), i > n - 1 && (i -= n), i < 0 && "bullets" !== x.params.paginationType && (i = n + i)) : i = void 0 !== x.snapIndex ? x.snapIndex : x.activeIndex || 0, "bullets" === x.params.paginationType && x.bullets && x.bullets.length > 0 && (x.bullets.removeClass(x.params.bulletActiveClass), x.paginationContainer.length > 1 ? x.bullets.each(function () {
	            e(this).index() === i && e(this).addClass(x.params.bulletActiveClass);
	          }) : x.bullets.eq(i).addClass(x.params.bulletActiveClass)), "fraction" === x.params.paginationType && (x.paginationContainer.find("." + x.params.paginationCurrentClass).text(i + 1), x.paginationContainer.find("." + x.params.paginationTotalClass).text(n)), "progress" === x.params.paginationType) {
	            var o = (i + 1) / n,
	                l = o,
	                p = 1;x.isHorizontal() || (p = o, l = 1), x.paginationContainer.find("." + x.params.paginationProgressbarClass).transform("translate3d(0,0,0) scaleX(" + l + ") scaleY(" + p + ")").transition(x.params.speed);
	          }"custom" === x.params.paginationType && x.params.paginationCustomRender && (x.paginationContainer.html(x.params.paginationCustomRender(x, i + 1, n)), x.emit("onPaginationRendered", x, x.paginationContainer[0]));
	        }x.params.loop || (x.params.prevButton && x.prevButton && x.prevButton.length > 0 && (x.isBeginning ? (x.prevButton.addClass(x.params.buttonDisabledClass), x.params.a11y && x.a11y && x.a11y.disable(x.prevButton)) : (x.prevButton.removeClass(x.params.buttonDisabledClass), x.params.a11y && x.a11y && x.a11y.enable(x.prevButton))), x.params.nextButton && x.nextButton && x.nextButton.length > 0 && (x.isEnd ? (x.nextButton.addClass(x.params.buttonDisabledClass), x.params.a11y && x.a11y && x.a11y.disable(x.nextButton)) : (x.nextButton.removeClass(x.params.buttonDisabledClass), x.params.a11y && x.a11y && x.a11y.enable(x.nextButton))));
	      }, x.updatePagination = function () {
	        if (x.params.pagination && x.paginationContainer && x.paginationContainer.length > 0) {
	          var e = "";if ("bullets" === x.params.paginationType) {
	            for (var a = x.params.loop ? Math.ceil((x.slides.length - 2 * x.loopedSlides) / x.params.slidesPerGroup) : x.snapGrid.length, t = 0; t < a; t++) {
	              e += x.params.paginationBulletRender ? x.params.paginationBulletRender(x, t, x.params.bulletClass) : "<" + x.params.paginationElement + ' class="' + x.params.bulletClass + '"></' + x.params.paginationElement + ">";
	            }x.paginationContainer.html(e), x.bullets = x.paginationContainer.find("." + x.params.bulletClass), x.params.paginationClickable && x.params.a11y && x.a11y && x.a11y.initPagination();
	          }"fraction" === x.params.paginationType && (e = x.params.paginationFractionRender ? x.params.paginationFractionRender(x, x.params.paginationCurrentClass, x.params.paginationTotalClass) : '<span class="' + x.params.paginationCurrentClass + '"></span> / <span class="' + x.params.paginationTotalClass + '"></span>', x.paginationContainer.html(e)), "progress" === x.params.paginationType && (e = x.params.paginationProgressRender ? x.params.paginationProgressRender(x, x.params.paginationProgressbarClass) : '<span class="' + x.params.paginationProgressbarClass + '"></span>', x.paginationContainer.html(e)), "custom" !== x.params.paginationType && x.emit("onPaginationRendered", x, x.paginationContainer[0]);
	        }
	      }, x.update = function (e) {
	        function a() {
	          x.rtl, x.translate;t = Math.min(Math.max(x.translate, x.maxTranslate()), x.minTranslate()), x.setWrapperTranslate(t), x.updateActiveIndex(), x.updateClasses();
	        }if (x) {
	          x.updateContainerSize(), x.updateSlidesSize(), x.updateProgress(), x.updatePagination(), x.updateClasses(), x.params.scrollbar && x.scrollbar && x.scrollbar.set();var t;if (e) {
	            x.controller && x.controller.spline && (x.controller.spline = void 0), x.params.freeMode ? (a(), x.params.autoHeight && x.updateAutoHeight()) : (("auto" === x.params.slidesPerView || x.params.slidesPerView > 1) && x.isEnd && !x.params.centeredSlides ? x.slideTo(x.slides.length - 1, 0, !1, !0) : x.slideTo(x.activeIndex, 0, !1, !0)) || a();
	          } else x.params.autoHeight && x.updateAutoHeight();
	        }
	      }, x.onResize = function (e) {
	        x.params.onBeforeResize && x.params.onBeforeResize(x), x.params.breakpoints && x.setBreakpoint();var a = x.params.allowSwipeToPrev,
	            t = x.params.allowSwipeToNext;x.params.allowSwipeToPrev = x.params.allowSwipeToNext = !0, x.updateContainerSize(), x.updateSlidesSize(), ("auto" === x.params.slidesPerView || x.params.freeMode || e) && x.updatePagination(), x.params.scrollbar && x.scrollbar && x.scrollbar.set(), x.controller && x.controller.spline && (x.controller.spline = void 0);var s = !1;if (x.params.freeMode) {
	          var r = Math.min(Math.max(x.translate, x.maxTranslate()), x.minTranslate());x.setWrapperTranslate(r), x.updateActiveIndex(), x.updateClasses(), x.params.autoHeight && x.updateAutoHeight();
	        } else x.updateClasses(), s = ("auto" === x.params.slidesPerView || x.params.slidesPerView > 1) && x.isEnd && !x.params.centeredSlides ? x.slideTo(x.slides.length - 1, 0, !1, !0) : x.slideTo(x.activeIndex, 0, !1, !0);x.params.lazyLoading && !s && x.lazy && x.lazy.load(), x.params.allowSwipeToPrev = a, x.params.allowSwipeToNext = t, x.params.onAfterResize && x.params.onAfterResize(x);
	      }, x.touchEventsDesktop = { start: "mousedown", move: "mousemove", end: "mouseup" }, window.navigator.pointerEnabled ? x.touchEventsDesktop = { start: "pointerdown", move: "pointermove", end: "pointerup" } : window.navigator.msPointerEnabled && (x.touchEventsDesktop = { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" }), x.touchEvents = { start: x.support.touch || !x.params.simulateTouch ? "touchstart" : x.touchEventsDesktop.start, move: x.support.touch || !x.params.simulateTouch ? "touchmove" : x.touchEventsDesktop.move, end: x.support.touch || !x.params.simulateTouch ? "touchend" : x.touchEventsDesktop.end }, (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) && ("container" === x.params.touchEventsTarget ? x.container : x.wrapper).addClass("swiper-wp8-" + x.params.direction), x.initEvents = function (e) {
	        var a = e ? "off" : "on",
	            t = e ? "removeEventListener" : "addEventListener",
	            r = "container" === x.params.touchEventsTarget ? x.container[0] : x.wrapper[0],
	            i = x.support.touch ? r : document,
	            n = !!x.params.nested;if (x.browser.ie) r[t](x.touchEvents.start, x.onTouchStart, !1), i[t](x.touchEvents.move, x.onTouchMove, n), i[t](x.touchEvents.end, x.onTouchEnd, !1);else {
	          if (x.support.touch) {
	            var o = !("touchstart" !== x.touchEvents.start || !x.support.passiveListener || !x.params.passiveListeners) && { passive: !0, capture: !1 };r[t](x.touchEvents.start, x.onTouchStart, o), r[t](x.touchEvents.move, x.onTouchMove, n), r[t](x.touchEvents.end, x.onTouchEnd, o);
	          }(s.simulateTouch && !x.device.ios && !x.device.android || s.simulateTouch && !x.support.touch && x.device.ios) && (r[t]("mousedown", x.onTouchStart, !1), document[t]("mousemove", x.onTouchMove, n), document[t]("mouseup", x.onTouchEnd, !1));
	        }window[t]("resize", x.onResize), x.params.nextButton && x.nextButton && x.nextButton.length > 0 && (x.nextButton[a]("click", x.onClickNext), x.params.a11y && x.a11y && x.nextButton[a]("keydown", x.a11y.onEnterKey)), x.params.prevButton && x.prevButton && x.prevButton.length > 0 && (x.prevButton[a]("click", x.onClickPrev), x.params.a11y && x.a11y && x.prevButton[a]("keydown", x.a11y.onEnterKey)), x.params.pagination && x.params.paginationClickable && (x.paginationContainer[a]("click", "." + x.params.bulletClass, x.onClickIndex), x.params.a11y && x.a11y && x.paginationContainer[a]("keydown", "." + x.params.bulletClass, x.a11y.onEnterKey)), (x.params.preventClicks || x.params.preventClicksPropagation) && r[t]("click", x.preventClicks, !0);
	      }, x.attachEvents = function () {
	        x.initEvents();
	      }, x.detachEvents = function () {
	        x.initEvents(!0);
	      }, x.allowClick = !0, x.preventClicks = function (e) {
	        x.allowClick || (x.params.preventClicks && e.preventDefault(), x.params.preventClicksPropagation && x.animating && (e.stopPropagation(), e.stopImmediatePropagation()));
	      }, x.onClickNext = function (e) {
	        e.preventDefault(), x.isEnd && !x.params.loop || x.slideNext();
	      }, x.onClickPrev = function (e) {
	        e.preventDefault(), x.isBeginning && !x.params.loop || x.slidePrev();
	      }, x.onClickIndex = function (a) {
	        a.preventDefault();var t = e(this).index() * x.params.slidesPerGroup;x.params.loop && (t += x.loopedSlides), x.slideTo(t);
	      }, x.updateClickedSlide = function (a) {
	        var t = n(a, "." + x.params.slideClass),
	            s = !1;if (t) for (var r = 0; r < x.slides.length; r++) {
	          x.slides[r] === t && (s = !0);
	        }if (!t || !s) return x.clickedSlide = void 0, void (x.clickedIndex = void 0);if (x.clickedSlide = t, x.clickedIndex = e(t).index(), x.params.slideToClickedSlide && void 0 !== x.clickedIndex && x.clickedIndex !== x.activeIndex) {
	          var i,
	              o = x.clickedIndex,
	              l = "auto" === x.params.slidesPerView ? x.currentSlidesPerView() : x.params.slidesPerView;if (x.params.loop) {
	            if (x.animating) return;i = parseInt(e(x.clickedSlide).attr("data-swiper-slide-index"), 10), x.params.centeredSlides ? o < x.loopedSlides - l / 2 || o > x.slides.length - x.loopedSlides + l / 2 ? (x.fixLoop(), o = x.wrapper.children("." + x.params.slideClass + '[data-swiper-slide-index="' + i + '"]:not(.' + x.params.slideDuplicateClass + ")").eq(0).index(), setTimeout(function () {
	              x.slideTo(o);
	            }, 0)) : x.slideTo(o) : o > x.slides.length - l ? (x.fixLoop(), o = x.wrapper.children("." + x.params.slideClass + '[data-swiper-slide-index="' + i + '"]:not(.' + x.params.slideDuplicateClass + ")").eq(0).index(), setTimeout(function () {
	              x.slideTo(o);
	            }, 0)) : x.slideTo(o);
	          } else x.slideTo(o);
	        }
	      };var b,
	          C,
	          S,
	          z,
	          M,
	          P,
	          E,
	          I,
	          k,
	          D,
	          L = "input, select, textarea, button, video",
	          B = Date.now(),
	          H = [];x.animating = !1, x.touches = { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 };var G, X;x.onTouchStart = function (a) {
	        if (a.originalEvent && (a = a.originalEvent), (G = "touchstart" === a.type) || !("which" in a) || 3 !== a.which) {
	          if (x.params.noSwiping && n(a, "." + x.params.noSwipingClass)) return void (x.allowClick = !0);if (!x.params.swipeHandler || n(a, x.params.swipeHandler)) {
	            var t = x.touches.currentX = "touchstart" === a.type ? a.targetTouches[0].pageX : a.pageX,
	                s = x.touches.currentY = "touchstart" === a.type ? a.targetTouches[0].pageY : a.pageY;if (!(x.device.ios && x.params.iOSEdgeSwipeDetection && t <= x.params.iOSEdgeSwipeThreshold)) {
	              if (b = !0, C = !1, S = !0, M = void 0, X = void 0, x.touches.startX = t, x.touches.startY = s, z = Date.now(), x.allowClick = !0, x.updateContainerSize(), x.swipeDirection = void 0, x.params.threshold > 0 && (I = !1), "touchstart" !== a.type) {
	                var r = !0;e(a.target).is(L) && (r = !1), document.activeElement && e(document.activeElement).is(L) && document.activeElement.blur(), r && a.preventDefault();
	              }x.emit("onTouchStart", x, a);
	            }
	          }
	        }
	      }, x.onTouchMove = function (a) {
	        if (a.originalEvent && (a = a.originalEvent), !G || "mousemove" !== a.type) {
	          if (a.preventedByNestedSwiper) return x.touches.startX = "touchmove" === a.type ? a.targetTouches[0].pageX : a.pageX, void (x.touches.startY = "touchmove" === a.type ? a.targetTouches[0].pageY : a.pageY);if (x.params.onlyExternal) return x.allowClick = !1, void (b && (x.touches.startX = x.touches.currentX = "touchmove" === a.type ? a.targetTouches[0].pageX : a.pageX, x.touches.startY = x.touches.currentY = "touchmove" === a.type ? a.targetTouches[0].pageY : a.pageY, z = Date.now()));if (G && x.params.touchReleaseOnEdges && !x.params.loop) if (x.isHorizontal()) {
	            if (x.touches.currentX < x.touches.startX && x.translate <= x.maxTranslate() || x.touches.currentX > x.touches.startX && x.translate >= x.minTranslate()) return;
	          } else if (x.touches.currentY < x.touches.startY && x.translate <= x.maxTranslate() || x.touches.currentY > x.touches.startY && x.translate >= x.minTranslate()) return;if (G && document.activeElement && a.target === document.activeElement && e(a.target).is(L)) return C = !0, void (x.allowClick = !1);if (S && x.emit("onTouchMove", x, a), !(a.targetTouches && a.targetTouches.length > 1)) {
	            if (x.touches.currentX = "touchmove" === a.type ? a.targetTouches[0].pageX : a.pageX, x.touches.currentY = "touchmove" === a.type ? a.targetTouches[0].pageY : a.pageY, void 0 === M) {
	              var t;x.isHorizontal() && x.touches.currentY === x.touches.startY || !x.isHorizontal() && x.touches.currentX === x.touches.startX ? M = !1 : (t = 180 * Math.atan2(Math.abs(x.touches.currentY - x.touches.startY), Math.abs(x.touches.currentX - x.touches.startX)) / Math.PI, M = x.isHorizontal() ? t > x.params.touchAngle : 90 - t > x.params.touchAngle);
	            }if (M && x.emit("onTouchMoveOpposite", x, a), void 0 === X && (x.touches.currentX === x.touches.startX && x.touches.currentY === x.touches.startY || (X = !0)), b) {
	              if (M) return void (b = !1);if (X) {
	                x.allowClick = !1, x.emit("onSliderMove", x, a), a.preventDefault(), x.params.touchMoveStopPropagation && !x.params.nested && a.stopPropagation(), C || (s.loop && x.fixLoop(), E = x.getWrapperTranslate(), x.setWrapperTransition(0), x.animating && x.wrapper.trigger("webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd"), x.params.autoplay && x.autoplaying && (x.params.autoplayDisableOnInteraction ? x.stopAutoplay() : x.pauseAutoplay()), D = !1, !x.params.grabCursor || x.params.allowSwipeToNext !== !0 && x.params.allowSwipeToPrev !== !0 || x.setGrabCursor(!0)), C = !0;var r = x.touches.diff = x.isHorizontal() ? x.touches.currentX - x.touches.startX : x.touches.currentY - x.touches.startY;r *= x.params.touchRatio, x.rtl && (r = -r), x.swipeDirection = r > 0 ? "prev" : "next", P = r + E;var i = !0;if (r > 0 && P > x.minTranslate() ? (i = !1, x.params.resistance && (P = x.minTranslate() - 1 + Math.pow(-x.minTranslate() + E + r, x.params.resistanceRatio))) : r < 0 && P < x.maxTranslate() && (i = !1, x.params.resistance && (P = x.maxTranslate() + 1 - Math.pow(x.maxTranslate() - E - r, x.params.resistanceRatio))), i && (a.preventedByNestedSwiper = !0), !x.params.allowSwipeToNext && "next" === x.swipeDirection && P < E && (P = E), !x.params.allowSwipeToPrev && "prev" === x.swipeDirection && P > E && (P = E), x.params.threshold > 0) {
	                  if (!(Math.abs(r) > x.params.threshold || I)) return void (P = E);if (!I) return I = !0, x.touches.startX = x.touches.currentX, x.touches.startY = x.touches.currentY, P = E, void (x.touches.diff = x.isHorizontal() ? x.touches.currentX - x.touches.startX : x.touches.currentY - x.touches.startY);
	                }x.params.followFinger && ((x.params.freeMode || x.params.watchSlidesProgress) && x.updateActiveIndex(), x.params.freeMode && (0 === H.length && H.push({ position: x.touches[x.isHorizontal() ? "startX" : "startY"], time: z }), H.push({ position: x.touches[x.isHorizontal() ? "currentX" : "currentY"], time: new window.Date().getTime() })), x.updateProgress(P), x.setWrapperTranslate(P));
	              }
	            }
	          }
	        }
	      }, x.onTouchEnd = function (a) {
	        if (a.originalEvent && (a = a.originalEvent), S && x.emit("onTouchEnd", x, a), S = !1, b) {
	          x.params.grabCursor && C && b && (x.params.allowSwipeToNext === !0 || x.params.allowSwipeToPrev === !0) && x.setGrabCursor(!1);var t = Date.now(),
	              s = t - z;if (x.allowClick && (x.updateClickedSlide(a), x.emit("onTap", x, a), s < 300 && t - B > 300 && (k && clearTimeout(k), k = setTimeout(function () {
	            x && (x.params.paginationHide && x.paginationContainer.length > 0 && !e(a.target).hasClass(x.params.bulletClass) && x.paginationContainer.toggleClass(x.params.paginationHiddenClass), x.emit("onClick", x, a));
	          }, 300)), s < 300 && t - B < 300 && (k && clearTimeout(k), x.emit("onDoubleTap", x, a))), B = Date.now(), setTimeout(function () {
	            x && (x.allowClick = !0);
	          }, 0), !b || !C || !x.swipeDirection || 0 === x.touches.diff || P === E) return void (b = C = !1);b = C = !1;var r;if (r = x.params.followFinger ? x.rtl ? x.translate : -x.translate : -P, x.params.freeMode) {
	            if (r < -x.minTranslate()) return void x.slideTo(x.activeIndex);if (r > -x.maxTranslate()) return void (x.slides.length < x.snapGrid.length ? x.slideTo(x.snapGrid.length - 1) : x.slideTo(x.slides.length - 1));if (x.params.freeModeMomentum) {
	              if (H.length > 1) {
	                var i = H.pop(),
	                    n = H.pop(),
	                    o = i.position - n.position,
	                    l = i.time - n.time;x.velocity = o / l, x.velocity = x.velocity / 2, Math.abs(x.velocity) < x.params.freeModeMinimumVelocity && (x.velocity = 0), (l > 150 || new window.Date().getTime() - i.time > 300) && (x.velocity = 0);
	              } else x.velocity = 0;x.velocity = x.velocity * x.params.freeModeMomentumVelocityRatio, H.length = 0;var p = 1e3 * x.params.freeModeMomentumRatio,
	                  d = x.velocity * p,
	                  m = x.translate + d;x.rtl && (m = -m);var u,
	                  c = !1,
	                  g = 20 * Math.abs(x.velocity) * x.params.freeModeMomentumBounceRatio;if (m < x.maxTranslate()) x.params.freeModeMomentumBounce ? (m + x.maxTranslate() < -g && (m = x.maxTranslate() - g), u = x.maxTranslate(), c = !0, D = !0) : m = x.maxTranslate();else if (m > x.minTranslate()) x.params.freeModeMomentumBounce ? (m - x.minTranslate() > g && (m = x.minTranslate() + g), u = x.minTranslate(), c = !0, D = !0) : m = x.minTranslate();else if (x.params.freeModeSticky) {
	                var h,
	                    v = 0;for (v = 0; v < x.snapGrid.length; v += 1) {
	                  if (x.snapGrid[v] > -m) {
	                    h = v;break;
	                  }
	                }m = Math.abs(x.snapGrid[h] - m) < Math.abs(x.snapGrid[h - 1] - m) || "next" === x.swipeDirection ? x.snapGrid[h] : x.snapGrid[h - 1], x.rtl || (m = -m);
	              }if (0 !== x.velocity) p = x.rtl ? Math.abs((-m - x.translate) / x.velocity) : Math.abs((m - x.translate) / x.velocity);else if (x.params.freeModeSticky) return void x.slideReset();x.params.freeModeMomentumBounce && c ? (x.updateProgress(u), x.setWrapperTransition(p), x.setWrapperTranslate(m), x.onTransitionStart(), x.animating = !0, x.wrapper.transitionEnd(function () {
	                x && D && (x.emit("onMomentumBounce", x), x.setWrapperTransition(x.params.speed), x.setWrapperTranslate(u), x.wrapper.transitionEnd(function () {
	                  x && x.onTransitionEnd();
	                }));
	              })) : x.velocity ? (x.updateProgress(m), x.setWrapperTransition(p), x.setWrapperTranslate(m), x.onTransitionStart(), x.animating || (x.animating = !0, x.wrapper.transitionEnd(function () {
	                x && x.onTransitionEnd();
	              }))) : x.updateProgress(m), x.updateActiveIndex();
	            }return void ((!x.params.freeModeMomentum || s >= x.params.longSwipesMs) && (x.updateProgress(), x.updateActiveIndex()));
	          }var f,
	              w = 0,
	              y = x.slidesSizesGrid[0];for (f = 0; f < x.slidesGrid.length; f += x.params.slidesPerGroup) {
	            void 0 !== x.slidesGrid[f + x.params.slidesPerGroup] ? r >= x.slidesGrid[f] && r < x.slidesGrid[f + x.params.slidesPerGroup] && (w = f, y = x.slidesGrid[f + x.params.slidesPerGroup] - x.slidesGrid[f]) : r >= x.slidesGrid[f] && (w = f, y = x.slidesGrid[x.slidesGrid.length - 1] - x.slidesGrid[x.slidesGrid.length - 2]);
	          }var T = (r - x.slidesGrid[w]) / y;if (s > x.params.longSwipesMs) {
	            if (!x.params.longSwipes) return void x.slideTo(x.activeIndex);"next" === x.swipeDirection && (T >= x.params.longSwipesRatio ? x.slideTo(w + x.params.slidesPerGroup) : x.slideTo(w)), "prev" === x.swipeDirection && (T > 1 - x.params.longSwipesRatio ? x.slideTo(w + x.params.slidesPerGroup) : x.slideTo(w));
	          } else {
	            if (!x.params.shortSwipes) return void x.slideTo(x.activeIndex);"next" === x.swipeDirection && x.slideTo(w + x.params.slidesPerGroup), "prev" === x.swipeDirection && x.slideTo(w);
	          }
	        }
	      }, x._slideTo = function (e, a) {
	        return x.slideTo(e, a, !0, !0);
	      }, x.slideTo = function (e, a, t, s) {
	        void 0 === t && (t = !0), void 0 === e && (e = 0), e < 0 && (e = 0), x.snapIndex = Math.floor(e / x.params.slidesPerGroup), x.snapIndex >= x.snapGrid.length && (x.snapIndex = x.snapGrid.length - 1);var r = -x.snapGrid[x.snapIndex];if (x.params.autoplay && x.autoplaying && (s || !x.params.autoplayDisableOnInteraction ? x.pauseAutoplay(a) : x.stopAutoplay()), x.updateProgress(r), x.params.normalizeSlideIndex) for (var i = 0; i < x.slidesGrid.length; i++) {
	          -Math.floor(100 * r) >= Math.floor(100 * x.slidesGrid[i]) && (e = i);
	        }return !(!x.params.allowSwipeToNext && r < x.translate && r < x.minTranslate()) && !(!x.params.allowSwipeToPrev && r > x.translate && r > x.maxTranslate() && (x.activeIndex || 0) !== e) && (void 0 === a && (a = x.params.speed), x.previousIndex = x.activeIndex || 0, x.activeIndex = e, x.updateRealIndex(), x.rtl && -r === x.translate || !x.rtl && r === x.translate ? (x.params.autoHeight && x.updateAutoHeight(), x.updateClasses(), "slide" !== x.params.effect && x.setWrapperTranslate(r), !1) : (x.updateClasses(), x.onTransitionStart(t), 0 === a || x.browser.lteIE9 ? (x.setWrapperTranslate(r), x.setWrapperTransition(0), x.onTransitionEnd(t)) : (x.setWrapperTranslate(r), x.setWrapperTransition(a), x.animating || (x.animating = !0, x.wrapper.transitionEnd(function () {
	          x && x.onTransitionEnd(t);
	        }))), !0));
	      }, x.onTransitionStart = function (e) {
	        void 0 === e && (e = !0), x.params.autoHeight && x.updateAutoHeight(), x.lazy && x.lazy.onTransitionStart(), e && (x.emit("onTransitionStart", x), x.activeIndex !== x.previousIndex && (x.emit("onSlideChangeStart", x), x.activeIndex > x.previousIndex ? x.emit("onSlideNextStart", x) : x.emit("onSlidePrevStart", x)));
	      }, x.onTransitionEnd = function (e) {
	        x.animating = !1, x.setWrapperTransition(0), void 0 === e && (e = !0), x.lazy && x.lazy.onTransitionEnd(), e && (x.emit("onTransitionEnd", x), x.activeIndex !== x.previousIndex && (x.emit("onSlideChangeEnd", x), x.activeIndex > x.previousIndex ? x.emit("onSlideNextEnd", x) : x.emit("onSlidePrevEnd", x))), x.params.history && x.history && x.history.setHistory(x.params.history, x.activeIndex), x.params.hashnav && x.hashnav && x.hashnav.setHash();
	      }, x.slideNext = function (e, a, t) {
	        if (x.params.loop) {
	          if (x.animating) return !1;x.fixLoop();x.container[0].clientLeft;return x.slideTo(x.activeIndex + x.params.slidesPerGroup, a, e, t);
	        }return x.slideTo(x.activeIndex + x.params.slidesPerGroup, a, e, t);
	      }, x._slideNext = function (e) {
	        return x.slideNext(!0, e, !0);
	      }, x.slidePrev = function (e, a, t) {
	        if (x.params.loop) {
	          if (x.animating) return !1;x.fixLoop();x.container[0].clientLeft;return x.slideTo(x.activeIndex - 1, a, e, t);
	        }return x.slideTo(x.activeIndex - 1, a, e, t);
	      }, x._slidePrev = function (e) {
	        return x.slidePrev(!0, e, !0);
	      }, x.slideReset = function (e, a, t) {
	        return x.slideTo(x.activeIndex, a, e);
	      }, x.disableTouchControl = function () {
	        return x.params.onlyExternal = !0, !0;
	      }, x.enableTouchControl = function () {
	        return x.params.onlyExternal = !1, !0;
	      }, x.setWrapperTransition = function (e, a) {
	        x.wrapper.transition(e), "slide" !== x.params.effect && x.effects[x.params.effect] && x.effects[x.params.effect].setTransition(e), x.params.parallax && x.parallax && x.parallax.setTransition(e), x.params.scrollbar && x.scrollbar && x.scrollbar.setTransition(e), x.params.control && x.controller && x.controller.setTransition(e, a), x.emit("onSetTransition", x, e);
	      }, x.setWrapperTranslate = function (e, a, t) {
	        var s = 0,
	            i = 0;x.isHorizontal() ? s = x.rtl ? -e : e : i = e, x.params.roundLengths && (s = r(s), i = r(i)), x.params.virtualTranslate || (x.support.transforms3d ? x.wrapper.transform("translate3d(" + s + "px, " + i + "px, 0px)") : x.wrapper.transform("translate(" + s + "px, " + i + "px)")), x.translate = x.isHorizontal() ? s : i;var n,
	            o = x.maxTranslate() - x.minTranslate();n = 0 === o ? 0 : (e - x.minTranslate()) / o, n !== x.progress && x.updateProgress(e), a && x.updateActiveIndex(), "slide" !== x.params.effect && x.effects[x.params.effect] && x.effects[x.params.effect].setTranslate(x.translate), x.params.parallax && x.parallax && x.parallax.setTranslate(x.translate), x.params.scrollbar && x.scrollbar && x.scrollbar.setTranslate(x.translate), x.params.control && x.controller && x.controller.setTranslate(x.translate, t), x.emit("onSetTranslate", x, x.translate);
	      }, x.getTranslate = function (e, a) {
	        var t, s, r, i;return void 0 === a && (a = "x"), x.params.virtualTranslate ? x.rtl ? -x.translate : x.translate : (r = window.getComputedStyle(e, null), window.WebKitCSSMatrix ? (s = r.transform || r.webkitTransform, s.split(",").length > 6 && (s = s.split(", ").map(function (e) {
	          return e.replace(",", ".");
	        }).join(", ")), i = new window.WebKitCSSMatrix("none" === s ? "" : s)) : (i = r.MozTransform || r.OTransform || r.MsTransform || r.msTransform || r.transform || r.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), t = i.toString().split(",")), "x" === a && (s = window.WebKitCSSMatrix ? i.m41 : 16 === t.length ? parseFloat(t[12]) : parseFloat(t[4])), "y" === a && (s = window.WebKitCSSMatrix ? i.m42 : 16 === t.length ? parseFloat(t[13]) : parseFloat(t[5])), x.rtl && s && (s = -s), s || 0);
	      }, x.getWrapperTranslate = function (e) {
	        return void 0 === e && (e = x.isHorizontal() ? "x" : "y"), x.getTranslate(x.wrapper[0], e);
	      }, x.observers = [], x.initObservers = function () {
	        if (x.params.observeParents) for (var e = x.container.parents(), a = 0; a < e.length; a++) {
	          o(e[a]);
	        }o(x.container[0], { childList: !1 }), o(x.wrapper[0], { attributes: !1 });
	      }, x.disconnectObservers = function () {
	        for (var e = 0; e < x.observers.length; e++) {
	          x.observers[e].disconnect();
	        }x.observers = [];
	      }, x.createLoop = function () {
	        x.wrapper.children("." + x.params.slideClass + "." + x.params.slideDuplicateClass).remove();var a = x.wrapper.children("." + x.params.slideClass);"auto" !== x.params.slidesPerView || x.params.loopedSlides || (x.params.loopedSlides = a.length), x.loopedSlides = parseInt(x.params.loopedSlides || x.params.slidesPerView, 10), x.loopedSlides = x.loopedSlides + x.params.loopAdditionalSlides, x.loopedSlides > a.length && (x.loopedSlides = a.length);var t,
	            s = [],
	            r = [];for (a.each(function (t, i) {
	          var n = e(this);t < x.loopedSlides && r.push(i), t < a.length && t >= a.length - x.loopedSlides && s.push(i), n.attr("data-swiper-slide-index", t);
	        }), t = 0; t < r.length; t++) {
	          x.wrapper.append(e(r[t].cloneNode(!0)).addClass(x.params.slideDuplicateClass));
	        }for (t = s.length - 1; t >= 0; t--) {
	          x.wrapper.prepend(e(s[t].cloneNode(!0)).addClass(x.params.slideDuplicateClass));
	        }
	      }, x.destroyLoop = function () {
	        x.wrapper.children("." + x.params.slideClass + "." + x.params.slideDuplicateClass).remove(), x.slides.removeAttr("data-swiper-slide-index");
	      }, x.reLoop = function (e) {
	        var a = x.activeIndex - x.loopedSlides;x.destroyLoop(), x.createLoop(), x.updateSlidesSize(), e && x.slideTo(a + x.loopedSlides, 0, !1);
	      }, x.fixLoop = function () {
	        var e;x.activeIndex < x.loopedSlides ? (e = x.slides.length - 3 * x.loopedSlides + x.activeIndex, e += x.loopedSlides, x.slideTo(e, 0, !1, !0)) : ("auto" === x.params.slidesPerView && x.activeIndex >= 2 * x.loopedSlides || x.activeIndex > x.slides.length - 2 * x.params.slidesPerView) && (e = -x.slides.length + x.activeIndex + x.loopedSlides, e += x.loopedSlides, x.slideTo(e, 0, !1, !0));
	      }, x.appendSlide = function (e) {
	        if (x.params.loop && x.destroyLoop(), "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e.length) for (var a = 0; a < e.length; a++) {
	          e[a] && x.wrapper.append(e[a]);
	        } else x.wrapper.append(e);x.params.loop && x.createLoop(), x.params.observer && x.support.observer || x.update(!0);
	      }, x.prependSlide = function (e) {
	        x.params.loop && x.destroyLoop();var a = x.activeIndex + 1;if ("object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e.length) {
	          for (var t = 0; t < e.length; t++) {
	            e[t] && x.wrapper.prepend(e[t]);
	          }a = x.activeIndex + e.length;
	        } else x.wrapper.prepend(e);x.params.loop && x.createLoop(), x.params.observer && x.support.observer || x.update(!0), x.slideTo(a, 0, !1);
	      }, x.removeSlide = function (e) {
	        x.params.loop && (x.destroyLoop(), x.slides = x.wrapper.children("." + x.params.slideClass));var a,
	            t = x.activeIndex;if ("object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e.length) {
	          for (var s = 0; s < e.length; s++) {
	            a = e[s], x.slides[a] && x.slides.eq(a).remove(), a < t && t--;
	          }t = Math.max(t, 0);
	        } else a = e, x.slides[a] && x.slides.eq(a).remove(), a < t && t--, t = Math.max(t, 0);x.params.loop && x.createLoop(), x.params.observer && x.support.observer || x.update(!0), x.params.loop ? x.slideTo(t + x.loopedSlides, 0, !1) : x.slideTo(t, 0, !1);
	      }, x.removeAllSlides = function () {
	        for (var e = [], a = 0; a < x.slides.length; a++) {
	          e.push(a);
	        }x.removeSlide(e);
	      }, x.effects = { fade: { setTranslate: function setTranslate() {
	            for (var e = 0; e < x.slides.length; e++) {
	              var a = x.slides.eq(e),
	                  t = a[0].swiperSlideOffset,
	                  s = -t;x.params.virtualTranslate || (s -= x.translate);var r = 0;x.isHorizontal() || (r = s, s = 0);var i = x.params.fade.crossFade ? Math.max(1 - Math.abs(a[0].progress), 0) : 1 + Math.min(Math.max(a[0].progress, -1), 0);a.css({ opacity: i }).transform("translate3d(" + s + "px, " + r + "px, 0px)");
	            }
	          }, setTransition: function setTransition(e) {
	            if (x.slides.transition(e), x.params.virtualTranslate && 0 !== e) {
	              var a = !1;x.slides.transitionEnd(function () {
	                if (!a && x) {
	                  a = !0, x.animating = !1;for (var e = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"], t = 0; t < e.length; t++) {
	                    x.wrapper.trigger(e[t]);
	                  }
	                }
	              });
	            }
	          } }, flip: { setTranslate: function setTranslate() {
	            for (var a = 0; a < x.slides.length; a++) {
	              var t = x.slides.eq(a),
	                  s = t[0].progress;x.params.flip.limitRotation && (s = Math.max(Math.min(t[0].progress, 1), -1));var r = t[0].swiperSlideOffset,
	                  i = -180 * s,
	                  n = i,
	                  o = 0,
	                  l = -r,
	                  p = 0;if (x.isHorizontal() ? x.rtl && (n = -n) : (p = l, l = 0, o = -n, n = 0), t[0].style.zIndex = -Math.abs(Math.round(s)) + x.slides.length, x.params.flip.slideShadows) {
	                var d = x.isHorizontal() ? t.find(".swiper-slide-shadow-left") : t.find(".swiper-slide-shadow-top"),
	                    m = x.isHorizontal() ? t.find(".swiper-slide-shadow-right") : t.find(".swiper-slide-shadow-bottom");0 === d.length && (d = e('<div class="swiper-slide-shadow-' + (x.isHorizontal() ? "left" : "top") + '"></div>'), t.append(d)), 0 === m.length && (m = e('<div class="swiper-slide-shadow-' + (x.isHorizontal() ? "right" : "bottom") + '"></div>'), t.append(m)), d.length && (d[0].style.opacity = Math.max(-s, 0)), m.length && (m[0].style.opacity = Math.max(s, 0));
	              }t.transform("translate3d(" + l + "px, " + p + "px, 0px) rotateX(" + o + "deg) rotateY(" + n + "deg)");
	            }
	          }, setTransition: function setTransition(a) {
	            if (x.slides.transition(a).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(a), x.params.virtualTranslate && 0 !== a) {
	              var t = !1;x.slides.eq(x.activeIndex).transitionEnd(function () {
	                if (!t && x && e(this).hasClass(x.params.slideActiveClass)) {
	                  t = !0, x.animating = !1;for (var a = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"], s = 0; s < a.length; s++) {
	                    x.wrapper.trigger(a[s]);
	                  }
	                }
	              });
	            }
	          } }, cube: { setTranslate: function setTranslate() {
	            var a,
	                t = 0;x.params.cube.shadow && (x.isHorizontal() ? (a = x.wrapper.find(".swiper-cube-shadow"), 0 === a.length && (a = e('<div class="swiper-cube-shadow"></div>'), x.wrapper.append(a)), a.css({ height: x.width + "px" })) : (a = x.container.find(".swiper-cube-shadow"), 0 === a.length && (a = e('<div class="swiper-cube-shadow"></div>'), x.container.append(a))));for (var s = 0; s < x.slides.length; s++) {
	              var r = x.slides.eq(s),
	                  i = 90 * s,
	                  n = Math.floor(i / 360);x.rtl && (i = -i, n = Math.floor(-i / 360));var o = Math.max(Math.min(r[0].progress, 1), -1),
	                  l = 0,
	                  p = 0,
	                  d = 0;s % 4 == 0 ? (l = 4 * -n * x.size, d = 0) : (s - 1) % 4 == 0 ? (l = 0, d = 4 * -n * x.size) : (s - 2) % 4 == 0 ? (l = x.size + 4 * n * x.size, d = x.size) : (s - 3) % 4 == 0 && (l = -x.size, d = 3 * x.size + 4 * x.size * n), x.rtl && (l = -l), x.isHorizontal() || (p = l, l = 0);var m = "rotateX(" + (x.isHorizontal() ? 0 : -i) + "deg) rotateY(" + (x.isHorizontal() ? i : 0) + "deg) translate3d(" + l + "px, " + p + "px, " + d + "px)";if (o <= 1 && o > -1 && (t = 90 * s + 90 * o, x.rtl && (t = 90 * -s - 90 * o)), r.transform(m), x.params.cube.slideShadows) {
	                var u = x.isHorizontal() ? r.find(".swiper-slide-shadow-left") : r.find(".swiper-slide-shadow-top"),
	                    c = x.isHorizontal() ? r.find(".swiper-slide-shadow-right") : r.find(".swiper-slide-shadow-bottom");0 === u.length && (u = e('<div class="swiper-slide-shadow-' + (x.isHorizontal() ? "left" : "top") + '"></div>'), r.append(u)), 0 === c.length && (c = e('<div class="swiper-slide-shadow-' + (x.isHorizontal() ? "right" : "bottom") + '"></div>'), r.append(c)), u.length && (u[0].style.opacity = Math.max(-o, 0)), c.length && (c[0].style.opacity = Math.max(o, 0));
	              }
	            }if (x.wrapper.css({ "-webkit-transform-origin": "50% 50% -" + x.size / 2 + "px", "-moz-transform-origin": "50% 50% -" + x.size / 2 + "px", "-ms-transform-origin": "50% 50% -" + x.size / 2 + "px", "transform-origin": "50% 50% -" + x.size / 2 + "px" }), x.params.cube.shadow) if (x.isHorizontal()) a.transform("translate3d(0px, " + (x.width / 2 + x.params.cube.shadowOffset) + "px, " + -x.width / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + x.params.cube.shadowScale + ")");else {
	              var g = Math.abs(t) - 90 * Math.floor(Math.abs(t) / 90),
	                  h = 1.5 - (Math.sin(2 * g * Math.PI / 360) / 2 + Math.cos(2 * g * Math.PI / 360) / 2),
	                  v = x.params.cube.shadowScale,
	                  f = x.params.cube.shadowScale / h,
	                  w = x.params.cube.shadowOffset;a.transform("scale3d(" + v + ", 1, " + f + ") translate3d(0px, " + (x.height / 2 + w) + "px, " + -x.height / 2 / f + "px) rotateX(-90deg)");
	            }var y = x.isSafari || x.isUiWebView ? -x.size / 2 : 0;x.wrapper.transform("translate3d(0px,0," + y + "px) rotateX(" + (x.isHorizontal() ? 0 : t) + "deg) rotateY(" + (x.isHorizontal() ? -t : 0) + "deg)");
	          }, setTransition: function setTransition(e) {
	            x.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), x.params.cube.shadow && !x.isHorizontal() && x.container.find(".swiper-cube-shadow").transition(e);
	          } }, coverflow: { setTranslate: function setTranslate() {
	            for (var a = x.translate, t = x.isHorizontal() ? -a + x.width / 2 : -a + x.height / 2, s = x.isHorizontal() ? x.params.coverflow.rotate : -x.params.coverflow.rotate, r = x.params.coverflow.depth, i = 0, n = x.slides.length; i < n; i++) {
	              var o = x.slides.eq(i),
	                  l = x.slidesSizesGrid[i],
	                  p = o[0].swiperSlideOffset,
	                  d = (t - p - l / 2) / l * x.params.coverflow.modifier,
	                  m = x.isHorizontal() ? s * d : 0,
	                  u = x.isHorizontal() ? 0 : s * d,
	                  c = -r * Math.abs(d),
	                  g = x.isHorizontal() ? 0 : x.params.coverflow.stretch * d,
	                  h = x.isHorizontal() ? x.params.coverflow.stretch * d : 0;Math.abs(h) < .001 && (h = 0), Math.abs(g) < .001 && (g = 0), Math.abs(c) < .001 && (c = 0), Math.abs(m) < .001 && (m = 0), Math.abs(u) < .001 && (u = 0);var v = "translate3d(" + h + "px," + g + "px," + c + "px)  rotateX(" + u + "deg) rotateY(" + m + "deg)";if (o.transform(v), o[0].style.zIndex = 1 - Math.abs(Math.round(d)), x.params.coverflow.slideShadows) {
	                var f = x.isHorizontal() ? o.find(".swiper-slide-shadow-left") : o.find(".swiper-slide-shadow-top"),
	                    w = x.isHorizontal() ? o.find(".swiper-slide-shadow-right") : o.find(".swiper-slide-shadow-bottom");0 === f.length && (f = e('<div class="swiper-slide-shadow-' + (x.isHorizontal() ? "left" : "top") + '"></div>'), o.append(f)), 0 === w.length && (w = e('<div class="swiper-slide-shadow-' + (x.isHorizontal() ? "right" : "bottom") + '"></div>'), o.append(w)), f.length && (f[0].style.opacity = d > 0 ? d : 0), w.length && (w[0].style.opacity = -d > 0 ? -d : 0);
	              }
	            }if (x.browser.ie) {
	              x.wrapper[0].style.perspectiveOrigin = t + "px 50%";
	            }
	          }, setTransition: function setTransition(e) {
	            x.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e);
	          } } }, x.lazy = { initialImageLoaded: !1, loadImageInSlide: function loadImageInSlide(a, t) {
	          if (void 0 !== a && (void 0 === t && (t = !0), 0 !== x.slides.length)) {
	            var s = x.slides.eq(a),
	                r = s.find("." + x.params.lazyLoadingClass + ":not(." + x.params.lazyStatusLoadedClass + "):not(." + x.params.lazyStatusLoadingClass + ")");!s.hasClass(x.params.lazyLoadingClass) || s.hasClass(x.params.lazyStatusLoadedClass) || s.hasClass(x.params.lazyStatusLoadingClass) || (r = r.add(s[0])), 0 !== r.length && r.each(function () {
	              var a = e(this);a.addClass(x.params.lazyStatusLoadingClass);var r = a.attr("data-background"),
	                  i = a.attr("data-src"),
	                  n = a.attr("data-srcset"),
	                  o = a.attr("data-sizes");x.loadImage(a[0], i || r, n, o, !1, function () {
	                if (void 0 !== x && null !== x && x) {
	                  if (r ? (a.css("background-image", 'url("' + r + '")'), a.removeAttr("data-background")) : (n && (a.attr("srcset", n), a.removeAttr("data-srcset")), o && (a.attr("sizes", o), a.removeAttr("data-sizes")), i && (a.attr("src", i), a.removeAttr("data-src"))), a.addClass(x.params.lazyStatusLoadedClass).removeClass(x.params.lazyStatusLoadingClass), s.find("." + x.params.lazyPreloaderClass + ", ." + x.params.preloaderClass).remove(), x.params.loop && t) {
	                    var e = s.attr("data-swiper-slide-index");if (s.hasClass(x.params.slideDuplicateClass)) {
	                      var l = x.wrapper.children('[data-swiper-slide-index="' + e + '"]:not(.' + x.params.slideDuplicateClass + ")");x.lazy.loadImageInSlide(l.index(), !1);
	                    } else {
	                      var p = x.wrapper.children("." + x.params.slideDuplicateClass + '[data-swiper-slide-index="' + e + '"]');x.lazy.loadImageInSlide(p.index(), !1);
	                    }
	                  }x.emit("onLazyImageReady", x, s[0], a[0]);
	                }
	              }), x.emit("onLazyImageLoad", x, s[0], a[0]);
	            });
	          }
	        }, load: function load() {
	          var a,
	              t = x.params.slidesPerView;if ("auto" === t && (t = 0), x.lazy.initialImageLoaded || (x.lazy.initialImageLoaded = !0), x.params.watchSlidesVisibility) x.wrapper.children("." + x.params.slideVisibleClass).each(function () {
	            x.lazy.loadImageInSlide(e(this).index());
	          });else if (t > 1) for (a = x.activeIndex; a < x.activeIndex + t; a++) {
	            x.slides[a] && x.lazy.loadImageInSlide(a);
	          } else x.lazy.loadImageInSlide(x.activeIndex);if (x.params.lazyLoadingInPrevNext) if (t > 1 || x.params.lazyLoadingInPrevNextAmount && x.params.lazyLoadingInPrevNextAmount > 1) {
	            var s = x.params.lazyLoadingInPrevNextAmount,
	                r = t,
	                i = Math.min(x.activeIndex + r + Math.max(s, r), x.slides.length),
	                n = Math.max(x.activeIndex - Math.max(r, s), 0);for (a = x.activeIndex + t; a < i; a++) {
	              x.slides[a] && x.lazy.loadImageInSlide(a);
	            }for (a = n; a < x.activeIndex; a++) {
	              x.slides[a] && x.lazy.loadImageInSlide(a);
	            }
	          } else {
	            var o = x.wrapper.children("." + x.params.slideNextClass);o.length > 0 && x.lazy.loadImageInSlide(o.index());var l = x.wrapper.children("." + x.params.slidePrevClass);l.length > 0 && x.lazy.loadImageInSlide(l.index());
	          }
	        }, onTransitionStart: function onTransitionStart() {
	          x.params.lazyLoading && (x.params.lazyLoadingOnTransitionStart || !x.params.lazyLoadingOnTransitionStart && !x.lazy.initialImageLoaded) && x.lazy.load();
	        }, onTransitionEnd: function onTransitionEnd() {
	          x.params.lazyLoading && !x.params.lazyLoadingOnTransitionStart && x.lazy.load();
	        } }, x.scrollbar = { isTouched: !1, setDragPosition: function setDragPosition(e) {
	          var a = x.scrollbar,
	              t = x.isHorizontal() ? "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX || e.clientX : "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY || e.clientY,
	              s = t - a.track.offset()[x.isHorizontal() ? "left" : "top"] - a.dragSize / 2,
	              r = -x.minTranslate() * a.moveDivider,
	              i = -x.maxTranslate() * a.moveDivider;s < r ? s = r : s > i && (s = i), s = -s / a.moveDivider, x.updateProgress(s), x.setWrapperTranslate(s, !0);
	        }, dragStart: function dragStart(e) {
	          var a = x.scrollbar;a.isTouched = !0, e.preventDefault(), e.stopPropagation(), a.setDragPosition(e), clearTimeout(a.dragTimeout), a.track.transition(0), x.params.scrollbarHide && a.track.css("opacity", 1), x.wrapper.transition(100), a.drag.transition(100), x.emit("onScrollbarDragStart", x);
	        }, dragMove: function dragMove(e) {
	          var a = x.scrollbar;a.isTouched && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, a.setDragPosition(e), x.wrapper.transition(0), a.track.transition(0), a.drag.transition(0), x.emit("onScrollbarDragMove", x));
	        }, dragEnd: function dragEnd(e) {
	          var a = x.scrollbar;a.isTouched && (a.isTouched = !1, x.params.scrollbarHide && (clearTimeout(a.dragTimeout), a.dragTimeout = setTimeout(function () {
	            a.track.css("opacity", 0), a.track.transition(400);
	          }, 1e3)), x.emit("onScrollbarDragEnd", x), x.params.scrollbarSnapOnRelease && x.slideReset());
	        }, draggableEvents: function () {
	          return x.params.simulateTouch !== !1 || x.support.touch ? x.touchEvents : x.touchEventsDesktop;
	        }(), enableDraggable: function enableDraggable() {
	          var a = x.scrollbar,
	              t = x.support.touch ? a.track : document;e(a.track).on(a.draggableEvents.start, a.dragStart), e(t).on(a.draggableEvents.move, a.dragMove), e(t).on(a.draggableEvents.end, a.dragEnd);
	        }, disableDraggable: function disableDraggable() {
	          var a = x.scrollbar,
	              t = x.support.touch ? a.track : document;e(a.track).off(a.draggableEvents.start, a.dragStart), e(t).off(a.draggableEvents.move, a.dragMove), e(t).off(a.draggableEvents.end, a.dragEnd);
	        }, set: function set() {
	          if (x.params.scrollbar) {
	            var a = x.scrollbar;a.track = e(x.params.scrollbar), x.params.uniqueNavElements && "string" == typeof x.params.scrollbar && a.track.length > 1 && 1 === x.container.find(x.params.scrollbar).length && (a.track = x.container.find(x.params.scrollbar)), a.drag = a.track.find(".swiper-scrollbar-drag"), 0 === a.drag.length && (a.drag = e('<div class="swiper-scrollbar-drag"></div>'), a.track.append(a.drag)), a.drag[0].style.width = "", a.drag[0].style.height = "", a.trackSize = x.isHorizontal() ? a.track[0].offsetWidth : a.track[0].offsetHeight, a.divider = x.size / x.virtualSize, a.moveDivider = a.divider * (a.trackSize / x.size), a.dragSize = a.trackSize * a.divider, x.isHorizontal() ? a.drag[0].style.width = a.dragSize + "px" : a.drag[0].style.height = a.dragSize + "px", a.divider >= 1 ? a.track[0].style.display = "none" : a.track[0].style.display = "", x.params.scrollbarHide && (a.track[0].style.opacity = 0);
	          }
	        }, setTranslate: function setTranslate() {
	          if (x.params.scrollbar) {
	            var e,
	                a = x.scrollbar,
	                t = (x.translate, a.dragSize);e = (a.trackSize - a.dragSize) * x.progress, x.rtl && x.isHorizontal() ? (e = -e, e > 0 ? (t = a.dragSize - e, e = 0) : -e + a.dragSize > a.trackSize && (t = a.trackSize + e)) : e < 0 ? (t = a.dragSize + e, e = 0) : e + a.dragSize > a.trackSize && (t = a.trackSize - e), x.isHorizontal() ? (x.support.transforms3d ? a.drag.transform("translate3d(" + e + "px, 0, 0)") : a.drag.transform("translateX(" + e + "px)"), a.drag[0].style.width = t + "px") : (x.support.transforms3d ? a.drag.transform("translate3d(0px, " + e + "px, 0)") : a.drag.transform("translateY(" + e + "px)"), a.drag[0].style.height = t + "px"), x.params.scrollbarHide && (clearTimeout(a.timeout), a.track[0].style.opacity = 1, a.timeout = setTimeout(function () {
	              a.track[0].style.opacity = 0, a.track.transition(400);
	            }, 1e3));
	          }
	        }, setTransition: function setTransition(e) {
	          x.params.scrollbar && x.scrollbar.drag.transition(e);
	        } }, x.controller = { LinearSpline: function LinearSpline(e, a) {
	          var t = function () {
	            var e, a, t;return function (s, r) {
	              for (a = -1, e = s.length; e - a > 1;) {
	                s[t = e + a >> 1] <= r ? a = t : e = t;
	              }return e;
	            };
	          }();this.x = e, this.y = a, this.lastIndex = e.length - 1;var s, r;this.x.length;this.interpolate = function (e) {
	            return e ? (r = t(this.x, e), s = r - 1, (e - this.x[s]) * (this.y[r] - this.y[s]) / (this.x[r] - this.x[s]) + this.y[s]) : 0;
	          };
	        }, getInterpolateFunction: function getInterpolateFunction(e) {
	          x.controller.spline || (x.controller.spline = x.params.loop ? new x.controller.LinearSpline(x.slidesGrid, e.slidesGrid) : new x.controller.LinearSpline(x.snapGrid, e.snapGrid));
	        }, setTranslate: function setTranslate(e, t) {
	          function s(a) {
	            e = a.rtl && "horizontal" === a.params.direction ? -x.translate : x.translate, "slide" === x.params.controlBy && (x.controller.getInterpolateFunction(a), i = -x.controller.spline.interpolate(-e)), i && "container" !== x.params.controlBy || (r = (a.maxTranslate() - a.minTranslate()) / (x.maxTranslate() - x.minTranslate()), i = (e - x.minTranslate()) * r + a.minTranslate()), x.params.controlInverse && (i = a.maxTranslate() - i), a.updateProgress(i), a.setWrapperTranslate(i, !1, x), a.updateActiveIndex();
	          }var r,
	              i,
	              n = x.params.control;if (Array.isArray(n)) for (var o = 0; o < n.length; o++) {
	            n[o] !== t && n[o] instanceof a && s(n[o]);
	          } else n instanceof a && t !== n && s(n);
	        }, setTransition: function setTransition(e, t) {
	          function s(a) {
	            a.setWrapperTransition(e, x), 0 !== e && (a.onTransitionStart(), a.wrapper.transitionEnd(function () {
	              i && (a.params.loop && "slide" === x.params.controlBy && a.fixLoop(), a.onTransitionEnd());
	            }));
	          }var r,
	              i = x.params.control;if (Array.isArray(i)) for (r = 0; r < i.length; r++) {
	            i[r] !== t && i[r] instanceof a && s(i[r]);
	          } else i instanceof a && t !== i && s(i);
	        } }, x.hashnav = { onHashCange: function onHashCange(e, a) {
	          var t = document.location.hash.replace("#", "");t !== x.slides.eq(x.activeIndex).attr("data-hash") && x.slideTo(x.wrapper.children("." + x.params.slideClass + '[data-hash="' + t + '"]').index());
	        }, attachEvents: function attachEvents(a) {
	          var t = a ? "off" : "on";e(window)[t]("hashchange", x.hashnav.onHashCange);
	        }, setHash: function setHash() {
	          if (x.hashnav.initialized && x.params.hashnav) if (x.params.replaceState && window.history && window.history.replaceState) window.history.replaceState(null, null, "#" + x.slides.eq(x.activeIndex).attr("data-hash") || "");else {
	            var e = x.slides.eq(x.activeIndex),
	                a = e.attr("data-hash") || e.attr("data-history");document.location.hash = a || "";
	          }
	        }, init: function init() {
	          if (x.params.hashnav && !x.params.history) {
	            x.hashnav.initialized = !0;var e = document.location.hash.replace("#", "");if (e) for (var a = 0, t = x.slides.length; a < t; a++) {
	              var s = x.slides.eq(a),
	                  r = s.attr("data-hash") || s.attr("data-history");if (r === e && !s.hasClass(x.params.slideDuplicateClass)) {
	                var i = s.index();x.slideTo(i, 0, x.params.runCallbacksOnInit, !0);
	              }
	            }x.params.hashnavWatchState && x.hashnav.attachEvents();
	          }
	        }, destroy: function destroy() {
	          x.params.hashnavWatchState && x.hashnav.attachEvents(!0);
	        } }, x.history = { init: function init() {
	          if (x.params.history) {
	            if (!window.history || !window.history.pushState) return x.params.history = !1, void (x.params.hashnav = !0);x.history.initialized = !0, this.paths = this.getPathValues(), (this.paths.key || this.paths.value) && (this.scrollToSlide(0, this.paths.value, x.params.runCallbacksOnInit), x.params.replaceState || window.addEventListener("popstate", this.setHistoryPopState));
	          }
	        }, setHistoryPopState: function setHistoryPopState() {
	          x.history.paths = x.history.getPathValues(), x.history.scrollToSlide(x.params.speed, x.history.paths.value, !1);
	        }, getPathValues: function getPathValues() {
	          var e = window.location.pathname.slice(1).split("/"),
	              a = e.length;return { key: e[a - 2], value: e[a - 1] };
	        }, setHistory: function setHistory(e, a) {
	          if (x.history.initialized && x.params.history) {
	            var t = x.slides.eq(a),
	                s = this.slugify(t.attr("data-history"));window.location.pathname.includes(e) || (s = e + "/" + s), x.params.replaceState ? window.history.replaceState(null, null, s) : window.history.pushState(null, null, s);
	          }
	        }, slugify: function slugify(e) {
	          return e.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
	        }, scrollToSlide: function scrollToSlide(e, a, t) {
	          if (a) for (var s = 0, r = x.slides.length; s < r; s++) {
	            var i = x.slides.eq(s),
	                n = this.slugify(i.attr("data-history"));if (n === a && !i.hasClass(x.params.slideDuplicateClass)) {
	              var o = i.index();x.slideTo(o, e, t);
	            }
	          } else x.slideTo(0, e, t);
	        } }, x.disableKeyboardControl = function () {
	        x.params.keyboardControl = !1, e(document).off("keydown", l);
	      }, x.enableKeyboardControl = function () {
	        x.params.keyboardControl = !0, e(document).on("keydown", l);
	      }, x.mousewheel = { event: !1, lastScrollTime: new window.Date().getTime() }, x.params.mousewheelControl && (x.mousewheel.event = navigator.userAgent.indexOf("firefox") > -1 ? "DOMMouseScroll" : function () {
	        var e = "onwheel" in document;if (!e) {
	          var a = document.createElement("div");a.setAttribute("onwheel", "return;"), e = "function" == typeof a.onwheel;
	        }return !e && document.implementation && document.implementation.hasFeature && document.implementation.hasFeature("", "") !== !0 && (e = document.implementation.hasFeature("Events.wheel", "3.0")), e;
	      }() ? "wheel" : "mousewheel"), x.disableMousewheelControl = function () {
	        if (!x.mousewheel.event) return !1;var a = x.container;return "container" !== x.params.mousewheelEventsTarged && (a = e(x.params.mousewheelEventsTarged)), a.off(x.mousewheel.event, d), x.params.mousewheelControl = !1, !0;
	      }, x.enableMousewheelControl = function () {
	        if (!x.mousewheel.event) return !1;var a = x.container;return "container" !== x.params.mousewheelEventsTarged && (a = e(x.params.mousewheelEventsTarged)), a.on(x.mousewheel.event, d), x.params.mousewheelControl = !0, !0;
	      }, x.parallax = { setTranslate: function setTranslate() {
	          x.container.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function () {
	            m(this, x.progress);
	          }), x.slides.each(function () {
	            var a = e(this);a.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function () {
	              m(this, Math.min(Math.max(a[0].progress, -1), 1));
	            });
	          });
	        }, setTransition: function setTransition(a) {
	          void 0 === a && (a = x.params.speed), x.container.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function () {
	            var t = e(this),
	                s = parseInt(t.attr("data-swiper-parallax-duration"), 10) || a;0 === a && (s = 0), t.transition(s);
	          });
	        } }, x.zoom = { scale: 1, currentScale: 1, isScaling: !1, gesture: { slide: void 0, slideWidth: void 0, slideHeight: void 0, image: void 0, imageWrap: void 0, zoomMax: x.params.zoomMax }, image: { isTouched: void 0, isMoved: void 0, currentX: void 0, currentY: void 0, minX: void 0, minY: void 0, maxX: void 0, maxY: void 0, width: void 0, height: void 0, startX: void 0, startY: void 0, touchesStart: {}, touchesCurrent: {} }, velocity: { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 }, getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
	          if (e.targetTouches.length < 2) return 1;var a = e.targetTouches[0].pageX,
	              t = e.targetTouches[0].pageY,
	              s = e.targetTouches[1].pageX,
	              r = e.targetTouches[1].pageY;return Math.sqrt(Math.pow(s - a, 2) + Math.pow(r - t, 2));
	        }, onGestureStart: function onGestureStart(a) {
	          var t = x.zoom;if (!x.support.gestures) {
	            if ("touchstart" !== a.type || "touchstart" === a.type && a.targetTouches.length < 2) return;t.gesture.scaleStart = t.getDistanceBetweenTouches(a);
	          }if (!(t.gesture.slide && t.gesture.slide.length || (t.gesture.slide = e(this), 0 === t.gesture.slide.length && (t.gesture.slide = x.slides.eq(x.activeIndex)), t.gesture.image = t.gesture.slide.find("img, svg, canvas"), t.gesture.imageWrap = t.gesture.image.parent("." + x.params.zoomContainerClass), t.gesture.zoomMax = t.gesture.imageWrap.attr("data-swiper-zoom") || x.params.zoomMax, 0 !== t.gesture.imageWrap.length))) return void (t.gesture.image = void 0);t.gesture.image.transition(0), t.isScaling = !0;
	        }, onGestureChange: function onGestureChange(e) {
	          var a = x.zoom;if (!x.support.gestures) {
	            if ("touchmove" !== e.type || "touchmove" === e.type && e.targetTouches.length < 2) return;a.gesture.scaleMove = a.getDistanceBetweenTouches(e);
	          }a.gesture.image && 0 !== a.gesture.image.length && (x.support.gestures ? a.scale = e.scale * a.currentScale : a.scale = a.gesture.scaleMove / a.gesture.scaleStart * a.currentScale, a.scale > a.gesture.zoomMax && (a.scale = a.gesture.zoomMax - 1 + Math.pow(a.scale - a.gesture.zoomMax + 1, .5)), a.scale < x.params.zoomMin && (a.scale = x.params.zoomMin + 1 - Math.pow(x.params.zoomMin - a.scale + 1, .5)), a.gesture.image.transform("translate3d(0,0,0) scale(" + a.scale + ")"));
	        }, onGestureEnd: function onGestureEnd(e) {
	          var a = x.zoom;!x.support.gestures && ("touchend" !== e.type || "touchend" === e.type && e.changedTouches.length < 2) || a.gesture.image && 0 !== a.gesture.image.length && (a.scale = Math.max(Math.min(a.scale, a.gesture.zoomMax), x.params.zoomMin), a.gesture.image.transition(x.params.speed).transform("translate3d(0,0,0) scale(" + a.scale + ")"), a.currentScale = a.scale, a.isScaling = !1, 1 === a.scale && (a.gesture.slide = void 0));
	        }, onTouchStart: function onTouchStart(e, a) {
	          var t = e.zoom;t.gesture.image && 0 !== t.gesture.image.length && (t.image.isTouched || ("android" === e.device.os && a.preventDefault(), t.image.isTouched = !0, t.image.touchesStart.x = "touchstart" === a.type ? a.targetTouches[0].pageX : a.pageX, t.image.touchesStart.y = "touchstart" === a.type ? a.targetTouches[0].pageY : a.pageY));
	        }, onTouchMove: function onTouchMove(e) {
	          var a = x.zoom;if (a.gesture.image && 0 !== a.gesture.image.length && (x.allowClick = !1, a.image.isTouched && a.gesture.slide)) {
	            a.image.isMoved || (a.image.width = a.gesture.image[0].offsetWidth, a.image.height = a.gesture.image[0].offsetHeight, a.image.startX = x.getTranslate(a.gesture.imageWrap[0], "x") || 0, a.image.startY = x.getTranslate(a.gesture.imageWrap[0], "y") || 0, a.gesture.slideWidth = a.gesture.slide[0].offsetWidth, a.gesture.slideHeight = a.gesture.slide[0].offsetHeight, a.gesture.imageWrap.transition(0), x.rtl && (a.image.startX = -a.image.startX), x.rtl && (a.image.startY = -a.image.startY));var t = a.image.width * a.scale,
	                s = a.image.height * a.scale;if (!(t < a.gesture.slideWidth && s < a.gesture.slideHeight)) {
	              if (a.image.minX = Math.min(a.gesture.slideWidth / 2 - t / 2, 0), a.image.maxX = -a.image.minX, a.image.minY = Math.min(a.gesture.slideHeight / 2 - s / 2, 0), a.image.maxY = -a.image.minY, a.image.touchesCurrent.x = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX, a.image.touchesCurrent.y = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY, !a.image.isMoved && !a.isScaling) {
	                if (x.isHorizontal() && Math.floor(a.image.minX) === Math.floor(a.image.startX) && a.image.touchesCurrent.x < a.image.touchesStart.x || Math.floor(a.image.maxX) === Math.floor(a.image.startX) && a.image.touchesCurrent.x > a.image.touchesStart.x) return void (a.image.isTouched = !1);if (!x.isHorizontal() && Math.floor(a.image.minY) === Math.floor(a.image.startY) && a.image.touchesCurrent.y < a.image.touchesStart.y || Math.floor(a.image.maxY) === Math.floor(a.image.startY) && a.image.touchesCurrent.y > a.image.touchesStart.y) return void (a.image.isTouched = !1);
	              }e.preventDefault(), e.stopPropagation(), a.image.isMoved = !0, a.image.currentX = a.image.touchesCurrent.x - a.image.touchesStart.x + a.image.startX, a.image.currentY = a.image.touchesCurrent.y - a.image.touchesStart.y + a.image.startY, a.image.currentX < a.image.minX && (a.image.currentX = a.image.minX + 1 - Math.pow(a.image.minX - a.image.currentX + 1, .8)), a.image.currentX > a.image.maxX && (a.image.currentX = a.image.maxX - 1 + Math.pow(a.image.currentX - a.image.maxX + 1, .8)), a.image.currentY < a.image.minY && (a.image.currentY = a.image.minY + 1 - Math.pow(a.image.minY - a.image.currentY + 1, .8)), a.image.currentY > a.image.maxY && (a.image.currentY = a.image.maxY - 1 + Math.pow(a.image.currentY - a.image.maxY + 1, .8)), a.velocity.prevPositionX || (a.velocity.prevPositionX = a.image.touchesCurrent.x), a.velocity.prevPositionY || (a.velocity.prevPositionY = a.image.touchesCurrent.y), a.velocity.prevTime || (a.velocity.prevTime = Date.now()), a.velocity.x = (a.image.touchesCurrent.x - a.velocity.prevPositionX) / (Date.now() - a.velocity.prevTime) / 2, a.velocity.y = (a.image.touchesCurrent.y - a.velocity.prevPositionY) / (Date.now() - a.velocity.prevTime) / 2, Math.abs(a.image.touchesCurrent.x - a.velocity.prevPositionX) < 2 && (a.velocity.x = 0), Math.abs(a.image.touchesCurrent.y - a.velocity.prevPositionY) < 2 && (a.velocity.y = 0), a.velocity.prevPositionX = a.image.touchesCurrent.x, a.velocity.prevPositionY = a.image.touchesCurrent.y, a.velocity.prevTime = Date.now(), a.gesture.imageWrap.transform("translate3d(" + a.image.currentX + "px, " + a.image.currentY + "px,0)");
	            }
	          }
	        }, onTouchEnd: function onTouchEnd(e, a) {
	          var t = e.zoom;if (t.gesture.image && 0 !== t.gesture.image.length) {
	            if (!t.image.isTouched || !t.image.isMoved) return t.image.isTouched = !1, void (t.image.isMoved = !1);t.image.isTouched = !1, t.image.isMoved = !1;var s = 300,
	                r = 300,
	                i = t.velocity.x * s,
	                n = t.image.currentX + i,
	                o = t.velocity.y * r,
	                l = t.image.currentY + o;0 !== t.velocity.x && (s = Math.abs((n - t.image.currentX) / t.velocity.x)), 0 !== t.velocity.y && (r = Math.abs((l - t.image.currentY) / t.velocity.y));var p = Math.max(s, r);t.image.currentX = n, t.image.currentY = l;var d = t.image.width * t.scale,
	                m = t.image.height * t.scale;t.image.minX = Math.min(t.gesture.slideWidth / 2 - d / 2, 0), t.image.maxX = -t.image.minX, t.image.minY = Math.min(t.gesture.slideHeight / 2 - m / 2, 0), t.image.maxY = -t.image.minY, t.image.currentX = Math.max(Math.min(t.image.currentX, t.image.maxX), t.image.minX), t.image.currentY = Math.max(Math.min(t.image.currentY, t.image.maxY), t.image.minY), t.gesture.imageWrap.transition(p).transform("translate3d(" + t.image.currentX + "px, " + t.image.currentY + "px,0)");
	          }
	        }, onTransitionEnd: function onTransitionEnd(e) {
	          var a = e.zoom;a.gesture.slide && e.previousIndex !== e.activeIndex && (a.gesture.image.transform("translate3d(0,0,0) scale(1)"), a.gesture.imageWrap.transform("translate3d(0,0,0)"), a.gesture.slide = a.gesture.image = a.gesture.imageWrap = void 0, a.scale = a.currentScale = 1);
	        }, toggleZoom: function toggleZoom(a, t) {
	          var s = a.zoom;if (s.gesture.slide || (s.gesture.slide = a.clickedSlide ? e(a.clickedSlide) : a.slides.eq(a.activeIndex), s.gesture.image = s.gesture.slide.find("img, svg, canvas"), s.gesture.imageWrap = s.gesture.image.parent("." + a.params.zoomContainerClass)), s.gesture.image && 0 !== s.gesture.image.length) {
	            var r, i, n, o, l, p, d, m, u, c, g, h, v, f, w, y, x, T;void 0 === s.image.touchesStart.x && t ? (r = "touchend" === t.type ? t.changedTouches[0].pageX : t.pageX, i = "touchend" === t.type ? t.changedTouches[0].pageY : t.pageY) : (r = s.image.touchesStart.x, i = s.image.touchesStart.y), s.scale && 1 !== s.scale ? (s.scale = s.currentScale = 1, s.gesture.imageWrap.transition(300).transform("translate3d(0,0,0)"), s.gesture.image.transition(300).transform("translate3d(0,0,0) scale(1)"), s.gesture.slide = void 0) : (s.scale = s.currentScale = s.gesture.imageWrap.attr("data-swiper-zoom") || a.params.zoomMax, t ? (x = s.gesture.slide[0].offsetWidth, T = s.gesture.slide[0].offsetHeight, n = s.gesture.slide.offset().left, o = s.gesture.slide.offset().top, l = n + x / 2 - r, p = o + T / 2 - i, u = s.gesture.image[0].offsetWidth, c = s.gesture.image[0].offsetHeight, g = u * s.scale, h = c * s.scale, v = Math.min(x / 2 - g / 2, 0), f = Math.min(T / 2 - h / 2, 0), w = -v, y = -f, d = l * s.scale, m = p * s.scale, d < v && (d = v), d > w && (d = w), m < f && (m = f), m > y && (m = y)) : (d = 0, m = 0), s.gesture.imageWrap.transition(300).transform("translate3d(" + d + "px, " + m + "px,0)"), s.gesture.image.transition(300).transform("translate3d(0,0,0) scale(" + s.scale + ")"));
	          }
	        }, attachEvents: function attachEvents(a) {
	          var t = a ? "off" : "on";if (x.params.zoom) {
	            var s = (x.slides, !("touchstart" !== x.touchEvents.start || !x.support.passiveListener || !x.params.passiveListeners) && { passive: !0, capture: !1 });x.support.gestures ? (x.slides[t]("gesturestart", x.zoom.onGestureStart, s), x.slides[t]("gesturechange", x.zoom.onGestureChange, s), x.slides[t]("gestureend", x.zoom.onGestureEnd, s)) : "touchstart" === x.touchEvents.start && (x.slides[t](x.touchEvents.start, x.zoom.onGestureStart, s), x.slides[t](x.touchEvents.move, x.zoom.onGestureChange, s), x.slides[t](x.touchEvents.end, x.zoom.onGestureEnd, s)), x[t]("touchStart", x.zoom.onTouchStart), x.slides.each(function (a, s) {
	              e(s).find("." + x.params.zoomContainerClass).length > 0 && e(s)[t](x.touchEvents.move, x.zoom.onTouchMove);
	            }), x[t]("touchEnd", x.zoom.onTouchEnd), x[t]("transitionEnd", x.zoom.onTransitionEnd), x.params.zoomToggle && x.on("doubleTap", x.zoom.toggleZoom);
	          }
	        }, init: function init() {
	          x.zoom.attachEvents();
	        }, destroy: function destroy() {
	          x.zoom.attachEvents(!0);
	        } }, x._plugins = [];for (var Y in x.plugins) {
	        var A = x.plugins[Y](x, x.params[Y]);A && x._plugins.push(A);
	      }return x.callPlugins = function (e) {
	        for (var a = 0; a < x._plugins.length; a++) {
	          e in x._plugins[a] && x._plugins[a][e](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	        }
	      }, x.emitterEventListeners = {}, x.emit = function (e) {
	        x.params[e] && x.params[e](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);var a;if (x.emitterEventListeners[e]) for (a = 0; a < x.emitterEventListeners[e].length; a++) {
	          x.emitterEventListeners[e][a](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	        }x.callPlugins && x.callPlugins(e, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	      }, x.on = function (e, a) {
	        return e = u(e), x.emitterEventListeners[e] || (x.emitterEventListeners[e] = []), x.emitterEventListeners[e].push(a), x;
	      }, x.off = function (e, a) {
	        var t;if (e = u(e), void 0 === a) return x.emitterEventListeners[e] = [], x;if (x.emitterEventListeners[e] && 0 !== x.emitterEventListeners[e].length) {
	          for (t = 0; t < x.emitterEventListeners[e].length; t++) {
	            x.emitterEventListeners[e][t] === a && x.emitterEventListeners[e].splice(t, 1);
	          }return x;
	        }
	      }, x.once = function (e, a) {
	        e = u(e);var t = function t() {
	          a(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]), x.off(e, t);
	        };return x.on(e, t), x;
	      }, x.a11y = { makeFocusable: function makeFocusable(e) {
	          return e.attr("tabIndex", "0"), e;
	        }, addRole: function addRole(e, a) {
	          return e.attr("role", a), e;
	        }, addLabel: function addLabel(e, a) {
	          return e.attr("aria-label", a), e;
	        }, disable: function disable(e) {
	          return e.attr("aria-disabled", !0), e;
	        }, enable: function enable(e) {
	          return e.attr("aria-disabled", !1), e;
	        }, onEnterKey: function onEnterKey(a) {
	          13 === a.keyCode && (e(a.target).is(x.params.nextButton) ? (x.onClickNext(a), x.isEnd ? x.a11y.notify(x.params.lastSlideMessage) : x.a11y.notify(x.params.nextSlideMessage)) : e(a.target).is(x.params.prevButton) && (x.onClickPrev(a), x.isBeginning ? x.a11y.notify(x.params.firstSlideMessage) : x.a11y.notify(x.params.prevSlideMessage)), e(a.target).is("." + x.params.bulletClass) && e(a.target)[0].click());
	        }, liveRegion: e('<span class="' + x.params.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>'), notify: function notify(e) {
	          var a = x.a11y.liveRegion;0 !== a.length && (a.html(""), a.html(e));
	        }, init: function init() {
	          x.params.nextButton && x.nextButton && x.nextButton.length > 0 && (x.a11y.makeFocusable(x.nextButton), x.a11y.addRole(x.nextButton, "button"), x.a11y.addLabel(x.nextButton, x.params.nextSlideMessage)), x.params.prevButton && x.prevButton && x.prevButton.length > 0 && (x.a11y.makeFocusable(x.prevButton), x.a11y.addRole(x.prevButton, "button"), x.a11y.addLabel(x.prevButton, x.params.prevSlideMessage)), e(x.container).append(x.a11y.liveRegion);
	        }, initPagination: function initPagination() {
	          x.params.pagination && x.params.paginationClickable && x.bullets && x.bullets.length && x.bullets.each(function () {
	            var a = e(this);x.a11y.makeFocusable(a), x.a11y.addRole(a, "button"), x.a11y.addLabel(a, x.params.paginationBulletMessage.replace(/{{index}}/, a.index() + 1));
	          });
	        }, destroy: function destroy() {
	          x.a11y.liveRegion && x.a11y.liveRegion.length > 0 && x.a11y.liveRegion.remove();
	        } }, x.init = function () {
	        x.params.loop && x.createLoop(), x.updateContainerSize(), x.updateSlidesSize(), x.updatePagination(), x.params.scrollbar && x.scrollbar && (x.scrollbar.set(), x.params.scrollbarDraggable && x.scrollbar.enableDraggable()), "slide" !== x.params.effect && x.effects[x.params.effect] && (x.params.loop || x.updateProgress(), x.effects[x.params.effect].setTranslate()), x.params.loop ? x.slideTo(x.params.initialSlide + x.loopedSlides, 0, x.params.runCallbacksOnInit) : (x.slideTo(x.params.initialSlide, 0, x.params.runCallbacksOnInit), 0 === x.params.initialSlide && (x.parallax && x.params.parallax && x.parallax.setTranslate(), x.lazy && x.params.lazyLoading && (x.lazy.load(), x.lazy.initialImageLoaded = !0))), x.attachEvents(), x.params.observer && x.support.observer && x.initObservers(), x.params.preloadImages && !x.params.lazyLoading && x.preloadImages(), x.params.zoom && x.zoom && x.zoom.init(), x.params.autoplay && x.startAutoplay(), x.params.keyboardControl && x.enableKeyboardControl && x.enableKeyboardControl(), x.params.mousewheelControl && x.enableMousewheelControl && x.enableMousewheelControl(), x.params.hashnavReplaceState && (x.params.replaceState = x.params.hashnavReplaceState), x.params.history && x.history && x.history.init(), x.params.hashnav && x.hashnav && x.hashnav.init(), x.params.a11y && x.a11y && x.a11y.init(), x.emit("onInit", x);
	      }, x.cleanupStyles = function () {
	        x.container.removeClass(x.classNames.join(" ")).removeAttr("style"), x.wrapper.removeAttr("style"), x.slides && x.slides.length && x.slides.removeClass([x.params.slideVisibleClass, x.params.slideActiveClass, x.params.slideNextClass, x.params.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-column").removeAttr("data-swiper-row"), x.paginationContainer && x.paginationContainer.length && x.paginationContainer.removeClass(x.params.paginationHiddenClass), x.bullets && x.bullets.length && x.bullets.removeClass(x.params.bulletActiveClass), x.params.prevButton && e(x.params.prevButton).removeClass(x.params.buttonDisabledClass), x.params.nextButton && e(x.params.nextButton).removeClass(x.params.buttonDisabledClass), x.params.scrollbar && x.scrollbar && (x.scrollbar.track && x.scrollbar.track.length && x.scrollbar.track.removeAttr("style"), x.scrollbar.drag && x.scrollbar.drag.length && x.scrollbar.drag.removeAttr("style"));
	      }, x.destroy = function (e, a) {
	        x.detachEvents(), x.stopAutoplay(), x.params.scrollbar && x.scrollbar && x.params.scrollbarDraggable && x.scrollbar.disableDraggable(), x.params.loop && x.destroyLoop(), a && x.cleanupStyles(), x.disconnectObservers(), x.params.zoom && x.zoom && x.zoom.destroy(), x.params.keyboardControl && x.disableKeyboardControl && x.disableKeyboardControl(), x.params.mousewheelControl && x.disableMousewheelControl && x.disableMousewheelControl(), x.params.a11y && x.a11y && x.a11y.destroy(), x.params.history && !x.params.replaceState && window.removeEventListener("popstate", x.history.setHistoryPopState), x.params.hashnav && x.hashnav && x.hashnav.destroy(), x.emit("onDestroy"), e !== !1 && (x = null);
	      }, x.init(), x;
	    }
	  };a.prototype = { isSafari: function () {
	      var e = window.navigator.userAgent.toLowerCase();return e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0;
	    }(), isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent), isArray: function isArray(e) {
	      return "[object Array]" === Object.prototype.toString.apply(e);
	    }, browser: { ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled, ieTouch: window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1 || window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1, lteIE9: function () {
	        var e = document.createElement("div");return e.innerHTML = "<!--[if lte IE 9]><i></i><![endif]-->", 1 === e.getElementsByTagName("i").length;
	      }() }, device: function () {
	      var e = window.navigator.userAgent,
	          a = e.match(/(Android);?[\s\/]+([\d.]+)?/),
	          t = e.match(/(iPad).*OS\s([\d_]+)/),
	          s = e.match(/(iPod)(.*OS\s([\d_]+))?/),
	          r = !t && e.match(/(iPhone\sOS|iOS)\s([\d_]+)/);return { ios: t || r || s, android: a };
	    }(), support: { touch: window.Modernizr && Modernizr.touch === !0 || function () {
	        return !!("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
	      }(), transforms3d: window.Modernizr && Modernizr.csstransforms3d === !0 || function () {
	        var e = document.createElement("div").style;return "webkitPerspective" in e || "MozPerspective" in e || "OPerspective" in e || "MsPerspective" in e || "perspective" in e;
	      }(), flexbox: function () {
	        for (var e = document.createElement("div").style, a = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "), t = 0; t < a.length; t++) {
	          if (a[t] in e) return !0;
	        }
	      }(), observer: function () {
	        return "MutationObserver" in window || "WebkitMutationObserver" in window;
	      }(), passiveListener: function () {
	        var e = !1;try {
	          var a = Object.defineProperty({}, "passive", { get: function get() {
	              e = !0;
	            } });window.addEventListener("testPassiveListener", null, a);
	        } catch (e) {}return e;
	      }(), gestures: function () {
	        return "ongesturestart" in window;
	      }() }, plugins: {} };for (var t = ["jQuery", "Zepto", "Dom7"], s = 0; s < t.length; s++) {
	    window[t[s]] && function (e) {
	      e.fn.swiper = function (t) {
	        var s;return e(this).each(function () {
	          var e = new a(this, t);s || (s = e);
	        }), s;
	      };
	    }(window[t[s]]);
	  }var r;r = "undefined" == typeof Dom7 ? window.Dom7 || window.Zepto || window.jQuery : Dom7, r && ("transitionEnd" in r.fn || (r.fn.transitionEnd = function (e) {
	    function a(i) {
	      if (i.target === this) for (e.call(this, i), t = 0; t < s.length; t++) {
	        r.off(s[t], a);
	      }
	    }var t,
	        s = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"],
	        r = this;if (e) for (t = 0; t < s.length; t++) {
	      r.on(s[t], a);
	    }return this;
	  }), "transform" in r.fn || (r.fn.transform = function (e) {
	    for (var a = 0; a < this.length; a++) {
	      var t = this[a].style;t.webkitTransform = t.MsTransform = t.msTransform = t.MozTransform = t.OTransform = t.transform = e;
	    }return this;
	  }), "transition" in r.fn || (r.fn.transition = function (e) {
	    "string" != typeof e && (e += "ms");for (var a = 0; a < this.length; a++) {
	      var t = this[a].style;t.webkitTransitionDuration = t.MsTransitionDuration = t.msTransitionDuration = t.MozTransitionDuration = t.OTransitionDuration = t.transitionDuration = e;
	    }return this;
	  }), "outerWidth" in r.fn || (r.fn.outerWidth = function (e) {
	    return this.length > 0 ? e ? this[0].offsetWidth + parseFloat(this.css("margin-right")) + parseFloat(this.css("margin-left")) : this[0].offsetWidth : null;
	  })), window.Swiper = a;
	}(),  true ? module.exports = window.Swiper : "function" == typeof define && define.amd && define([], function () {
	  "use strict";
	  return window.Swiper;
	});
	//# sourceMappingURL=maps/swiper.jquery.min.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	"use strict";
	
	// Generated by CoffeeScript 1.6.2
	/**
	@license Sticky-kit v1.1.3 | WTFPL | Leaf Corcoran 2015 | http://leafo.net
	*/
	
	(function () {
	  var $, win;
	
	  $ = window.jQuery;
	
	  win = $(window);
	
	  $.fn.stick_in_parent = function (opts) {
	    var doc, elm, enable_bottoming, inner_scrolling, manual_spacer, offset_top, outer_width, parent_selector, recalc_every, sticky_class, _fn, _i, _len;
	
	    if (opts == null) {
	      opts = {};
	    }
	    sticky_class = opts.sticky_class, inner_scrolling = opts.inner_scrolling, recalc_every = opts.recalc_every, parent_selector = opts.parent, offset_top = opts.offset_top, manual_spacer = opts.spacer, enable_bottoming = opts.bottoming;
	    if (offset_top == null) {
	      offset_top = 0;
	    }
	    if (parent_selector == null) {
	      parent_selector = void 0;
	    }
	    if (inner_scrolling == null) {
	      inner_scrolling = true;
	    }
	    if (sticky_class == null) {
	      sticky_class = "is_stuck";
	    }
	    doc = $(document);
	    if (enable_bottoming == null) {
	      enable_bottoming = true;
	    }
	    outer_width = function outer_width(el) {
	      var computed, w, _el;
	
	      if (window.getComputedStyle) {
	        _el = el[0];
	        computed = window.getComputedStyle(el[0]);
	        w = parseFloat(computed.getPropertyValue("width")) + parseFloat(computed.getPropertyValue("margin-left")) + parseFloat(computed.getPropertyValue("margin-right"));
	        if (computed.getPropertyValue("box-sizing") !== "border-box") {
	          w += parseFloat(computed.getPropertyValue("border-left-width")) + parseFloat(computed.getPropertyValue("border-right-width")) + parseFloat(computed.getPropertyValue("padding-left")) + parseFloat(computed.getPropertyValue("padding-right"));
	        }
	        return w;
	      } else {
	        return el.outerWidth(true);
	      }
	    };
	    _fn = function _fn(elm, padding_bottom, parent_top, parent_height, top, height, el_float, detached) {
	      var bottomed, _detach, fixed, last_pos, last_scroll_height, offset, parent, recalc, recalc_and_tick, recalc_counter, spacer, tick;
	
	      if (elm.data("sticky_kit")) {
	        return;
	      }
	      elm.data("sticky_kit", true);
	      last_scroll_height = doc.height();
	      parent = elm.parent();
	      if (parent_selector != null) {
	        parent = parent.closest(parent_selector);
	      }
	      if (!parent.length) {
	        throw "failed to find stick parent";
	      }
	      fixed = false;
	      bottomed = false;
	      spacer = manual_spacer != null ? manual_spacer && elm.closest(manual_spacer) : $("<div />");
	      if (spacer) {
	        spacer.css('position', elm.css('position'));
	      }
	      recalc = function recalc() {
	        var border_top, padding_top, restore;
	
	        if (detached) {
	          return;
	        }
	        last_scroll_height = doc.height();
	        border_top = parseInt(parent.css("border-top-width"), 10);
	        padding_top = parseInt(parent.css("padding-top"), 10);
	        padding_bottom = parseInt(parent.css("padding-bottom"), 10);
	        parent_top = parent.offset().top + border_top + padding_top;
	        parent_height = parent.height();
	        if (fixed) {
	          fixed = false;
	          bottomed = false;
	          if (manual_spacer == null) {
	            spacer.detach();
	          }
	          elm.css({
	            position: "",
	            top: "",
	            width: "",
	            bottom: ""
	          }).removeClass(sticky_class);
	          restore = true;
	        }
	        top = elm.offset().top - (parseInt(elm.css("margin-top"), 10) || 0) - offset_top;
	        height = elm.outerHeight(true);
	        el_float = elm.css("float");
	        if (spacer) {
	          spacer.css({
	            width: outer_width(elm),
	            height: height,
	            display: elm.css("display"),
	            "vertical-align": elm.css("vertical-align"),
	            "float": el_float
	          });
	        }
	        if (restore) {
	          return tick();
	        }
	      };
	      recalc();
	      if (height === parent_height) {
	        return;
	      }
	      last_pos = void 0;
	      offset = offset_top;
	      recalc_counter = recalc_every;
	      tick = function tick() {
	        var css, delta, recalced, scroll, will_bottom, win_height;
	
	        if (detached) {
	          return;
	        }
	        recalced = false;
	        if (recalc_counter != null) {
	          recalc_counter -= 1;
	          if (recalc_counter <= 0) {
	            recalc_counter = recalc_every;
	            recalc();
	            recalced = true;
	          }
	        }
	        if (!recalced && doc.height() !== last_scroll_height) {
	          recalc();
	          recalced = true;
	        }
	        scroll = win.scrollTop();
	        if (last_pos != null) {
	          delta = scroll - last_pos;
	        }
	        last_pos = scroll;
	        if (fixed) {
	          if (enable_bottoming) {
	            will_bottom = scroll + height + offset > parent_height + parent_top;
	            if (bottomed && !will_bottom) {
	              bottomed = false;
	              elm.css({
	                position: "fixed",
	                bottom: "",
	                top: offset
	              }).trigger("sticky_kit:unbottom");
	            }
	          }
	          if (scroll < top) {
	            fixed = false;
	            offset = offset_top;
	            if (manual_spacer == null) {
	              if (el_float === "left" || el_float === "right") {
	                elm.insertAfter(spacer);
	              }
	              spacer.detach();
	            }
	            css = {
	              position: "",
	              width: "",
	              top: ""
	            };
	            elm.css(css).removeClass(sticky_class).trigger("sticky_kit:unstick");
	          }
	          if (inner_scrolling) {
	            win_height = win.height();
	            if (height + offset_top > win_height) {
	              if (!bottomed) {
	                offset -= delta;
	                offset = Math.max(win_height - height, offset);
	                offset = Math.min(offset_top, offset);
	                if (fixed) {
	                  elm.css({
	                    top: offset + "px"
	                  });
	                }
	              }
	            }
	          }
	        } else {
	          if (scroll > top) {
	            fixed = true;
	            css = {
	              position: "fixed",
	              top: offset
	            };
	            css.width = elm.css("box-sizing") === "border-box" ? elm.outerWidth() + "px" : elm.width() + "px";
	            elm.css(css).addClass(sticky_class);
	            if (manual_spacer == null) {
	              elm.after(spacer);
	              if (el_float === "left" || el_float === "right") {
	                spacer.append(elm);
	              }
	            }
	            elm.trigger("sticky_kit:stick");
	          }
	        }
	        if (fixed && enable_bottoming) {
	          if (will_bottom == null) {
	            will_bottom = scroll + height + offset > parent_height + parent_top;
	          }
	          if (!bottomed && will_bottom) {
	            bottomed = true;
	            if (parent.css("position") === "static") {
	              parent.css({
	                position: "relative"
	              });
	            }
	            return elm.css({
	              position: "absolute",
	              bottom: padding_bottom,
	              top: "auto"
	            }).trigger("sticky_kit:bottom");
	          }
	        }
	      };
	      recalc_and_tick = function recalc_and_tick() {
	        recalc();
	        return tick();
	      };
	      _detach = function detach() {
	        detached = true;
	        win.off("touchmove", tick);
	        win.off("scroll", tick);
	        win.off("resize", recalc_and_tick);
	        $(document.body).off("sticky_kit:recalc", recalc_and_tick);
	        elm.off("sticky_kit:detach", _detach);
	        elm.removeData("sticky_kit");
	        elm.css({
	          position: "",
	          bottom: "",
	          top: "",
	          width: ""
	        });
	        parent.position("position", "");
	        if (fixed) {
	          if (manual_spacer == null) {
	            if (el_float === "left" || el_float === "right") {
	              elm.insertAfter(spacer);
	            }
	            spacer.remove();
	          }
	          return elm.removeClass(sticky_class);
	        }
	      };
	      win.on("touchmove", tick);
	      win.on("scroll", tick);
	      win.on("resize", recalc_and_tick);
	      $(document.body).on("sticky_kit:recalc", recalc_and_tick);
	      elm.on("sticky_kit:detach", _detach);
	      return setTimeout(tick, 0);
	    };
	    for (_i = 0, _len = this.length; _i < _len; _i++) {
	      elm = this[_i];
	      _fn($(elm));
	    }
	    return this;
	  };
	}).call(undefined);

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import $ from 'jquery';
	
	var NAME = 'scrollProgress',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME],
	    INIT_DELAY = 500;
	
	var _bar$, _window$, _doc$;
	
	var ScrollProgress = function () {
	  function ScrollProgress(element$) {
	    var _this = this;
	
	    _classCallCheck(this, ScrollProgress);
	
	    _bar$ = element$.children();
	    _window$ = $(window);
	    _doc$ = $(document);
	    _window$.scroll(this.onScroll.bind(this));
	    setTimeout(function () {
	      return _this.onScroll();
	    }, INIT_DELAY);
	  }
	
	  _createClass(ScrollProgress, [{
	    key: 'onScroll',
	    value: function onScroll() {
	      var progressWidth, scrollHeight, scrollTop;
	
	      scrollHeight = _doc$.height();
	      scrollTop = _window$.scrollTop();
	      progressWidth = Math.round(scrollTop * 100 / (scrollHeight - window.innerHeight));
	
	      _bar$.css('width', progressWidth + '%');
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() {
	      return this.each(function () {
	        new ScrollProgress($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return ScrollProgress;
	}();
	
	$.fn[NAME] = ScrollProgress._jQueryInterface;
	$.fn[NAME].Constructor = ScrollProgress;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return ScrollProgress._jQueryInterface;
	};
	
	exports.default = ScrollProgress;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import $ from 'jquery';
	
	var NAME = 'shareSelection',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME],
	    TEMPLATE_HEIGHT = 90,
	    DISTANCE_ABOVE = 115,
	    NEW_WINDOW_TOP = 125,
	    NEW_WINDOW_WIDTH = 500,
	    NEW_WINDOW_LEFT = _calcLeftPosition(),
	    NEW_WINDOW_HEIGHT = 350,
	    NEW_WINDOW_TOOLBAR = 0,
	    NEW_WINDOW_MENUBAR = 0,
	    NEW_WINDOW_TITLEBAR = 0,
	    NEW_WINDOW_STATUS = 0,
	    OPEN_LINK_TYPE = 'popup',
	    OPEN_LINK_OPTS = 'top=' + NEW_WINDOW_TOP + ', width=' + NEW_WINDOW_WIDTH + ', left=' + NEW_WINDOW_LEFT + ', height=' + NEW_WINDOW_HEIGHT + ', toolbar=' + NEW_WINDOW_TOOLBAR + ', menubar=' + NEW_WINDOW_MENUBAR + ', titlebar=' + NEW_WINDOW_TITLEBAR + ', status=' + NEW_WINDOW_STATUS,
	    FACEBOOK = 'facebook',
	    FACEBOOK_CLASS = 'voc-facebook-share',
	    TWITTER = 'twitter',
	    TWITTER_CLASS = 'voc-twitter-share',
	    TEMPLATE = '\n    <div class="voc-select-tooltip">\n      <a title="' + FACEBOOK + '" class="' + FACEBOOK_CLASS + '"><i class="voc-icons facebook"></i></a>\n      <a title="' + TWITTER + '" class="' + TWITTER_CLASS + '"><i class="voc-icons twitter"></i></a>\n    </div>\n  ';
	
	var _selector$, _lastText;
	
	var ShareSelection = function () {
	  function ShareSelection(element$, _ref) {
	    var offset_top = _ref.offset_top;
	
	    _classCallCheck(this, ShareSelection);
	
	    element$.on('mouseup', 'p', this.onMouseUp.bind(this));
	    this.headerHeight = offset_top;
	  }
	
	  _createClass(ShareSelection, [{
	    key: 'onMouseUp',
	    value: function onMouseUp(event) {
	      this.selection = this.getSelected();
	      this.text = this.selection.toString().trim();
	      this.mouseX = event.pageX;
	      this.mouseY = event.pageY;
	      this.window$ = $(window);
	
	      if (this.text && this.text !== _lastText) {
	        _lastText = this.text;
	        this.showSelector();
	      } else if (_selector$) {
	        _selector$.hide();
	      }
	    }
	  }, {
	    key: 'showSelector',
	    value: function showSelector() {
	      if (!_selector$) {
	        this.renderSelector();
	      }
	
	      this.setShareUrl(this.text);
	
	      if (this.window$.scrollTop() + this.headerHeight + TEMPLATE_HEIGHT > this.mouseY) {
	        this.mouseY = this.mouseY + DISTANCE_ABOVE;
	        _selector$.addClass('voc-above');
	      } else {
	        _selector$.removeClass('voc-above');
	      }
	
	      _selector$.css('top', this.mouseY).css('left', this.mouseX).show();
	    }
	  }, {
	    key: 'renderSelector',
	    value: function renderSelector() {
	      _selector$ = $(TEMPLATE);
	      $('body').append(_selector$);
	    }
	  }, {
	    key: 'setShareUrl',
	    value: function setShareUrl(text) {
	      var _this = this;
	
	      var multiEdition = this.checkMultiedition();
	
	      _selector$.find('.' + FACEBOOK_CLASS).on('click', function () {
	        window.open('//www.facebook.com/sharer.php?u=' + encodeURIComponent(window.location.href) + multiEdition + '&quote=' + encodeURIComponent(text), OPEN_LINK_TYPE, OPEN_LINK_OPTS);
	      });
	      _selector$.find('.' + TWITTER_CLASS).on('click', function () {
	        var twitterUser = _this.checkTwitterUser();
	        window.open('//twitter.com/share?url=' + encodeURIComponent(window.location.href) + multiEdition + '&text=' + encodeURIComponent(text) + twitterUser, OPEN_LINK_TYPE, OPEN_LINK_OPTS);
	      });
	    }
	  }, {
	    key: 'checkMultiedition',
	    value: function checkMultiedition() {
	      var editions = Voonto.getInstance().lookup('vocento.site.editions');
	      return editions.hasEditions ? '?' + editions.queryString + '=' + editions.current : '';
	    }
	  }, {
	    key: 'checkTwitterUser',
	    value: function checkTwitterUser() {
	      var username = document.querySelector('meta[name="twitter:site"]');
	      return username && username.content ? '&via=' + username.content.slice(1) : '';
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected() {
	      var selection;
	
	      if (window.getSelection) {
	        selection = window.getSelection();
	      } else if (document.getSelection) {
	        selection = document.getSelection();
	      } else if (document.selection) {
	        selection = document.selection.createRange().text;
	      }
	
	      return selection;
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(options) {
	      return this.each(function () {
	        new ShareSelection($(this), options);
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return ShareSelection;
	}();
	
	$.fn[NAME] = ShareSelection._jQueryInterface;
	$.fn[NAME].Constructor = ShareSelection;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return ShareSelection._jQueryInterface;
	};
	
	exports.default = ShareSelection;
	
	/* Private */
	
	function _calcLeftPosition() {
	  return screen.width / 2 - NEW_WINDOW_WIDTH / 2;
	}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //import $ from 'jquery';
	
	
	var _constants = __webpack_require__(17);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'anchorDisplacement',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME],
	    ANIMATION_SPEED = 1000;
	
	var AnchorDisplacement = function () {
	  function AnchorDisplacement(element$) {
	    _classCallCheck(this, AnchorDisplacement);
	
	    this.hash = element$[0].hash.slice(1);
	
	    if (this.hash) {
	      this.target$ = $('[name=\'' + this.hash + '\']');
	      if (this.target$.length) {
	        element$.on('click', this.onClick.bind(this));
	      }
	    }
	  }
	
	  _createClass(AnchorDisplacement, [{
	    key: 'onClick',
	    value: function onClick() /*event*/{
	      var headerHeight = 0;
	      $(_constants.HEADER_SELECTOR).children().each(function () {
	        headerHeight = headerHeight + $(this).height();
	      });
	
	      $('html, body').animate({
	        scrollTop: this.target$.offset().top - headerHeight
	      }, ANIMATION_SPEED);
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(options) {
	      return this.each(function () {
	        new AnchorDisplacement($(this), options);
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return AnchorDisplacement;
	}();
	
	$.fn[NAME] = AnchorDisplacement._jQueryInterface;
	$.fn[NAME].Constructor = AnchorDisplacement;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return AnchorDisplacement._jQueryInterface;
	};
	
	exports.default = AnchorDisplacement;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//import $ from 'jquery';
	
	var HEADER_SELECTOR = exports.HEADER_SELECTOR = '.main-header';
	var EDITION_COOKIE = exports.EDITION_COOKIE = 'voc_edtn';
	var COOKIE_DOMAIN = exports.COOKIE_DOMAIN = '.' + Voonto.getInstance().lookup('vocento.site').tlddomain;
	var EDITION_COOKIE_OPTIONS = exports.EDITION_COOKIE_OPTIONS = { domain: COOKIE_DOMAIN, path: '/', expires: 7 };
	
	var SWIPER_DEFAULTS = exports.SWIPER_DEFAULTS = {
	  pagination: '.swiper-pagination',
	  nextButton: '.swiper-button-next',
	  prevButton: '.swiper-button-prev',
	  slidesPerView: 4,
	  centeredSlides: false,
	  paginationClickable: true,
	  spaceBetween: 0,
	  grabCursor: true,
	  preloadImages: false,
	  lazyLoading: true,
	  loop: true,
	  breakpoints: {
	    // when window width is <= 700px
	    700: {
	      effect: 'coverflow',
	      grabCursor: true,
	      centeredSlides: true,
	      slidesPerView: 2,
	      coverflow: {
	        stretch: 0,
	        depth: 100,
	        modifier: 1
	      }
	    }
	  }
	};
	
	var SWIPER_FRACTION = exports.SWIPER_FRACTION = $.extend({}, SWIPER_DEFAULTS, {
	  keyboardControl: true,
	  slidesPerView: 1,
	  paginationType: 'fraction',
	  loop: false,
	  paginationFractionRender: function paginationFractionRender(swiper, currentClassName, totalClassName) {
	    return '<span class="' + currentClassName + '"></span>' + ' de ' + '<span class="' + totalClassName + '"></span>';
	  },
	  breakpoints: {
	    700: {
	      centeredSlides: false,
	      slidesPerView: 1
	    }
	  }
	});
	
	var SWIPER_2ROWS = exports.SWIPER_2ROWS = $.extend({}, SWIPER_DEFAULTS, {
	  breakpoints: {
	    700: {
	      centeredSlides: false,
	      loop: false,
	      pagination: '.swiper-pagination',
	      slidesPerView: 2,
	      slidesPerColumn: 2
	    }
	  }
	});
	
	var SWIPER_AUTO = exports.SWIPER_AUTO = $.extend({}, SWIPER_DEFAULTS, {
	  slidesPerView: 'auto',
	  breakpoints: {
	    700: {
	      centeredSlides: false,
	      slidesPerView: 'auto',
	      grabCursor: true
	    }
	  }
	});
	
	var SWIPER_ADV = exports.SWIPER_ADV = $.extend({}, SWIPER_DEFAULTS, {
	  slidesPerView: 2.2,
	  noSwipingClass: '.swiper-container',
	  breakpoints: {
	    1900: {
	      slidesPerView: 5,
	      spaceBetween: 0,
	      simulateTouch: false,
	      noSwiping: true
	    },
	    700: {
	      spaceBetween: 1,
	      noSwiping: false
	    }
	  }
	});
	
	var SWIPER_NAV = exports.SWIPER_NAV = $.extend({}, SWIPER_DEFAULTS, {
	  slidesPerView: 1,
	  pagination: '.club-pagination',
	  noSwipingClass: '.swiper-container',
	  breakpoints: {
	    1900: {
	      slidesPerView: 3,
	      spaceBetween: 20,
	      simulateTouch: false,
	      paginationClickable: false,
	      noSwiping: true
	    },
	    800: {
	      slidesPerView: 3,
	      simulateTouch: false,
	      spaceBetween: 30,
	      paginationClickable: false,
	      noSwiping: true
	    },
	    700: {
	      spaceBetween: 100,
	      noSwiping: false,
	      paginationClickable: true
	    }
	  }
	});
	
	var SWIPER_ON_PLUS = exports.SWIPER_ON_PLUS = $.extend({}, SWIPER_DEFAULTS, {
	  slidesPerView: 3,
	  spaceBetween: 12,
	  breakpoints: {
	    1039: {
	      slidesPerView: 2
	    },
	    700: {
	      slidesPerView: 1
	    }
	  }
	});
	
	var SCROLL_HANDLER = exports.SCROLL_HANDLER = 'ontouchmove' in document.documentElement ? 'touchmove' : 'scroll';
	var WINDOW_DELIMITER_WIDTH = exports.WINDOW_DELIMITER_WIDTH = 700;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'gotoHomeBubble',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME],
	    CLASS = 'voc-alert-number--fade-in',
	    DELAY_TIMES = [2000, 10000, 30000, 45000],
	    SESSION_KEY = 'squido-goto-home-bubble-rendered';
	
	var GotoHomeBubble = function () {
	  function GotoHomeBubble(element$) {
	    _classCallCheck(this, GotoHomeBubble);
	
	    this._element$ = element$;
	    setTimeout(this.addClass.bind(this), _randomTimeout.call(this));
	  }
	
	  _createClass(GotoHomeBubble, [{
	    key: 'addClass',
	    value: function addClass() {
	      if ('sessionStorage' in window) {
	        if (window.sessionStorage.getItem(SESSION_KEY)) {
	          window.sessionStorage.removeItem(SESSION_KEY);
	        } else {
	          this._element$.addClass(CLASS);
	          window.sessionStorage.setItem(SESSION_KEY, 'true');
	        }
	      }
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() /*config*/{
	      return this.each(function () {
	        new GotoHomeBubble($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return GotoHomeBubble;
	}();
	
	$.fn[NAME] = GotoHomeBubble._jQueryInterface;
	$.fn[NAME].Constructor = GotoHomeBubble;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return GotoHomeBubble._jQueryInterface;
	};
	
	exports.default = GotoHomeBubble;
	
	/* Private */
	
	function _randomTimeout() {
	  // NOTE returns a random element from the DELAY_TIMES array
	  return DELAY_TIMES[Math.floor(Math.random() * DELAY_TIMES.length)];
	}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(17);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'animatedUnderline',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var AnimatedUnderline = function () {
	  function AnimatedUnderline(element$) {
	    var _this = this;
	
	    _classCallCheck(this, AnimatedUnderline);
	
	    this._element$ = element$;
	    this._underline$ = element$.find('.voc-underline');
	    this._scrollable$ = element$.find('.voc-scrollable');
	
	    if (_elementExists(element$.find('.voc-active')) && _elementExists(this._underline$)) {
	      this._activeEl$ = element$.find('.voc-active');
	
	      this._elementAttr = this._element$.data().vocAnimatedUnderline;
	
	      //NOTE: Scroll to active element if it's to the right of centre
	      if (_isNotMobile() || this._elementAttr == 'allDevices') {
	        var windowHalfWidth = $(window).width() / 2;
	        var actElHalfWidth = this._activeEl$.width() / 2;
	        var maxActElLeftPos = windowHalfWidth - actElHalfWidth;
	        var actElLeftPos = this._activeEl$.offset().left;
	
	        if (actElLeftPos > maxActElLeftPos) {
	          this._scrollable$.scrollLeft(actElLeftPos - windowHalfWidth + actElHalfWidth);
	
	          if (_elementExists(this._element$.find('.dropdown'))) {
	            for (var i = 0; i < this._element$.find('.dropdown').length; i++) {
	              var ddElement$ = this._element$.find('.dropdown')[i];
	              var ddElLeftPos = $(ddElement$).offset().left;
	              var ddMenu$ = $(ddElement$).find('.dropdown-menu');
	
	              ddMenu$.css('left', ddElLeftPos + 12 + 'px');
	            }
	          }
	        }
	      }
	
	      // NOTE: Assign width and left properties to the underline element
	      this._activeElWidth = this._activeEl$.width();
	      this._activeElLeft = this._activeEl$.position().left + parseInt(this._activeEl$.css('marginLeft'));
	      this.positioningUnderline();
	
	      if (_isNotMobile() || this._elementAttr == 'allDevices') {
	        element$.on('mouseover', 'a', function (e) {
	          return _this.onMouseOver(e);
	        });
	        element$.on('mouseleave', function (e) {
	          return _this.onMouseOut(e);
	        });
	        $('body').on('click', function (e) {
	          return _this.onClick(e);
	        });
	      }
	
	      $(window).on('resize', function (e) {
	        return _this.onResize(e);
	      });
	    }
	  }
	
	  _createClass(AnimatedUnderline, [{
	    key: 'positioningUnderline',
	    value: function positioningUnderline(width, left) {
	      this._underline$.css({
	        width: (width ? width : this._activeElWidth) + 'px',
	        left: (left ? left : this._activeElLeft) + 'px'
	      });
	    }
	  }, {
	    key: 'onMouseOver',
	    value: function onMouseOver(event) {
	      if (!$('.dropdown.open').length) {
	        var target = void 0,
	            elWidth = void 0,
	            elLeft = void 0;
	
	        target = event.target;
	
	        if (target.nodeName === 'A') {
	          var dropdownParent = $(target).closest('.dropdown');
	
	          elWidth = target.offsetWidth;
	          elLeft = target.offsetLeft;
	
	          if (dropdownParent.length) {
	            elWidth = dropdownParent.find('.dropdown-toggle').width();
	            elLeft = dropdownParent.find('.dropdown-toggle').position().left;
	          }
	
	          this.positioningUnderline(elWidth, elLeft);
	        }
	      }
	    }
	  }, {
	    key: 'onMouseOut',
	    value: function onMouseOut() /*event*/{
	      if (!$('.dropdown.open').length) {
	        this.positioningUnderline();
	      }
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(event) {
	      if (!$(event.target).closest(this._element$).length) {
	        this.positioningUnderline();
	      }
	    }
	  }, {
	    key: 'onResize',
	    value: function onResize() /*event*/{
	      if (this._element$.find('.voc-active')) {
	        //NOTE: Scroll to active element if it's to the right of centre
	        if (_isNotMobile() || this._elementAttr == 'allDevices') {
	          var windowHalfWidth = $(window).width() / 2;
	          var actElHalfWidth = this._activeEl$.width() / 2;
	          var maxActElLeftPos = windowHalfWidth - actElHalfWidth;
	          var actElLeftPos = this._activeEl$.offset().left;
	
	          if (actElLeftPos > maxActElLeftPos) {
	            this._scrollable$.scrollLeft(actElLeftPos - windowHalfWidth + actElHalfWidth);
	
	            if (_elementExists(this._element$.find('.dropdown'))) {
	              for (var i = 0; i < this._element$.find('.dropdown').length; i++) {
	                var ddElement$ = this._element$.find('.dropdown')[i];
	                var ddElLeftPos = $(ddElement$).offset().left;
	                var ddMenu$ = $(ddElement$).find('.dropdown-menu');
	
	                ddMenu$.css('left', ddElLeftPos + 12 + 'px');
	              }
	            }
	          }
	        }
	
	        this._activeElWidth = this._activeEl$.width();
	        this._activeElLeft = this._activeEl$.position().left + parseInt(this._activeEl$.css('marginLeft'));
	        this.positioningUnderline();
	      }
	
	      if (_elementExists(this._underline$) && _isNotMobile()) {
	        this._element$.on('mouseover', 'a', this.onMouseOver.bind(this));
	        this._element$.on('mouseleave', this.onMouseOut.bind(this));
	      } else {
	        this._element$.off('mouseover');
	        this._element$.off('mouseleave');
	      }
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() {
	      return this.each(function () {
	        new AnimatedUnderline($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return AnimatedUnderline;
	}();
	
	$.fn[NAME] = AnimatedUnderline._jQueryInterface;
	$.fn[NAME].Constructor = AnimatedUnderline;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return AnimatedUnderline._jQueryInterface;
	};
	
	exports.default = AnimatedUnderline;
	
	/* Private  */
	
	function _elementExists(element$) {
	  return element$.length;
	}
	
	function _isNotMobile() {
	  return window.innerWidth >= _constants.WINDOW_DELIMITER_WIDTH;
	}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import $ from 'jquery';
	
	var NAME = 'collapseBootstrapMenus',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME],
	    NAVBAR_OPENED_SELECTOR = '.collapse.in',
	    CLOSE_CLASS = 'close-x',
	    HIDE = 'hide',
	    COMMENTS_CLASS = 'voc-comments-container';
	
	var CollapseBootstrapMenus = function () {
	  function CollapseBootstrapMenus(element$) {
	    _classCallCheck(this, CollapseBootstrapMenus);
	
	    this._element$ = element$;
	    element$.on('click', this.onClick.bind(this));
	  }
	
	  _createClass(CollapseBootstrapMenus, [{
	    key: 'onClick',
	    value: function onClick(event) {
	      var navbar$, clickOver$, clickInside$;
	
	      navbar$ = this._element$.find(NAVBAR_OPENED_SELECTOR);
	      clickOver$ = $(event.target);
	      clickInside$ = $(clickOver$).closest(navbar$).length;
	
	      if ((!clickInside$ || clickOver$.hasClass(CLOSE_CLASS)) && !navbar$.hasClass(COMMENTS_CLASS)) {
	        navbar$.collapse(HIDE);
	      }
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() {
	      return this.each(function () {
	        new CollapseBootstrapMenus($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return CollapseBootstrapMenus;
	}();
	
	$.fn[NAME] = CollapseBootstrapMenus._jQueryInterface;
	$.fn[NAME].Constructor = CollapseBootstrapMenus;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return CollapseBootstrapMenus._jQueryInterface;
	};
	
	exports.default = CollapseBootstrapMenus;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(17);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'arrowsDisplay',
	    VERSION = '1.1.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME],
	    THROTTLE_INTERVAL = 400,
	    // NOTE: Interval in miliseconds to execute the scroll event callback
	_window$ = $(window);
	
	var _lastScrollTop = 0;
	
	/**
	 * Plugin to show Next and Back arrows on the left and right sides of page, when the
	 * user are scrolling up on page
	 */
	
	var ArrowsDisplay = function () {
	  function ArrowsDisplay(element$, options) {
	    var _this = this;
	
	    _classCallCheck(this, ArrowsDisplay);
	
	    this._target$ = element$.find('a');
	    this._options = options;
	    this._overlapElement = $(this._options.hideOverlapClass).first();
	
	    _window$.on('scroll', _.throttle(function (e) {
	      return _this.onScroll(e);
	    }, THROTTLE_INTERVAL));
	  }
	
	  _createClass(ArrowsDisplay, [{
	    key: 'onScroll',
	    value: function onScroll() /*event*/{
	      var scrollTop;
	
	      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	
	      if (!_isMobileWidth() || _isMobileWidth() && _areArrowsOverlappingElement(scrollTop, this._overlapElement)) {
	        if (scrollTop > _lastScrollTop) {
	          // NOTE: Downscroll code
	          this._target$.removeClass('voc-active');
	        } else {
	          // NOTE: Upscroll code
	          this._target$.addClass('voc-active');
	        }
	
	        _lastScrollTop = scrollTop;
	      } else {
	        // NOTE: Hide arrows when they are overlapping the element with hideOverlapClass
	        this._target$.removeClass('voc-active');
	      }
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(options) {
	      return this.each(function () {
	        new ArrowsDisplay($(this), options);
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return ArrowsDisplay;
	}();
	
	$.fn[NAME] = ArrowsDisplay._jQueryInterface;
	$.fn[NAME].Constructor = ArrowsDisplay;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return ArrowsDisplay._jQueryInterface;
	};
	
	exports.default = ArrowsDisplay;
	
	/* Private methods */
	
	/**
	 *  Check if the width of window is a mobile width
	 */
	
	function _isMobileWidth() {
	  return window.innerWidth <= _constants.WINDOW_DELIMITER_WIDTH;
	}
	
	/**
	 *  Check if the arrows are overlapping the elements passed in options
	 */
	function _areArrowsOverlappingElement(scrollTop, element$) {
	  return element$.length && scrollTop < element$.offset().top - window.innerHeight / 2;
	}

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*!
	 * Infinite Ajax Scroll v2.2.2
	 * A jQuery plugin for infinite scrolling
	 * http://infiniteajaxscroll.com
	 *
	 * Commercial use requires one-time purchase of a commercial license
	 * http://infiniteajaxscroll.com/docs/license.html
	 *
	 * Non-commercial use is licensed under the MIT License
	 *
	 * Copyright (c) 2016 Webcreate (Jeroen Fiege)
	 */
	var IASCallbacks = function IASCallbacks(a) {
	  return this.list = [], this.fireStack = [], this.isFiring = !1, this.isDisabled = !1, this.fire = function (a) {
	    var b = a[0],
	        c = a[1],
	        d = a[2];this.isFiring = !0;for (var e = 0, f = this.list.length; f > e; e++) {
	      if (void 0 != this.list[e] && !1 === this.list[e].fn.apply(b, d)) {
	        c.reject();break;
	      }
	    }this.isFiring = !1, c.resolve(), this.fireStack.length && this.fire(this.fireStack.shift());
	  }, this.inList = function (a, b) {
	    b = b || 0;for (var c = b, d = this.list.length; d > c; c++) {
	      if (this.list[c].fn === a || a.guid && this.list[c].fn.guid && a.guid === this.list[c].fn.guid) return c;
	    }return -1;
	  }, this;
	};IASCallbacks.prototype = { add: function add(a, b) {
	    var c = { fn: a, priority: b };b = b || 0;for (var d = 0, e = this.list.length; e > d; d++) {
	      if (b > this.list[d].priority) return this.list.splice(d, 0, c), this;
	    }return this.list.push(c), this;
	  }, remove: function remove(a) {
	    for (var b = 0; (b = this.inList(a, b)) > -1;) {
	      this.list.splice(b, 1);
	    }return this;
	  }, has: function has(a) {
	    return this.inList(a) > -1;
	  }, fireWith: function fireWith(a, b) {
	    var c = $.Deferred();return this.isDisabled ? c.reject() : (b = b || [], b = [a, c, b.slice ? b.slice() : b], this.isFiring ? this.fireStack.push(b) : this.fire(b), c);
	  }, disable: function disable() {
	    this.isDisabled = !0;
	  }, enable: function enable() {
	    this.isDisabled = !1;
	  } }, function (a) {
	  "use strict";
	  var b = -1,
	      c = function c(_c, d) {
	    return this.itemsContainerSelector = d.container, this.itemSelector = d.item, this.nextSelector = d.next, this.paginationSelector = d.pagination, this.$scrollContainer = _c, this.$container = window === _c.get(0) ? a(document) : _c, this.defaultDelay = d.delay, this.negativeMargin = d.negativeMargin, this.nextUrl = null, this.isBound = !1, this.isPaused = !1, this.isInitialized = !1, this.jsXhr = !1, this.listeners = { next: new IASCallbacks(a), load: new IASCallbacks(a), loaded: new IASCallbacks(a), render: new IASCallbacks(a), rendered: new IASCallbacks(a), scroll: new IASCallbacks(a), noneLeft: new IASCallbacks(a), ready: new IASCallbacks(a) }, this.extensions = [], this.scrollHandler = function () {
	      if (this.isBound && !this.isPaused) {
	        var a = this.getCurrentScrollOffset(this.$scrollContainer),
	            c = this.getScrollThreshold();b != c && (this.fire("scroll", [a, c]), a >= c && this.next());
	      }
	    }, this.getItemsContainer = function () {
	      return a(this.itemsContainerSelector, this.$container);
	    }, this.getLastItem = function () {
	      return a(this.itemSelector, this.getItemsContainer().get(0)).last();
	    }, this.getFirstItem = function () {
	      return a(this.itemSelector, this.getItemsContainer().get(0)).first();
	    }, this.getScrollThreshold = function (a) {
	      var c;return a = a || this.negativeMargin, a = a >= 0 ? -1 * a : a, c = this.getLastItem(), 0 === c.length ? b : c.offset().top + c.height() + a;
	    }, this.getCurrentScrollOffset = function (a) {
	      var b = 0,
	          c = a.height();return b = window === a.get(0) ? a.scrollTop() : a.offset().top, (-1 != navigator.platform.indexOf("iPhone") || -1 != navigator.platform.indexOf("iPod")) && (c += 80), b + c;
	    }, this.getNextUrl = function (b) {
	      return b = b || this.$container, a(this.nextSelector, b).last().attr("href");
	    }, this.load = function (b, c, d) {
	      var e,
	          f,
	          g = this,
	          h = [],
	          i = +new Date();d = d || this.defaultDelay;var j = { url: b };return g.fire("load", [j]), this.jsXhr = a.get(j.url, null, a.proxy(function (b) {
	        e = a(this.itemsContainerSelector, b).eq(0), 0 === e.length && (e = a(b).filter(this.itemsContainerSelector).eq(0)), e && e.find(this.itemSelector).each(function () {
	          h.push(this);
	        }), g.fire("loaded", [b, h]), c && (f = +new Date() - i, d > f ? setTimeout(function () {
	          c.call(g, b, h);
	        }, d - f) : c.call(g, b, h));
	      }, g), "html"), this.jsXhr;
	    }, this.render = function (b, c) {
	      var d = this,
	          e = this.getLastItem(),
	          f = 0,
	          g = this.fire("render", [b]);g.done(function () {
	        a(b).hide(), e.after(b), a(b).fadeIn(400, function () {
	          ++f < b.length || (d.fire("rendered", [b]), c && c());
	        });
	      }), g.fail(function () {
	        c && c();
	      });
	    }, this.hidePagination = function () {
	      this.paginationSelector && a(this.paginationSelector, this.$container).hide();
	    }, this.restorePagination = function () {
	      this.paginationSelector && a(this.paginationSelector, this.$container).show();
	    }, this.throttle = function (b, c) {
	      var d,
	          e,
	          f = 0;return d = function d() {
	        function a() {
	          f = +new Date(), b.apply(d, g);
	        }var d = this,
	            g = arguments,
	            h = +new Date() - f;e ? clearTimeout(e) : a(), h > c ? a() : e = setTimeout(a, c);
	      }, a.guid && (d.guid = b.guid = b.guid || a.guid++), d;
	    }, this.fire = function (a, b) {
	      return this.listeners[a].fireWith(this, b);
	    }, this.pause = function () {
	      this.isPaused = !0;
	    }, this.resume = function () {
	      this.isPaused = !1;
	    }, this;
	  };c.prototype.initialize = function () {
	    if (this.isInitialized) return !1;var a = !!("onscroll" in this.$scrollContainer.get(0)),
	        b = this.getCurrentScrollOffset(this.$scrollContainer),
	        c = this.getScrollThreshold();return a ? (this.hidePagination(), this.bind(), this.fire("ready"), this.nextUrl = this.getNextUrl(), b >= c ? (this.next(), this.one("rendered", function () {
	      this.isInitialized = !0;
	    })) : this.isInitialized = !0, this) : !1;
	  }, c.prototype.reinitialize = function () {
	    this.isInitialized = !1, this.unbind(), this.initialize();
	  }, c.prototype.bind = function () {
	    if (!this.isBound) {
	      this.$scrollContainer.on("scroll", a.proxy(this.throttle(this.scrollHandler, 150), this));for (var b = 0, c = this.extensions.length; c > b; b++) {
	        this.extensions[b].bind(this);
	      }this.isBound = !0, this.resume();
	    }
	  }, c.prototype.unbind = function () {
	    if (this.isBound) {
	      this.$scrollContainer.off("scroll", this.scrollHandler);for (var a = 0, b = this.extensions.length; b > a; a++) {
	        "undefined" != typeof this.extensions[a].unbind && this.extensions[a].unbind(this);
	      }this.isBound = !1;
	    }
	  }, c.prototype.destroy = function () {
	    try {
	      this.jsXhr.abort();
	    } catch (a) {}this.unbind(), this.$scrollContainer.data("ias", null);
	  }, c.prototype.on = function (b, c, d) {
	    if ("undefined" == typeof this.listeners[b]) throw new Error('There is no event called "' + b + '"');return d = d || 0, this.listeners[b].add(a.proxy(c, this), d), this;
	  }, c.prototype.one = function (a, b) {
	    var c = this,
	        d = function d() {
	      c.off(a, b), c.off(a, d);
	    };return this.on(a, b), this.on(a, d), this;
	  }, c.prototype.off = function (a, b) {
	    if ("undefined" == typeof this.listeners[a]) throw new Error('There is no event called "' + a + '"');return this.listeners[a].remove(b), this;
	  }, c.prototype.next = function () {
	    var a = this.nextUrl,
	        b = this;if (this.pause(), !a) return this.fire("noneLeft", [this.getLastItem()]), this.listeners.noneLeft.disable(), b.resume(), !1;var c = this.fire("next", [a]);return c.done(function () {
	      b.load(a, function (a, c) {
	        b.render(c, function () {
	          b.nextUrl = b.getNextUrl(a), b.resume();
	        });
	      });
	    }), c.fail(function () {
	      b.resume();
	    }), !0;
	  }, c.prototype.extension = function (a) {
	    if ("undefined" == typeof a.bind) throw new Error('Extension doesn\'t have required method "bind"');return "undefined" != typeof a.initialize && a.initialize(this), this.extensions.push(a), this.isInitialized && this.reinitialize(), this;
	  }, a.ias = function (b) {
	    var c = a(window);return c.ias.apply(c, arguments);
	  }, a.fn.ias = function (b) {
	    var d = Array.prototype.slice.call(arguments),
	        e = this;return this.each(function () {
	      var f = a(this),
	          g = f.data("ias"),
	          h = a.extend({}, a.fn.ias.defaults, f.data(), "object" == (typeof b === "undefined" ? "undefined" : _typeof(b)) && b);if (g || (f.data("ias", g = new c(f, h)), a(document).ready(a.proxy(g.initialize, g))), "string" == typeof b) {
	        if ("function" != typeof g[b]) throw new Error('There is no method called "' + b + '"');d.shift(), g[b].apply(g, d);
	      }e = g;
	    }), e;
	  }, a.fn.ias.defaults = { item: ".item", container: ".listing", next: ".next", pagination: !1, delay: 600, negativeMargin: 10 };
	}(jQuery);var IASHistoryExtension = function IASHistoryExtension(a) {
	  return a = jQuery.extend({}, this.defaults, a), this.ias = null, this.prevSelector = a.prev, this.prevUrl = null, this.listeners = { prev: new IASCallbacks() }, this.onPageChange = function (a, b, c) {
	    if (window.history && window.history.replaceState) {
	      var d = history.state;history.replaceState(d, document.title, c);
	    }
	  }, this.onScroll = function (a, b) {
	    var c = this.getScrollThresholdFirstItem();this.prevUrl && (a -= this.ias.$scrollContainer.height(), c >= a && this.prev());
	  }, this.onReady = function () {
	    var a = this.ias.getCurrentScrollOffset(this.ias.$scrollContainer),
	        b = this.getScrollThresholdFirstItem();a -= this.ias.$scrollContainer.height(), b >= a && this.prev();
	  }, this.getPrevUrl = function (a) {
	    return a || (a = this.ias.$container), jQuery(this.prevSelector, a).last().attr("href");
	  }, this.getScrollThresholdFirstItem = function () {
	    var a;return a = this.ias.getFirstItem(), 0 === a.length ? -1 : a.offset().top;
	  }, this.renderBefore = function (a, b) {
	    var c = this.ias,
	        d = c.getFirstItem(),
	        e = 0;c.fire("render", [a]), jQuery(a).hide(), d.before(a), jQuery(a).fadeIn(400, function () {
	      ++e < a.length || (c.fire("rendered", [a]), b && b());
	    });
	  }, this;
	};IASHistoryExtension.prototype.initialize = function (a) {
	  var b = this;this.ias = a, jQuery.extend(a.listeners, this.listeners), a.prev = function () {
	    return b.prev();
	  }, this.prevUrl = this.getPrevUrl();
	}, IASHistoryExtension.prototype.bind = function (a) {
	  a.on("pageChange", jQuery.proxy(this.onPageChange, this)), a.on("scroll", jQuery.proxy(this.onScroll, this)), a.on("ready", jQuery.proxy(this.onReady, this));
	}, IASHistoryExtension.prototype.unbind = function (a) {
	  a.off("pageChange", this.onPageChange), a.off("scroll", this.onScroll), a.off("ready", this.onReady);
	}, IASHistoryExtension.prototype.prev = function () {
	  var a = this.prevUrl,
	      b = this,
	      c = this.ias;if (!a) return !1;c.pause();var d = c.fire("prev", [a]);return d.done(function () {
	    c.load(a, function (a, d) {
	      b.renderBefore(d, function () {
	        b.prevUrl = b.getPrevUrl(a), c.resume(), b.prevUrl && b.prev();
	      });
	    });
	  }), d.fail(function () {
	    c.resume();
	  }), !0;
	}, IASHistoryExtension.prototype.defaults = { prev: ".prev" };var IASNoneLeftExtension = function IASNoneLeftExtension(a) {
	  return a = jQuery.extend({}, this.defaults, a), this.ias = null, this.uid = new Date().getTime(), this.html = a.html.replace("{text}", a.text), this.showNoneLeft = function () {
	    var a = jQuery(this.html).attr("id", "ias_noneleft_" + this.uid),
	        b = this.ias.getLastItem();b.after(a), a.fadeIn();
	  }, this;
	};IASNoneLeftExtension.prototype.bind = function (a) {
	  this.ias = a, a.on("noneLeft", jQuery.proxy(this.showNoneLeft, this));
	}, IASNoneLeftExtension.prototype.unbind = function (a) {
	  a.off("noneLeft", this.showNoneLeft);
	}, IASNoneLeftExtension.prototype.defaults = { text: "You reached the end.", html: '<div class="ias-noneleft" style="text-align: center;">{text}</div>' };var IASPagingExtension = function IASPagingExtension() {
	  return this.ias = null, this.pagebreaks = [[0, document.location.toString()]], this.lastPageNum = 1, this.enabled = !0, this.listeners = { pageChange: new IASCallbacks() }, this.onScroll = function (a, b) {
	    if (this.enabled) {
	      var c,
	          d = this.ias,
	          e = this.getCurrentPageNum(a),
	          f = this.getCurrentPagebreak(a);this.lastPageNum !== e && (c = f[1], d.fire("pageChange", [e, a, c])), this.lastPageNum = e;
	    }
	  }, this.onNext = function (a) {
	    var b = this.ias.getCurrentScrollOffset(this.ias.$scrollContainer);this.pagebreaks.push([b, a]);var c = this.getCurrentPageNum(b) + 1;this.ias.fire("pageChange", [c, b, a]), this.lastPageNum = c;
	  }, this.onPrev = function (a) {
	    var b = this,
	        c = b.ias,
	        d = c.getCurrentScrollOffset(c.$scrollContainer),
	        e = d - c.$scrollContainer.height(),
	        f = c.getFirstItem();this.enabled = !1, this.pagebreaks.unshift([0, a]), c.one("rendered", function () {
	      for (var d = 1, g = b.pagebreaks.length; g > d; d++) {
	        b.pagebreaks[d][0] = b.pagebreaks[d][0] + f.offset().top;
	      }var h = b.getCurrentPageNum(e) + 1;c.fire("pageChange", [h, e, a]), b.lastPageNum = h, b.enabled = !0;
	    });
	  }, this;
	};IASPagingExtension.prototype.initialize = function (a) {
	  this.ias = a, jQuery.extend(a.listeners, this.listeners);
	}, IASPagingExtension.prototype.bind = function (a) {
	  try {
	    a.on("prev", jQuery.proxy(this.onPrev, this), this.priority);
	  } catch (b) {}a.on("next", jQuery.proxy(this.onNext, this), this.priority), a.on("scroll", jQuery.proxy(this.onScroll, this), this.priority);
	}, IASPagingExtension.prototype.unbind = function (a) {
	  try {
	    a.off("prev", this.onPrev);
	  } catch (b) {}a.off("next", this.onNext), a.off("scroll", this.onScroll);
	}, IASPagingExtension.prototype.getCurrentPageNum = function (a) {
	  for (var b = this.pagebreaks.length - 1; b > 0; b--) {
	    if (a > this.pagebreaks[b][0]) return b + 1;
	  }return 1;
	}, IASPagingExtension.prototype.getCurrentPagebreak = function (a) {
	  for (var b = this.pagebreaks.length - 1; b >= 0; b--) {
	    if (a > this.pagebreaks[b][0]) return this.pagebreaks[b];
	  }return null;
	}, IASPagingExtension.prototype.priority = 500;var IASSpinnerExtension = function IASSpinnerExtension(a) {
	  return a = jQuery.extend({}, this.defaults, a), this.ias = null, this.uid = new Date().getTime(), this.src = a.src, this.html = a.html.replace("{src}", this.src), this.showSpinner = function () {
	    var a = this.getSpinner() || this.createSpinner(),
	        b = this.ias.getLastItem();b.after(a), a.fadeIn();
	  }, this.showSpinnerBefore = function () {
	    var a = this.getSpinner() || this.createSpinner(),
	        b = this.ias.getFirstItem();b.before(a), a.fadeIn();
	  }, this.removeSpinner = function () {
	    this.hasSpinner() && this.getSpinner().remove();
	  }, this.getSpinner = function () {
	    var a = jQuery("#ias_spinner_" + this.uid);return a.length > 0 ? a : !1;
	  }, this.hasSpinner = function () {
	    var a = jQuery("#ias_spinner_" + this.uid);return a.length > 0;
	  }, this.createSpinner = function () {
	    var a = jQuery(this.html).attr("id", "ias_spinner_" + this.uid);return a.hide(), a;
	  }, this;
	};IASSpinnerExtension.prototype.bind = function (a) {
	  this.ias = a, a.on("next", jQuery.proxy(this.showSpinner, this)), a.on("render", jQuery.proxy(this.removeSpinner, this));try {
	    a.on("prev", jQuery.proxy(this.showSpinnerBefore, this));
	  } catch (b) {}
	}, IASSpinnerExtension.prototype.unbind = function (a) {
	  a.off("next", this.showSpinner), a.off("render", this.removeSpinner);try {
	    a.off("prev", this.showSpinnerBefore);
	  } catch (b) {}
	}, IASSpinnerExtension.prototype.defaults = { src: "data:image/gif;base64,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", html: '<div class="ias-spinner" style="text-align: center;"><img src="{src}"/></div>' };var IASTriggerExtension = function IASTriggerExtension(a) {
	  return a = jQuery.extend({}, this.defaults, a), this.ias = null, this.html = a.html.replace("{text}", a.text), this.htmlPrev = a.htmlPrev.replace("{text}", a.textPrev), this.enabled = !0, this.count = 0, this.offset = a.offset, this.$triggerNext = null, this.$triggerPrev = null, this.showTriggerNext = function () {
	    if (!this.enabled) return !0;if (!1 === this.offset || ++this.count < this.offset) return !0;var a = this.$triggerNext || (this.$triggerNext = this.createTrigger(this.next, this.html)),
	        b = this.ias.getLastItem();return b.after(a), a.fadeIn(), !1;
	  }, this.showTriggerPrev = function () {
	    if (!this.enabled) return !0;var a = this.$triggerPrev || (this.$triggerPrev = this.createTrigger(this.prev, this.htmlPrev)),
	        b = this.ias.getFirstItem();return b.before(a), a.fadeIn(), !1;
	  }, this.onRendered = function () {
	    this.enabled = !0;
	  }, this.createTrigger = function (a, b) {
	    var c,
	        d = new Date().getTime();return b = b || this.html, c = jQuery(b).attr("id", "ias_trigger_" + d), c.hide(), c.on("click", jQuery.proxy(a, this)), c;
	  }, this;
	};IASTriggerExtension.prototype.bind = function (a) {
	  this.ias = a, a.on("next", jQuery.proxy(this.showTriggerNext, this), this.priority), a.on("rendered", jQuery.proxy(this.onRendered, this), this.priority);try {
	    a.on("prev", jQuery.proxy(this.showTriggerPrev, this), this.priority);
	  } catch (b) {}
	}, IASTriggerExtension.prototype.unbind = function (a) {
	  a.off("next", this.showTriggerNext), a.off("rendered", this.onRendered);try {
	    a.off("prev", this.showTriggerPrev);
	  } catch (b) {}
	}, IASTriggerExtension.prototype.next = function () {
	  this.enabled = !1, this.ias.pause(), this.$triggerNext && (this.$triggerNext.remove(), this.$triggerNext = null), this.ias.next();
	}, IASTriggerExtension.prototype.prev = function () {
	  this.enabled = !1, this.ias.pause(), this.$triggerPrev && (this.$triggerPrev.remove(), this.$triggerPrev = null), this.ias.prev();
	}, IASTriggerExtension.prototype.defaults = { text: "Load more items", html: '<div class="ias-trigger ias-trigger-next" style="text-align: center; cursor: pointer;"><a>{text}</a></div>', textPrev: "Load previous items", htmlPrev: '<div class="ias-trigger ias-trigger-prev" style="text-align: center; cursor: pointer;"><a>{text}</a></div>', offset: 0 }, IASTriggerExtension.prototype.priority = 1e3;
	
	var NAME = 'infiniteScroll',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME],
	    IAS_OPTIONS = {
	  container: '#posts',
	  item: '.post',
	  pagination: '#pagination',
	  next: '.next'
	},
	    INVALID_SCRIPT_TYPES = ['application/ld+json'];
	
	var InfiniteScroll = function () {
	  function InfiniteScroll() /*element$*/{
	    _classCallCheck(this, InfiniteScroll);
	
	    var ias;
	    ias = $.ias(IAS_OPTIONS);
	
	    // NOTE: código para cambiar la URL
	    ias.extension(new IASTriggerExtension({ offset: 100 }));
	    ias.extension(new IASPagingExtension());
	    ias.extension(new IASHistoryExtension({
	      prev: '.prev'
	    }));
	
	    // NOTE: Spinner
	    ias.extension(new IASSpinnerExtension({
	      html: '<div class="voc-spinner-infinite-scroll"></div>'
	    }));
	
	    // NOTE: Cuando se ha cargado, recuperamos todos los scripts e inyectamos los que tienen contenido.
	    ias.on('loaded', function (data, items) {
	      var doc, posts, scripts;
	      doc = new DOMParser().parseFromString(data, 'text/html');
	      posts = doc.getElementById('posts');
	      if (posts) {
	        posts.parentNode.removeChild(posts);
	      }
	      scripts = doc.scripts;
	
	      for (var i = 0; i < scripts.length; i++) {
	        if (scripts[i].innerHTML.length && INVALID_SCRIPT_TYPES.indexOf(scripts[i].type) === -1) {
	          // FUTURE: Comprobar por qué hay que copiar el contenido del script en nuevo script para que funcione
	          var script = document.createElement('script');
	          script.innerHTML = scripts[i].innerHTML;
	          document.head.appendChild(script);
	        }
	      }
	    });
	
	    // NOTE: Una vez se ha renderizado, lanzamos el evento para que recargue todos los plugins.
	    ias.on('rendered', function (items) {
	      var items$ = $(items).last();
	      var config = Voonto.getInstance().lookup('vocento.config.vam');
	      Voonto.getInstance().trigger('voonto:reload', [items$, config.media, config.options]);
	    });
	
	    // Add a link after page 2 which has to be clicked to load the next page
	    // ias.extension(new IASTriggerExtension({offset: 2}));
	
	    // Add a text when there are no more pages left to load
	    // ias.extension(new IASNoneLeftExtension({text: 'You reached the end'}));
	  }
	
	  _createClass(InfiniteScroll, null, [{
	    key: "_jQueryInterface",
	    value: function _jQueryInterface() /*config*/{
	      return this.each(function () {
	        new InfiniteScroll($(this));
	      });
	    }
	  }, {
	    key: "VERSION",
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return InfiniteScroll;
	}();
	
	$.fn[NAME] = InfiniteScroll._jQueryInterface;
	$.fn[NAME].Constructor = InfiniteScroll;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return InfiniteScroll._jQueryInterface;
	};
	
	exports.default = InfiniteScroll;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'molinillo',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var Molinillo = function () {
	  function Molinillo(element$) {
	    var _this = this;
	
	    _classCallCheck(this, Molinillo);
	
	    this._element$ = element$;
	    element$.find('.voc-molinillo-btn').on('click', function (e) {
	      return _this.onClick(e);
	    });
	  }
	
	  _createClass(Molinillo, [{
	    key: 'onClick',
	    value: function onClick() /*event*/{
	      this._element$.animate({ 'opacity': '0' }, 'slow');
	      this._element$.slideToggle('slow');
	    }
	  }], [{
	    key: '_jQueryInterface',
	
	
	    /**
	     * This method is required to register the plugin as jQuery Plugin
	     */
	    value: function _jQueryInterface() /*config*/{
	      return this.each(function () {
	        new Molinillo($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return Molinillo;
	}();
	
	$.fn[NAME] = Molinillo._jQueryInterface;
	$.fn[NAME].Constructor = Molinillo;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return Molinillo._jQueryInterface;
	};
	
	exports.default = Molinillo;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import $ from 'jquery';
	
	var NAME = 'fixedColumn',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var Fixedcolumn = function () {
	  function Fixedcolumn(element$) {
	    _classCallCheck(this, Fixedcolumn);
	
	    this._element$ = element$;
	    var fixedcolumn = element$.clone().insertBefore(element$).addClass('fixed-column');
	    fixedcolumn.find('th:not(:first-child),td:not(:first-child)').remove();
	    fixedcolumn.find('tr').each(function (i) {
	      $(this).height(element$.find('tr:eq(' + i + ')').height());
	    });
	  }
	
	  _createClass(Fixedcolumn, null, [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() /*config*/{
	      return this.each(function () {
	        new Fixedcolumn($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return Fixedcolumn;
	}();
	
	$.fn[NAME] = Fixedcolumn._jQueryInterface;
	$.fn[NAME].Constructor = Fixedcolumn;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return Fixedcolumn._jQueryInterface;
	};
	
	exports.default = Fixedcolumn;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'deactivateTabsResolution',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var _window$ = $(window);
	
	/**
	 * This plugin remove the 'active' class of tabs when the window width
	 * is smaller than or equals the width provided in 'data-voc-deactivate-tabs-resolution'
	 * attribute, and add this class when the window width is greater
	 */
	
	var DeactivateTabsResolution = function () {
	  function DeactivateTabsResolution(element$) {
	    var _this = this;
	
	    _classCallCheck(this, DeactivateTabsResolution);
	
	    this._element$ = element$;
	
	    var elementAttr$ = this._element$.data().vocDeactivateTabsResolution;
	
	    if (elementAttr$ !== '') {
	      var attrArray$ = elementAttr$.split(';'),
	          widthArray$ = attrArray$[0].split(':');
	
	      this._maxWindowWidth = parseInt(widthArray$[1]);
	      this.lastWith = window.innerWidth;
	
	      _window$.on('resize', function () {
	        return (/*event*/_this.onResize()
	        );
	      });
	
	      _window$.resize();
	    }
	  }
	
	  _createClass(DeactivateTabsResolution, [{
	    key: 'onResize',
	    value: function onResize() /*event*/{
	      this._windowWidth = window.innerWidth;
	
	      // NOTE: To change the class only when there is a jump of _maxWindowWidth
	      if (this._windowWidth <= this._maxWindowWidth && this.lastWith > this._maxWindowWidth || this._windowWidth > this._maxWindowWidth && this.lastWith <= this._maxWindowWidth) {
	        var tabActiveBtn$ = this._element$.find('.nav-pills li.active'),
	            tabActivePane$ = this._element$.find('.tab-content .tab-pane.active');
	
	        if (this._windowWidth <= this._maxWindowWidth) {
	          tabActiveBtn$.removeClass('active');
	          tabActivePane$.removeClass('active');
	        } else {
	          if (tabActiveBtn$.length === 0) {
	            tabActiveBtn$ = this._element$.find('.nav-pills li').first();
	          }
	
	          if (tabActivePane$.length === 0) {
	            tabActivePane$ = this._element$.find('.tab-content .tab-pane').first();
	          }
	
	          tabActiveBtn$.addClass('active');
	          tabActivePane$.addClass('active');
	        }
	        this.lastWith = this._windowWidth;
	      }
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() {
	      return this.each(function () {
	        new DeactivateTabsResolution($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return DeactivateTabsResolution;
	}();
	
	$.fn[NAME] = DeactivateTabsResolution._jQueryInterface;
	$.fn[NAME].Constructor = DeactivateTabsResolution;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return DeactivateTabsResolution._jQueryInterface;
	};
	
	exports.default = DeactivateTabsResolution;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'deactivateTabsOnclick',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var DeactivateTabsOnclick = function () {
	  function DeactivateTabsOnclick(element$) {
	    var _this = this;
	
	    _classCallCheck(this, DeactivateTabsOnclick);
	
	    this._elementAttr$ = element$.data().vocDeactivateTabsOnclick;
	
	    element$.on('click', function (e) {
	      return _this.onClick(e);
	    });
	  }
	
	  _createClass(DeactivateTabsOnclick, [{
	    key: 'onClick',
	    value: function onClick() /*event*/{
	      $('a[href="#' + this._elementAttr$ + '"]').parent('li').removeClass('active');
	      $('#' + this._elementAttr$).removeClass('active');
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() {
	      return this.each(function () {
	        new DeactivateTabsOnclick($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return DeactivateTabsOnclick;
	}();
	
	$.fn[NAME] = DeactivateTabsOnclick._jQueryInterface;
	$.fn[NAME].Constructor = DeactivateTabsOnclick;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return DeactivateTabsOnclick._jQueryInterface;
	};
	
	exports.default = DeactivateTabsOnclick;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import $ from 'jquery';
	
	var NAME = 'dynamicArrow',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME],
	    IS_CHROME = is.chrome(),
	    IS_MOBILE = is.mobile();
	
	/**
	 * This plugin show Down or Up arrow on select elements inside the element selected
	 * Down arrow: When select element is close
	 * Up arrow: When select element is open
	 */
	
	var DynamicArrow = function () {
	  function DynamicArrow(element$) {
	    var _this = this;
	
	    _classCallCheck(this, DynamicArrow);
	
	    this._element$ = element$;
	    this._arrow$ = element$.find('.downArrow');
	    this._select$ = element$.find('select');
	
	    this._select$.on('mouseup touchend', function () {
	      return _this.onMouseUp();
	    });
	    this._select$.on('mousedown touchstart', function () {
	      return _this.onMouseDown();
	    });
	    this._select$.on('change blur', function () {
	      return _this.close();
	    });
	  }
	
	  _createClass(DynamicArrow, [{
	    key: 'onMouseDown',
	    value: function onMouseDown() {
	      var state = this._element$.data('state');
	
	      if (state === 1 || state === 3 || state === undefined) {
	        this._arrow$.removeClass('downArrow').addClass('upArrow');
	        this._element$.data('state', 2);
	      }
	    }
	  }, {
	    key: 'onMouseUp',
	    value: function onMouseUp() {
	      var state = this._element$.data('state');
	
	      // NOTE: Chrome has a bug, only detect mouseup and click events once when open and close select
	      if (state === 2) {
	        if (IS_CHROME && !IS_MOBILE) {
	          // NOTE: Reset de arrow on chrome navigator
	          this._arrow$.removeClass('upArrow').addClass('downArrow');
	          this._element$.data('state', 1);
	        } else {
	          // NOTE: Firefox detect mouseup and click events twice when open and close select
	          this._element$.data('state', 3);
	        }
	      } else if (state === 3) {
	        // NOTE: Reset de arrow on NO chrome navigators
	        this._arrow$.removeClass('upArrow').addClass('downArrow');
	        this._element$.data('state', 1);
	      }
	    }
	
	    // NOTE: Reset de arrow
	
	  }, {
	    key: 'close',
	    value: function close() {
	      this._arrow$.removeClass('upArrow').addClass('downArrow');
	      this._element$.data('state', 1);
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() {
	      return this.each(function () {
	        new DynamicArrow($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return DynamicArrow;
	}();
	
	$.fn[NAME] = DynamicArrow._jQueryInterface;
	$.fn[NAME].Constructor = DynamicArrow;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return DynamicArrow._jQueryInterface;
	};
	
	exports.default = DynamicArrow;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import $ from 'jquery';
	
	var NAME = 'dependentSelect',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var DependentSelect = function () {
	  function DependentSelect(element$) {
	    _classCallCheck(this, DependentSelect);
	
	    this._element$ = element$;
	    this._elementAttr$ = $('#' + element$.data('voc-dependent-select'));
	
	    this._elementAttr$.on('change', this.onChange.bind(this));
	    this._elementAttr$.trigger('change');
	  }
	
	  _createClass(DependentSelect, [{
	    key: 'onChange',
	    value: function onChange() /*event*/{
	      var idSection = this._elementAttr$.find('option:selected').data('id');
	      this._element$.prop('disabled', false);
	
	      this._element$.find('option').not(':first').each(function () {
	        if (idSection !== $(this).data('id')) {
	          $(this).hide();
	        } else {
	          $(this).show();
	        }
	      });
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() {
	      return this.each(function () {
	        new DependentSelect($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return DependentSelect;
	}();
	
	$.fn[NAME] = DependentSelect._jQueryInterface;
	$.fn[NAME].Constructor = DependentSelect;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return DependentSelect._jQueryInterface;
	};
	
	exports.default = DependentSelect;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'datepicker',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME],
	
	// NOTE: Maybe more than one datapicker should be included and the ID should be unique
	DAYS_CONTAINER = '.datepicker-days > tbody',
	    MONTH_NAMES = {
	  ES: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
	  EU: [// Euskera
	  "urtarrila", "otsaila", "march", "april", "mayo", "june", "uztailean", "abuztua", "september", "urria", "azaroa", "abenduan"]
	};
	
	/**
	 * To get the total days of the current month
	 */
	Date.prototype.monthDays = function () {
	  var date = new Date(this.getFullYear(), this.getMonth() + 1, 0);
	  return date.getDate();
	};
	
	var Datepicker = function () {
	  function Datepicker(element$) {
	    var _this = this;
	
	    _classCallCheck(this, Datepicker);
	
	    this._element$ = element$;
	    this.dates = [];
	    this.language = 'ES';
	    this.year;
	    this.month;
	
	    this.resetDateFields();
	    this.changeLanguage();
	    var current = new Date();
	    this.generateDays(current.getFullYear(), current.getMonth() + 1);
	    $('.toggle-year', this._element$).on('click', function (e) {
	      return _this.onClick(e);
	    });
	    $('.toggle-month', this._element$).on('click', function (e) {
	      return _this.onClick(e);
	    });
	    $('.schedule-search-way ~ label', this._element$).on('click', function (e) {
	      return _this.byMultipleDate(e);
	    });
	    $('.daily-search-way ~ label', this._element$).on('click', function (e) {
	      return _this.byMultipleDate(e);
	    });
	    $('.daily-search-way', this._element$).prop('checked', true);
	
	    // NOTE: Change language with $(ELEMENT).data('voc-datepicker', 'ES').trigger('changeLanguage');
	    // NOTE: Possible languages: 'ES' | 'EU'
	    this._element$.on('changeLanguage', this.changeLanguage.bind(this));
	  }
	
	  /**
	   * Enabled/disabled the end period fields. It depends of the clicked option[daily or schedule]
	   */
	
	
	  _createClass(Datepicker, [{
	    key: 'byMultipleDate',
	    value: function byMultipleDate(event) {
	      $('.date-row input', this._element$).val('');
	      if ($(event.target).prev().hasClass('schedule-search-way')) {
	        $('.date-row.date-periodo', this._element$).removeClass('_inactive');
	        $('.date-row.date-periodo input', this._element$).prop('disabled', false);
	        $('.daily-search-way', this._element$).prop('checked', false);
	      } else if ($(event.target).prev().hasClass('daily-search-way')) {
	        $('.date-row.date-periodo', this._element$).addClass('_inactive');
	        $('.date-row.date-periodo input', this._element$).prop('disabled', true);
	        $('.schedule-search-way', this._element$).prop('checked', false);
	      }
	      $('.active', this._element$).removeClass('active');
	      this.dates = [];
	    }
	
	    /**
	     *
	     */
	
	  }, {
	    key: 'toggleActive',
	    value: function toggleActive(event) {
	      // NOTE: Fill the start and end date on click a day cell, when schedule optinon is selected
	      if ($('.schedule-search-way:checked', this._element$).length > 0) {
	        $('.active', this._element$).removeClass('active');
	
	        // NOTE: Clear previous selection
	        if (this.dates.length > 1) {
	          $('.date-row input', this._element$).val('');
	          $('.active', this._element$).removeClass('active');
	          this.dates = [];
	        }
	
	        // NOTE: First click(start day) of new selection
	        if (this.dates.length === 0) {
	          $(event.target).addClass('active');
	          this.dates.push($(event.target).attr('data-date'));
	          $('input[data-voc-start-dd]', this._element$).val(this.pad($(event.target).attr('data-day')));
	          $('input[data-voc-start-mm]', this._element$).val(this.pad($(event.target).attr('data-month')));
	          $('input[data-voc-start-aaaa]', this._element$).val($(event.target).attr('data-year'));
	        } else {
	          // NOTE: Second click(end day) of new selection
	          var dateStart = new Date(this.dates[0]);
	          var dateEnd = new Date($(event.target).attr('data-date'));
	          this.dates = [];
	
	          if (dateStart.getTime() > dateEnd.getTime()) {
	            var temp = dateStart;
	            dateStart = dateEnd;
	            dateEnd = temp;
	          }
	
	          $('input[data-voc-start-dd]', this._element$).val(this.pad(dateStart.getDate()));
	          $('input[data-voc-start-mm]', this._element$).val(this.pad(dateStart.getMonth() + 1));
	          $('input[data-voc-start-aaaa]', this._element$).val(dateStart.getFullYear());
	
	          $('input[data-voc-end-dd]', this._element$).val(this.pad(dateEnd.getDate()));
	          $('input[data-voc-end-mm]', this._element$).val(this.pad(dateEnd.getMonth() + 1));
	          $('input[data-voc-end-aaaa]', this._element$).val(dateEnd.getFullYear());
	
	          while (dateStart.getTime() <= dateEnd.getTime()) {
	            var dateStr = dateStart.getFullYear() + '-' + this.pad(dateStart.getMonth() + 1) + '-' + this.pad(dateStart.getDate());
	            this.dates.push(dateStr);
	            $('[data-date="' + dateStr + '"]', this._element$).addClass('active');
	            dateStart = new Date(dateStart.setDate(dateStart.getDate() + 1));
	          }
	        }
	      } else {
	        // NOTE: Fill the start date on click a day cell, when daily option is selected
	        $('.active', this._element$).not(event.target).removeClass('active');
	        $(event.target).addClass('active');
	        $('input[data-voc-start-dd]', this._element$).val(this.pad($(event.target).attr('data-day')));
	        $('input[data-voc-start-mm]', this._element$).val(this.pad($(event.target).attr('data-month')));
	        $('input[data-voc-start-aaaa]', this._element$).val($(event.target).attr('data-year'));
	      }
	    }
	
	    /**
	     * Garantee that every numbers has two places
	     */
	
	  }, {
	    key: 'pad',
	    value: function pad(num) {
	      return num < 10 && num.toString().length === 1 ? '0' + num : num;
	    }
	
	    /**
	     * Actions when click on next and back arrow of year and month slide
	     */
	
	  }, {
	    key: 'onClick',
	    value: function onClick(event) {
	      if ($(event.target).hasClass('toggle-year')) {
	        var incYear = $(event.target).hasClass('leftArrow') ? -1 : 1;
	        this.generateDays(this.year + incYear, this.month);
	      } else {
	        //toggle-month
	        var incMonth = $(event.target).hasClass('leftArrow') ? -1 : 1;
	        this.generateDays(this.year, this.month + incMonth);
	      }
	    }
	
	    /**
	     * Paint the calendar based on the year and month given
	     */
	
	  }, {
	    key: 'generateDays',
	    value: function generateDays(year, month) {
	      var _this2 = this;
	
	      this.year = year;
	      this.month = month;
	
	      if (this.month > MONTH_NAMES[this.language].length) {
	        this.year++;
	        this.month = this.month % MONTH_NAMES[this.language].length;
	      } else if (this.month <= 0) {
	        this.year--;
	        this.month = MONTH_NAMES[this.language].length;
	      }
	
	      $(DAYS_CONTAINER, this._element$).children().remove();
	      var dateGenerated = new Date(this.year, this.month - 1, '01');
	
	      this.changeLanguage();
	      $('.datepicker-year .name', this._element$).text(this.year);
	
	      var returntemplate = this.buildTemplate(dateGenerated);
	      $(DAYS_CONTAINER, this._element$).append(returntemplate);
	      $('.day.voc-enabled', this._element$).on('click', function (e) {
	        return _this2.toggleActive(e);
	      });
	    }
	
	    /**
	     * Build the days matrix
	     */
	
	  }, {
	    key: 'buildTemplate',
	    value: function buildTemplate(date) {
	      // NOTE: The Sunday is 0, but it is necessary to start on Monday
	      var today = void 0,
	          todayDay = void 0,
	          todayMonth = void 0,
	          todayYear = void 0,
	          currentDay = void 0,
	          startDay = void 0,
	          template = void 0;
	
	      today = new Date();
	      todayDay = today.getDate();
	      todayMonth = today.getMonth() + 1;
	      todayYear = today.getFullYear();
	      currentDay = date.getDay() > 0 ? date.getDay() : 7;
	      startDay = currentDay;
	      template = '<tr>';
	
	      // NOTE: Creating the empty cells of the first row
	      for (var i = 1; i < currentDay; i++) {
	        template += '<td></td>';
	      }
	
	      // NOTE: Fill the days cells
	      for (var _i = 1; _i <= date.monthDays(); _i++, startDay++) {
	        // NOTE: Reset the week day[between 1 and 7]
	        var disabledClass = void 0,
	            dateTotal = void 0,
	            activeClass = void 0;
	
	        if (startDay > 7) {
	          template += '</tr><tr>';
	          startDay = 1;
	        }
	
	        disabledClass = _i > todayDay && this.month === todayMonth && this.year === todayYear || this.month > todayMonth && this.year >= todayYear || this.year > todayYear ? 'voc-disabled' : 'voc-enabled';
	
	        dateTotal = this.year + '-' + this.pad(this.month) + '-' + this.pad(_i);
	        activeClass = this.dates.indexOf(dateTotal) !== -1 ? 'active' : '';
	        template += '<td class="day ' + activeClass + ' ' + disabledClass + '"\n                      data-day="' + this.pad(_i) + '"\n                      data-month="' + this.pad(this.month) + '"\n                      data-year="' + this.year + '"\n                      data-date="' + dateTotal + '">' + this.pad(_i) + '</td>';
	      }
	
	      // NOTE: Creating the empty cells of the last row
	      for (var _i2 = startDay; _i2 < 8; _i2++) {
	        template += '<td></td>';
	      }
	
	      return template + '</tr>';
	    }
	  }, {
	    key: 'changeLanguage',
	    value: function changeLanguage() {
	      this.language = this._element$.data('voc-datepicker-language') !== undefined ? this._element$.data('voc-datepicker-language') : 'ES';
	      $('.datepicker-month .name', this._element$).text(MONTH_NAMES[this.language][this.month - 1]);
	    }
	  }, {
	    key: 'resetDateFields',
	    value: function resetDateFields() {
	      $('input[data-voc-start-dd]', this._element$).val('');
	      $('input[data-voc-start-mm]', this._element$).val('');
	      $('input[data-voc-start-aaaa]', this._element$).val('');
	      $('input[data-voc-end-dd]', this._element$).val('');
	      $('input[data-voc-end-mm]', this._element$).val('');
	      $('input[data-voc-end-aaaa]', this._element$).val('');
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() /*config*/{
	      return this.each(function () {
	        new Datepicker($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return Datepicker;
	}();
	
	$.fn[NAME] = Datepicker._jQueryInterface;
	$.fn[NAME].Constructor = Datepicker;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return Datepicker._jQueryInterface;
	};
	
	exports.default = Datepicker;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'matchbind',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	/**
	 * This plugin add the behavior of resalt the player in the
	 * local or visitor list when click on the field correspondign
	 * position
	 */
	
	var Matchbind = function () {
	  function Matchbind(element$) {
	    var _this = this;
	
	    _classCallCheck(this, Matchbind);
	
	    this._element$ = element$;
	    element$.find('.player').on('click mouseover', function (e) {
	      return _this.onClick(e);
	    });
	  }
	
	  _createClass(Matchbind, [{
	    key: 'onClick',
	    value: function onClick(e) {
	      $('.team-members .member', this._element$).removeClass('active');
	      $('.voc-field-container .player', this._element$).removeClass('active');
	      $('#' + $(e.target).data('related')).addClass('active');
	      $(e.target).addClass('active');
	    }
	  }], [{
	    key: '_jQueryInterface',
	
	
	    /**
	     * This method is required to register the plugin as jQuery Plugin
	     */
	    value: function _jQueryInterface() /*config*/{
	      return this.each(function () {
	        new Matchbind($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return Matchbind;
	}();
	
	$.fn[NAME] = Matchbind._jQueryInterface;
	$.fn[NAME].Constructor = Matchbind;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return Matchbind._jQueryInterface;
	};
	
	exports.default = Matchbind;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import $ from 'jquery';
	
	var NAME = 'selectRedirect',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var SelectRedirect = function () {
	  function SelectRedirect(element$) {
	    _classCallCheck(this, SelectRedirect);
	
	    element$.on('change', this.onChange.bind(this));
	  }
	
	  _createClass(SelectRedirect, [{
	    key: 'onChange',
	    value: function onChange(event) {
	      window.location = event.target.value;
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() /*config*/{
	      return this.each(function () {
	        new SelectRedirect($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return SelectRedirect;
	}();
	
	$.fn[NAME] = SelectRedirect._jQueryInterface;
	$.fn[NAME].Constructor = SelectRedirect;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return SelectRedirect._jQueryInterface;
	};
	
	exports.default = SelectRedirect;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'toggleClick',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var Toggleclick = function () {
	  function Toggleclick(element$) {
	    _classCallCheck(this, Toggleclick);
	
	    this._element$ = element$;
	    this._element$.find('[data-voc-toggle-trigger]').on('click', this.onClick.bind(this));
	  }
	
	  _createClass(Toggleclick, [{
	    key: 'onClick',
	    value: function onClick() /*event*/{
	      this._element$.find('[data-voc-toggle-listen]').toggle();
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() /*config*/{
	      return this.each(function () {
	        new Toggleclick($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return Toggleclick;
	}();
	
	$.fn[NAME] = Toggleclick._jQueryInterface;
	$.fn[NAME].Constructor = Toggleclick;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return Toggleclick._jQueryInterface;
	};
	
	exports.default = Toggleclick;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'buttonDisplacement',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var _window$ = $(window);
	
	var ButtonDisplacement = function () {
	  function ButtonDisplacement(element$, options) {
	    _classCallCheck(this, ButtonDisplacement);
	
	    this._element$ = element$;
	    this._options = options;
	    _window$.on('scroll', this.onScroll.bind(this));
	    this._element$.on('click', this.onClick.bind(this));
	  }
	
	  _createClass(ButtonDisplacement, [{
	    key: 'onScroll',
	    value: function onScroll() /*event*/{
	      var parent = this._element$.parents('.voc-live-scribble');
	      var topHeight = parent.offset().top;
	      if (_window$.scrollTop() >= _window$.height() && _window$.scrollTop() >= topHeight && _window$.scrollTop() <= parent.outerHeight()) {
	        this._element$.addClass('_fixed');
	      } else {
	        this._element$.removeClass('_fixed');
	      }
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick() /*event*/{
	      $('html, body').animate({ scrollTop: 0 }, '500');
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(options) {
	      return this.each(function () {
	        new ButtonDisplacement($(this), options);
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return ButtonDisplacement;
	}();
	
	$.fn[NAME] = ButtonDisplacement._jQueryInterface;
	$.fn[NAME].Constructor = ButtonDisplacement;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return ButtonDisplacement._jQueryInterface;
	};
	
	exports.default = ButtonDisplacement;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'adverUnfix',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME],
	    _window$ = $(window),
	    STICKY_TIMER = 6000,
	    SUSCRIPTOR = 'suscriptor',
	    TRIAL = 'trial',
	    BOTTOM = 'bottom',
	    app = Voonto.getInstance();
	
	var AdverUnfix = function () {
	  function AdverUnfix(element$, options) {
	    var _this = this;
	
	    _classCallCheck(this, AdverUnfix);
	
	    this._element$ = element$;
	    this._options = options;
	    this._position = element$.data('voc-adver-unfix');
	    this._elParent$ = element$.parent();
	    this._elOffsetTop = element$.offset().top;
	    this._elOuterHeight = element$.outerHeight(true);
	
	    if (this._position === BOTTOM) {
	      element$.one('vam:slotrendered', function () {
	        app.when('vocuser:ready').then(function (gigyaux) {
	          var userType = gigyaux.getUserType();
	          if (userType !== SUSCRIPTOR && userType !== TRIAL) {
	            _this._elParent$.addClass('fixed-position');
	            setTimeout(function () {
	              _this._elParent$.removeClass('fixed-position');
	            }, STICKY_TIMER);
	          }
	        });
	      });
	    } else {
	      element$.one('vam:viewable', function () {
	        app.when('vocuser:ready').then(function (gigyaux) {
	          var userType = gigyaux.getUserType();
	          if (userType !== SUSCRIPTOR && userType !== TRIAL) {
	            _window$.on('scroll.megabanner', _this.onScroll.bind(_this));
	            _window$.trigger('scroll.megabanner');
	            setTimeout(function () {
	              _this._element$.removeClass('fixed-position');
	              _window$.off('scroll.megabanner');
	              _this._elParent$.css('padding-top', '0');
	            }, STICKY_TIMER);
	          }
	        });
	      });
	    }
	  }
	
	  _createClass(AdverUnfix, [{
	    key: 'onScroll',
	    value: function onScroll() {
	      if (_window$.scrollTop() + this._options.offset_top > this._elOffsetTop) {
	        this._element$.addClass('fixed-position');
	        this._elParent$.css('padding-top', this._elOuterHeight + 'px');
	      } else {
	        this._element$.removeClass('fixed-position');
	        this._elParent$.css('padding-top', '0');
	      }
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(options) {
	      return this.each(function () {
	        new AdverUnfix($(this), options);
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return AdverUnfix;
	}();
	
	$.fn[NAME] = AdverUnfix._jQueryInterface;
	$.fn[NAME].Constructor = AdverUnfix;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return AdverUnfix._jQueryInterface;
	};
	
	exports.default = AdverUnfix;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'socialMore',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME],
	    _window$ = $(window),
	    INPUT_MEDIA_CLASS = '.voc-input-media',
	    AUTHOR_SOCIAL_CLASS = 'div.voc-author-social';
	
	var SocialMore = function () {
	  function SocialMore(element$) {
	    var _this = this;
	
	    _classCallCheck(this, SocialMore);
	
	    this._element$ = element$;
	    this._checkBoxSocialMore$ = element$.find(INPUT_MEDIA_CLASS);
	
	    _window$.on('click', function (e) {
	      return _this.onClick(e);
	    });
	  }
	
	  _createClass(SocialMore, [{
	    key: 'onClick',
	    value: function onClick(e) {
	      // NOTE: Cerrar el panel de redes sociales adicionales si se hace click fuera de este.
	      var target$ = $(e.target);
	
	      if (!target$.parents(AUTHOR_SOCIAL_CLASS).length) {
	        if (this._checkBoxSocialMore$.is(':checked')) {
	          this._checkBoxSocialMore$.prop('checked', false);
	        }
	      }
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() /*config*/{
	      return this.each(function () {
	        new SocialMore($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return SocialMore;
	}();
	
	$.fn[NAME] = SocialMore._jQueryInterface;
	$.fn[NAME].Constructor = SocialMore;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return SocialMore._jQueryInterface;
	};
	
	exports.default = SocialMore;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(17);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'initSwiperOnTab',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var InitSwiperOnTab = function () {
	  function InitSwiperOnTab(element$) {
	    _classCallCheck(this, InitSwiperOnTab);
	
	    var tabButtons$ = element$.find('a[data-toggle="tab"]');
	    tabButtons$.on('shown.bs.tab', this.onShowTab.bind(this));
	  }
	
	  _createClass(InitSwiperOnTab, [{
	    key: 'onShowTab',
	    value: function onShowTab(event) {
	      var activeTabPan$ = $(event.target).attr('href');
	      var swiperContainer$ = $(activeTabPan$).find('.swiper-container');
	      if (swiperContainer$.length) {
	        swiperContainer$.data('swiper', swiperContainer$.swiper(Object.create(_constants.SWIPER_AUTO)));
	      }
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() {
	      return this.each(function () {
	        new InitSwiperOnTab($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return InitSwiperOnTab;
	}();
	
	$.fn[NAME] = InitSwiperOnTab._jQueryInterface;
	$.fn[NAME].Constructor = InitSwiperOnTab;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return InitSwiperOnTab._jQueryInterface;
	};
	
	exports.default = InitSwiperOnTab;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'selectDisplay',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var _selectedId;
	
	var SelectDisplay = function () {
	  function SelectDisplay(element$) {
	    _classCallCheck(this, SelectDisplay);
	
	    var select$;
	
	    this._element$ = element$;
	    select$ = element$.find('select');
	    _selectedId = select$.find('option:selected').val();
	    $('#' + _selectedId, element$).addClass('voc-visible-select-div');
	
	    select$.on('change', this.onChange.bind(this));
	  }
	
	  _createClass(SelectDisplay, [{
	    key: 'onChange',
	    value: function onChange(event) {
	      _selectedId = event.target.value;
	      $('.voc-select-div', this._element$).removeClass('voc-visible-select-div');
	      $('#' + _selectedId, this._element$).addClass('voc-visible-select-div');
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() {
	      return this.each(function () {
	        new SelectDisplay($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return SelectDisplay;
	}();
	
	$.fn[NAME] = SelectDisplay._jQueryInterface;
	$.fn[NAME].Constructor = SelectDisplay;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return SelectDisplay._jQueryInterface;
	};
	
	exports.default = SelectDisplay;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'closeGallery',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME],
	    GALLERY_COUNTER = 'squido-carousel-galleries-opened';
	
	var CloseGallery = function () {
	  function CloseGallery(element$) {
	    _classCallCheck(this, CloseGallery);
	
	    element$.on('click', this.clicked.bind(this));
	  }
	
	  _createClass(CloseGallery, [{
	    key: 'clicked',
	    value: function clicked() {
	      var key = this.getSessionStorageCounter() + 1;
	      window.history.go(-key);
	      this.removeSessionStorageCounter();
	    }
	  }, {
	    key: 'getSessionStorageCounter',
	    value: function getSessionStorageCounter() {
	      var value = window.sessionStorage.getItem(GALLERY_COUNTER).split();
	      return Number(value[0]);
	    }
	  }, {
	    key: 'removeSessionStorageCounter',
	    value: function removeSessionStorageCounter() {
	      window.sessionStorage.removeItem(GALLERY_COUNTER);
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() /*config*/{
	      return this.each(function () {
	        new CloseGallery($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return CloseGallery;
	}();
	
	$.fn[NAME] = CloseGallery._jQueryInterface;
	$.fn[NAME].Constructor = CloseGallery;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return CloseGallery._jQueryInterface;
	};
	
	exports.default = CloseGallery;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'socialSharer',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var NEW_WINDOW_TOP = 125,
	    NEW_WINDOW_WIDTH = 500,
	    NEW_WINDOW_LEFT = _calcLeftPosition(),
	    NEW_WINDOW_HEIGHT = 350,
	    NEW_WINDOW_TOOLBAR = 0,
	    NEW_WINDOW_MENUBAR = 0,
	    NEW_WINDOW_TITLEBAR = 0,
	    NEW_WINDOW_STATUS = 0,
	    OPEN_LINK_TYPE = 'popup',
	    OPEN_LINK_OPTS = 'top=' + NEW_WINDOW_TOP + ', width=' + NEW_WINDOW_WIDTH + ', left=' + NEW_WINDOW_LEFT + ', height=' + NEW_WINDOW_HEIGHT + ', toolbar=' + NEW_WINDOW_TOOLBAR + ', menubar=' + NEW_WINDOW_MENUBAR + ', titlebar=' + NEW_WINDOW_TITLEBAR + ', status=' + NEW_WINDOW_STATUS,
	    FACEBOOK = 'facebook',
	    TWITTER = 'twitter',
	    GOOGLEPLUS = 'googleplus',
	    LINKEDIN = 'linkedin',
	    MAIL = 'mail',
	    WHATSAPP = 'whatsapp',
	    TWITTER_REGEXP = /(twitter)@(\w*)/;
	
	var SocialSharer = function () {
	  function SocialSharer(element$) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, SocialSharer);
	
	    var type = element$.data('voc-social-sharer');
	
	    this._url = _checkSite(options.url || document.location);
	
	    if (TWITTER_REGEXP.test(type)) {
	      var _type$split = type.split('@');
	
	      var _type$split2 = _slicedToArray(_type$split, 2);
	
	      type = _type$split2[0];
	      this._twitterUser = _type$split2[1];
	    }
	
	    switch (type) {
	      case FACEBOOK:
	        element$.on('click', this.onFacebook.bind(this));
	        break;
	      case TWITTER:
	        element$.on('click', this.onTwitter.bind(this));
	        break;
	      case GOOGLEPLUS:
	        element$.on('click', this.onGooglePlus.bind(this));
	        break;
	      case LINKEDIN:
	        element$.on('click', this.onLinkedIn.bind(this));
	        break;
	      case MAIL:
	        element$.on('click', this.onMail.bind(this));
	        break;
	      case WHATSAPP:
	        element$.data('action', 'share/whatsapp/share');
	        element$.on('click', this.onWhatsapp.bind(this));
	    }
	  }
	
	  _createClass(SocialSharer, [{
	    key: 'onFacebook',
	    value: function onFacebook() {
	      window.open('//www.facebook.com/sharer.php?u=' + this._url, OPEN_LINK_TYPE, OPEN_LINK_OPTS);
	    }
	  }, {
	    key: 'onTwitter',
	    value: function onTwitter() {
	      var twitterUser = this._twitterUser ? '&via=' + this._twitterUser : _checkTwitterUser() ? _checkTwitterUser() : '';
	      window.open('//twitter.com/share?text=' + encodeURI(_getTitle()) + '&url=' + this._url + twitterUser, OPEN_LINK_TYPE, OPEN_LINK_OPTS);
	    }
	  }, {
	    key: 'onGooglePlus',
	    value: function onGooglePlus() {
	      window.open('//plus.google.com/share?url=' + this._url, OPEN_LINK_TYPE, OPEN_LINK_OPTS);
	    }
	  }, {
	    key: 'onLinkedIn',
	    value: function onLinkedIn() {
	      window.open('//www.linkedin.com/shareArticle?url=' + this._url, OPEN_LINK_TYPE, OPEN_LINK_OPTS);
	    }
	  }, {
	    key: 'onMail',
	    value: function onMail() {
	      window.open('//www.addthis.com/tellfriend_v2.php?v=300&winname=addthis&pub=ra-537cb4845172d4ab&source=men-300&lng=es&s=email&url=' + encodeURIComponent(this._url) + (_hasEdition() ? '&' : '?') + encodeURIComponent('ns_campaign=rrss&ns_mchannel=boton&ns_fee=0&ns_source=em&ns_linkname=undefined') + '&title=' + encodeURIComponent(_getTitle()) + '&ate=AT-ra-537cb4845172d4ab/-/-/58f8b5fff498d9d5/2&uid=58f87b3c13039483&description=' + encodeURIComponent($('meta[name="description"]').attr('content')) + '&ufbl=1&ct=0&ui_email_to=&ui_email_from=&ui_email_note=&pre=' + encodeURIComponent(document.location.origin) + '&tt=0&captcha_provider=recaptcha2&pro=0&ats=passthrough=twitter=via=' + (document.querySelector('meta[name="twitter:site"]') ? encodeURIComponent(document.querySelector('meta[name="twitter:site"]').content.slice(1)) : '') + '&text=' + encodeURIComponent($('meta[name="title"]').attr('content')) + '&imp_url=0&smd=rsi=&gen=0&rsc=&dr=' + encodeURIComponent(document.location.origin) + '&sta=AT-ra-537cb4845172d4ab/-/-/58f8b5fff498d9d5/1&hideEmailSharingConfirmation=undefined&service=email&media=undefined&email_template=undefined&email_vars=undefined&atc=pubid=ra-537cb4845172d4ab&ui_language=es&data_track_clickback=false&data_track_addressbar=false&ui_click=false&product=undefined&widgetId=undefined&ui_pane=email&rb=false');
	    }
	  }, {
	    key: 'onWhatsapp',
	    value: function onWhatsapp() {
	      window.open('whatsapp://send?text=' + this._url, OPEN_LINK_TYPE, OPEN_LINK_OPTS);
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(options) {
	      return this.each(function () {
	        new SocialSharer($(this), options);
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return SocialSharer;
	}();
	
	$.fn[NAME] = SocialSharer._jQueryInterface;
	$.fn[NAME].Constructor = SocialSharer;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return SocialSharer._jQueryInterface;
	};
	
	exports.default = SocialSharer;
	
	/* Private */
	
	function _calcLeftPosition() {
	  return screen.width / 2 - NEW_WINDOW_WIDTH / 2;
	}
	
	function _checkSite(url) {
	  var editions = Voonto.getInstance().lookup('vocento.site.editions');
	  return location.search.indexOf('edtn') === -1 && editions.hasEditions ? url + '?' + editions.queryString + '=' + editions.current : url;
	}
	
	function _getTitle() {
	  var title = document.querySelector('meta[name="title"]');
	  return title ? title.content : document.title;
	}
	
	function _checkTwitterUser() {
	  var username = document.querySelector('meta[name="twitter:site"]');
	  return username && username.content ? '&via=' + username.content.slice(1) : '';
	}
	
	function _hasEdition() {
	  return Voonto.getInstance().lookup('vocento.site.editions').hasEditions;
	}

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'carousel',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME],
	    GALLERY_COUNTER = 'squido-carousel-galleries-opened',
	    NAVIGATE_BACK = 'squido-carousel-gallery-nav-back';
	
	var lastAdvMobileSlide$;
	
	var Carousel = function () {
	  function Carousel(element$, globalOptions) {
	    _classCallCheck(this, Carousel);
	
	    var swiper, selector, autoplay, realSlidesPerView, options;
	
	    this._element$ = element$;
	    this._nextButton$ = $('.swiper-button-next', element$);
	    this._prevButton$ = $('.swiper-button-prev', element$);
	    this._length = element$.find('.swiper-slide').length;
	    this._gtngHandler = this.goToNextGallery.bind(this);
	    this._addSwiperListener = this.addSwiperListener.bind(this);
	    this._onSwipeLeft = this.onSwipeLeft.bind(this);
	    this._historyBack = this.historyBack.bind(this);
	    this._checkDirection = this.checkDirection.bind(this);
	
	    // NOTE: Creating a local copy of swiper's configuration objects
	    options = {};
	    $.extend(true, options, globalOptions);
	
	    // NOTE: Calculate the real slides per view (case of multirow presentation)
	    realSlidesPerView = this.calculateRealSlidesPerView(options);
	
	    // NOTE: Hide pagination and arrow buttons if there is not scroll
	    if (!this.hasLoop(realSlidesPerView)) {
	      if (options.breakpoints["700"]) {
	        options.breakpoints["700"].pagination = null;
	      }
	      options.prevButton = null;
	      options.nextButton = null;
	      this._element$.find('.swiper-pagination').hide();
	      this._element$.find('.swiper-button-prev').hide();
	      this._element$.find('.swiper-button-next').hide();
	    }
	
	    // NOTE: Loop configuration
	    // FUTURE: la posibilidad de configuración del loop mediante data-atributo.
	    // loop = !!element$.data('voc-carousel-loop');
	
	    // NOTE: Si es versión móvil y el swipper se contrae a 2 filas, no tiene loop
	    if (!this.hasLoop(realSlidesPerView)) {
	      options.loop = false;
	    }
	
	    // NOTE: Autoplay configuration
	    autoplay = Number(element$.data('voc-carousel-autoplay'));
	    if (!isNaN(autoplay)) {
	      options.autoplay = autoplay;
	    }
	
	    // NOTE: Sync carousel configuration
	    selector = element$.data('voc-carousel-sync-selector');
	    if (selector) {
	      this._synced$ = $(selector);
	      this._synced$.children(':not(:first-child)').hide();
	    }
	
	    swiper = element$.swiper(Object.create(options));
	
	    swiper.on('slideChangeEnd', this.onSlideChangeEnd.bind(this));
	    swiper.on('slideChangeStart', this.onSlideChangeStart.bind(this));
	    this._swiper = swiper;
	    element$.data('swiper', swiper);
	
	    this.onInitCheckSession();
	    this.hidePrevButtonIfNeeded(swiper);
	    this.onInit();
	  }
	
	  _createClass(Carousel, [{
	    key: 'onInitCheckSession',
	    value: function onInitCheckSession() {
	      if ('sessionStorage' in window) {
	        if (!window.sessionStorage.getItem(GALLERY_COUNTER)) {
	          window.sessionStorage.setItem(GALLERY_COUNTER, 0);
	        }
	        if (window.sessionStorage.getItem(NAVIGATE_BACK)) {
	          window.sessionStorage.removeItem(NAVIGATE_BACK);
	          var i = this._length - 2;
	          this._swiper.slideTo(i, 50);
	        }
	      }
	    }
	  }, {
	    key: 'onInit',
	    value: function onInit() {
	      if (this.getSessionStorageCounter() > 0 && this._swiper.activeIndex === 0) {
	        this.deleteClass(this._prevButton$);
	        this._prevButton$.on('click', this._historyBack);
	        this._swiper.on('sliderMove', _.debounce(this._onSwipeLeft, 300));
	      }
	    }
	  }, {
	    key: 'onSlideChangeStart',
	    value: function onSlideChangeStart(event) {
	      var hasNextGallery, slide$, eq, key;
	
	      eq = event.activeIndex > this._length ? 1 : event.activeIndex === 0 ? this._length : event.activeIndex;
	      slide$ = this._element$.find('.swiper-slide').eq(eq);
	      hasNextGallery = !!$('.voc-next-gallery', slide$).length;
	
	      if (eq > 0) {
	        this._prevButton$.show();
	      }
	
	      this.hidePrevButtonIfNeeded(this._swiper);
	      key = this.getSessionStorageCounter();
	
	      if (this._swiper.activeIndex === 0 && key > 0) {
	        this.deleteClass(this._prevButton$);
	        this.onSlideBeginning();
	      } else {
	        this._swiper.off('sliderMove');
	        this._prevButton$.off('click', this._historyBack);
	      }
	
	      if (hasNextGallery) {
	        this.deleteClass(this._nextButton$);
	        this._nextButton$.one('click', this._gtngHandler);
	        this._swiper.once('slideChangeStart', this._addSwiperListener);
	      } else {
	        this._nextButton$.off('click', this._gtngHandler);
	        this._swiper.off('slideChangeEnd', this._addSwiperListener);
	      }
	    }
	  }, {
	    key: 'hidePrevButtonIfNeeded',
	    value: function hidePrevButtonIfNeeded(swiper) {
	      var key = this.getSessionStorageCounter();
	      if (swiper.activeIndex === 0 && key === 0) {
	        this._prevButton$.hide();
	      }
	    }
	  }, {
	    key: 'onSlideChangeEnd',
	    value: function onSlideChangeEnd(event) {
	      var track, ads, eq, app, moveRefresh, slide$;
	
	      app = Voonto.getInstance();
	      eq = event.activeIndex > this._length ? 1 : event.activeIndex === 0 ? this._length : event.activeIndex;
	      slide$ = this._element$.find('.swiper-slide').eq(eq);
	      track = slide$.data('voc-vtm-track');
	      ads = slide$.data('voc-vam-refresh');
	      moveRefresh = slide$.data('voc-vam-move-and-refresh');
	
	      if (moveRefresh) {
	        if (!slide$.find('[data-voc-vam]').length) {
	          var ads$ = void 0,
	              elNoAds$ = void 0;
	          elNoAds$ = slide$.find('.voc-w300');
	          ads$ = this._element$.find('[data-voc-vam]');
	
	          if (ads$.length) {
	            elNoAds$.append(ads$);
	            setTimeout(function () {
	              return app.trigger('vam:refresh', moveRefresh);
	            }, 0);
	          }
	        }
	      }
	
	      // NOTE: Increase adv container height to 600px if the device is mobile
	      if (Voonto.is.mobile()) {
	        this.mobileAdvertisingResize(moveRefresh, slide$);
	      }
	
	      if (track) {
	        app.trigger('vtm:track', track);
	      }
	      if (ads) {
	        app.trigger('vam:refresh', ads);
	      }
	
	      if (this._synced$) {
	        this._synced$.children(':visible').hide();
	        this._synced$.children().eq(eq - 1).show();
	      }
	    }
	  }, {
	    key: 'addSwiperListener',
	    value: function addSwiperListener() {
	      this._swiper.on('sliderMove', _.debounce(this._checkDirection, 300));
	    }
	  }, {
	    key: 'checkDirection',
	    value: function checkDirection() {
	      if (this._swiper.swipeDirection === 'next') {
	        this.goToNextGallery();
	      }
	    }
	  }, {
	    key: 'goToNextGallery',
	    value: function goToNextGallery() {
	      var link;
	      link = $('.voc-next-gallery > a', this._element$).attr('href');
	      document.location = link;
	      this.storeCounterSession();
	      window.sessionStorage.removeItem(NAVIGATE_BACK);
	    }
	  }, {
	    key: 'storeCounterSession',
	    value: function storeCounterSession() {
	      if ('sessionStorage' in window) {
	        if (window.sessionStorage.getItem(GALLERY_COUNTER)) {
	          var key = this.getSessionStorageCounter() + 1;
	          window.sessionStorage.setItem(GALLERY_COUNTER, key);
	        }
	      }
	    }
	  }, {
	    key: 'getSessionStorageCounter',
	    value: function getSessionStorageCounter() {
	      var value = window.sessionStorage.getItem(GALLERY_COUNTER).split();
	      return Number(value[0]);
	    }
	  }, {
	    key: 'deleteClass',
	    value: function deleteClass(button$) {
	      button$.removeClass('swiper-button-disabled');
	    }
	  }, {
	    key: 'onSlideBeginning',
	    value: function onSlideBeginning() {
	      this._swiper.on('sliderMove', _.debounce(this._onSwipeLeft, 300));
	      this._prevButton$.one('click', this._historyBack);
	    }
	  }, {
	    key: 'onSwipeLeft',
	    value: function onSwipeLeft(swiper) {
	      if (swiper.swipeDirection === 'prev') {
	        this.historyBack();
	      }
	    }
	  }, {
	    key: 'historyBack',
	    value: function historyBack() {
	      var key = this.getSessionStorageCounter() - 1;
	      window.sessionStorage.setItem(GALLERY_COUNTER, key);
	      window.sessionStorage.setItem(NAVIGATE_BACK, true);
	      window.history.back();
	    }
	  }, {
	    key: 'hasLoop',
	    value: function hasLoop(realSlidesPerView) {
	      return Voonto.is.mobile() ? this._length >= realSlidesPerView : this._length > realSlidesPerView;
	    }
	  }, {
	    key: 'calculateRealSlidesPerView',
	    value: function calculateRealSlidesPerView(options) {
	      var realSlidesPerView = 0;
	
	      if (!isNaN(options.slidesPerView)) {
	        var slidesPerRow, slidesPerColumn;
	
	        if (Voonto.is.mobile() && options.breakpoints["700"]) {
	          var slidesPerRowMobile, slidesPerColumnMobile;
	          slidesPerRowMobile = options.breakpoints["700"].slidesPerView;
	          slidesPerColumnMobile = options.breakpoints["700"].slidesPerColumn;
	
	          if (!isNaN(slidesPerRowMobile)) {
	            slidesPerRow = slidesPerRowMobile;
	          }
	          if (!isNaN(slidesPerColumnMobile)) {
	            slidesPerColumn = slidesPerColumnMobile;
	          }
	        } else if (Voonto.is.tablet() && options.breakpoints["1039"]) {
	          var slidesPerRowTablet, slidesPerColumnTablet;
	          slidesPerRowTablet = options.breakpoints["1039"].slidesPerView;
	          slidesPerColumnTablet = options.breakpoints["1039"].slidesPerColumn;
	
	          if (!isNaN(slidesPerRowTablet)) {
	            slidesPerRow = slidesPerRowTablet;
	          }
	          if (!isNaN(slidesPerColumnTablet)) {
	            slidesPerColumn = slidesPerColumnTablet;
	          }
	        } else {
	          slidesPerRow = options.slidesPerView;
	          slidesPerColumn = options.slidesPerColumn;
	        }
	
	        if (!isNaN(slidesPerColumn)) {
	          realSlidesPerView = slidesPerRow * slidesPerColumn;
	        } else {
	          realSlidesPerView = slidesPerRow;
	        }
	      }
	
	      return realSlidesPerView;
	    }
	  }, {
	    key: 'mobileAdvertisingResize',
	    value: function mobileAdvertisingResize(moveRefresh, currentSlide) {
	      if (moveRefresh) {
	        if (currentSlide.find('.voc-figure-container').length) {
	          lastAdvMobileSlide$ = currentSlide.find('.voc-figure-container');
	          lastAdvMobileSlide$.addClass("voc-figure-container--600h");
	        }
	      } else if (lastAdvMobileSlide$) {
	        lastAdvMobileSlide$.removeClass("voc-figure-container--600h");
	        lastAdvMobileSlide$ = null;
	      }
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(options) {
	      return this.each(function () {
	        new Carousel($(this), options);
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return Carousel;
	}();
	
	$.fn[NAME] = Carousel._jQueryInterface;
	$.fn[NAME].Constructor = Carousel;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return Carousel._jQueryInterface;
	};
	
	exports.default = Carousel;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'dynamicGrid',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var SPONSORED_CLASS = 'voc-sponsored',
	    RELATED_CLASS = 'voc-related',
	    PULL_RIGHT_CLASS = 'pull-right',
	    RELATED_GRID_CLASSES = 'col-xs-12 col-sm-9 col-md-9 col-lg-9',
	    RELATED_GRID_LI_CLASSES = 'col-xs-12 col-sm-4 col-md-4 col-lg-4';
	
	var DynamicGrid = function () {
	  function DynamicGrid(element$) {
	    _classCallCheck(this, DynamicGrid);
	
	    this._element$ = element$;
	    this._sponsoredEl$ = element$.find('.' + SPONSORED_CLASS);
	    this._relatedEl$ = element$.find('.' + RELATED_CLASS);
	
	    this._sponsoredEl$.on('vam:slotrendered', this.changeGrid.bind(this));
	  }
	
	  _createClass(DynamicGrid, [{
	    key: 'changeGrid',
	    value: function changeGrid() {
	      this._sponsoredEl$.removeClass('hidden');
	      this._relatedEl$.removeClass().addClass(RELATED_CLASS + ' ' + PULL_RIGHT_CLASS + ' ' + RELATED_GRID_CLASSES);
	      this._relatedEl$.find('li').removeClass().addClass(RELATED_GRID_LI_CLASSES);
	      if (this._relatedEl$.find('li').length === 4) {
	        this._relatedEl$.find('li:last').hide();
	      }
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(options) {
	      return this.each(function () {
	        new DynamicGrid($(this), options);
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return DynamicGrid;
	}();
	
	$.fn[NAME] = DynamicGrid._jQueryInterface;
	$.fn[NAME].Constructor = DynamicGrid;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return DynamicGrid._jQueryInterface;
	};
	
	exports.default = DynamicGrid;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'lazy',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var Lazy = function () {
	  function Lazy(element$) {
	    _classCallCheck(this, Lazy);
	
	    element$.one('inview', function () /*event, isInView*/{
	      element$.attr('src', element$.data('original'));
	    });
	  }
	
	  _createClass(Lazy, null, [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() /*config*/{
	      return this.each(function () {
	        new Lazy($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return Lazy;
	}();
	
	$.fn[NAME] = Lazy._jQueryInterface;
	$.fn[NAME].Constructor = Lazy;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return Lazy._jQueryInterface;
	};
	
	exports.default = Lazy;

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'socialButtons',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var SOCIAL_ICONS_TEMPLATE = '\n  <a title="facebook" class="voc-social-btn voc-facebook-share" data-voc-social-sharer="facebook">\n    <i class="voc-icons facebook"></i>\n  </a>\n  <a title="twitter" class="voc-social-btn voc-twitter-share" data-voc-social-sharer="twitter">\n    <i class="voc-icons twitter"></i>\n  </a>\n  <a title="whatsapp" class="voc-social-btn voc-whatsapp-share hidden-lg hidden-md hidden-sm" data-voc-social-sharer="whatsapp">\n    <i class="voc-icons whatsapp"></i>\n  </a>\n  <input type="checkbox" id="moreSocialMedia" class="voc-input-media">\n  <label for="moreSocialMedia" class="voc-social-btn voc-more-share">\n    <i class="voc-icons dots"></i>\n  </label>\n  <div class="voc-more-social">\n    <a title="Google +" class="voc-social-btn voc-googleplus-share" data-voc-social-sharer="googleplus">\n      <i class="voc-icons googleplus"></i>\n    </a>\n    <a title="linkedin" class="voc-social-btn voc-linkedin-share" data-voc-social-sharer="linkedin">\n      <i class="voc-icons linkedin"></i>\n    </a>\n    <a class="voc-social-btn voc-mail-share" data-voc-social-sharer="mail">\n      <i class="voc-icons mail"></i>\n    </a>\n  </div>\n';
	
	var SocialButtons = function () {
	  function SocialButtons(element$) {
	    _classCallCheck(this, SocialButtons);
	
	    var url = element$.data('voc-social-buttons');
	
	    element$.html(SOCIAL_ICONS_TEMPLATE).find('[data-voc-social-sharer]').socialSharer({ url: url });
	  }
	
	  _createClass(SocialButtons, null, [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() {
	      return this.each(function () {
	        new SocialButtons($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return SocialButtons;
	}();
	
	$.fn[NAME] = SocialButtons._jQueryInterface;
	$.fn[NAME].Constructor = SocialButtons;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return SocialButtons._jQueryInterface;
	};
	
	exports.default = SocialButtons;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'adverDisplacement',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var AUTO = 'auto',
	    MARGIN = 400;
	
	var AdverDisplacement = function () {
	  function AdverDisplacement(element$, options) {
	    _classCallCheck(this, AdverDisplacement);
	
	    if (element$.parent().height() <= element$.height()) {
	      return;
	    }
	
	    this._element$ = element$;
	
	    if (element$.data('voc-adver-displacement') === AUTO) {
	      element$.one('vam:slotrendered', this.onRendered.bind(this));
	    }
	
	    element$.stick_in_parent(options);
	  }
	
	  _createClass(AdverDisplacement, [{
	    key: 'onRendered',
	    value: function onRendered() {
	      this._element$.parent().height(this._element$.height() + MARGIN);
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(options) {
	      return this.each(function () {
	        new AdverDisplacement($(this), options);
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return AdverDisplacement;
	}();
	
	$.fn[NAME] = AdverDisplacement._jQueryInterface;
	$.fn[NAME].Constructor = AdverDisplacement;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return AdverDisplacement._jQueryInterface;
	};
	
	exports.default = AdverDisplacement;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'tabBind',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var TabBind = function () {
	  function TabBind(element$) {
	    _classCallCheck(this, TabBind);
	
	    this._element$ = element$;
	    this._element$.on('shown.bs.tab', this.onClick.bind(this));
	  }
	
	  _createClass(TabBind, [{
	    key: 'onClick',
	    value: function onClick() /*event*/{
	      var tabBinded = $('a[href="' + this._element$.attr('href') + '"]');
	      tabBinded.closest('li').siblings().removeClass('active');
	      tabBinded.closest('li').addClass('active');
	      tabBinded.addClass('active');
	    }
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() /*config*/{
	      return this.each(function () {
	        new TabBind($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return TabBind;
	}();
	
	$.fn[NAME] = TabBind._jQueryInterface;
	$.fn[NAME].Constructor = TabBind;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return TabBind._jQueryInterface;
	};
	
	exports.default = TabBind;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(17);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'editionJumper',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var _Voonto = Voonto,
	    Cookies = _Voonto.Cookies,
	    editions = Voonto.getInstance().lookup('vocento.site.editions'),
	    RELOAD_TIMEOUT = 300;
	
	var EditionJumper = function () {
	  function EditionJumper(element$) {
	    _classCallCheck(this, EditionJumper);
	
	    var value;
	
	    value = element$.data('voc-edition-jumper');
	    if (value) {
	      if (element$.val() === Cookies.get(_constants.EDITION_COOKIE)) {
	        element$.prop('checked', true);
	      }
	      element$.on('click', _onEditionChange);
	    }
	
	    if (element$.get(0).tagName === 'SELECT') {
	      element$.val(Cookies.get(_constants.EDITION_COOKIE) || editions.current).change();
	      element$.on('change', _onEditionChange);
	    }
	  }
	
	  _createClass(EditionJumper, null, [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface() /*config*/{
	      return this.each(function () {
	        new EditionJumper($(this));
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return EditionJumper;
	}();
	
	$.fn[NAME] = EditionJumper._jQueryInterface;
	$.fn[NAME].Constructor = EditionJumper;
	$.fn[NAME].noConflict = function noConflict() {
	  $.fn[NAME] = JQUERY_NO_CONFLICT;
	  return EditionJumper._jQueryInterface;
	};
	
	exports.default = EditionJumper;
	
	/* Private */
	
	function _onEditionChange() {
	  Cookies.set(_constants.EDITION_COOKIE, this.value, _constants.EDITION_COOKIE_OPTIONS);
	  setTimeout(function () {
	    document.location = '/';
	  }, RELOAD_TIMEOUT);
	}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NAME = 'newslettersStickyPopups',
	    VERSION = '1.0.0',
	    JQUERY_NO_CONFLICT = $.fn[NAME];
	
	var NewslettersStrickyPopups = function () {
	    function NewslettersStrickyPopups(element$) {
	        _classCallCheck(this, NewslettersStrickyPopups);
	
	        this._element$ = element$;
	
	        //Controla que salte el popup de aviso en el formulario de newsletter si haces un cambio y navegas sin guardar
	        var change_checkbox = false,
	            url_destino;
	
	        $("#form-newsletters, #form-newsletters-anonimo").find(".form-input, .css-checkbox--s").one('change', function () {
	            change_checkbox = true;
	            //Si se hace algun cambio, se muestra el sticky de guardar
	            $('.savesticky').addClass('show');
	        });
	
	        $("#form-newsletters .savesticky .ap-btn").one('click', function () {
	            change_checkbox = false;
	            //Solo se oculta el sticky en Newsletter no anonima
	            $('.savesticky').removeClass('show');
	        });
	
	        $(".js-guardar").one('click', function () {
	            change_checkbox = false;
	            $('.savesticky').removeClass('show');
	            $("#form-newsletters").submit();
	        });
	
	        $(".js-salirsinguardar").one('click', function () {
	            window.location.href = url_destino;
	        });
	
	        //En la pagina de newsletter, al hacer click en cualquier link, si el usuario ha hecho algun cambio, salta modal de aviso
	        $('a').on('click', function (e) {
	            if ($("#form-newsletters").length === 1 && change_checkbox === true) {
	                url_destino = $(this).attr('href');
	                e.preventDefault();
	                $("#ap-modal-bg").show();
	                $("#modal-newsletter-aviso-guardar").show();
	                return false;
	            }
	        });
	
	        //Plegar modulos
	        $('.js-seccionplegable').find('.js-plegador').on('click', function () {
	            $(this).parents('.js-seccionplegable').toggleClass('cerrado').find('.js-plegable').slideToggle();
	        });
	
	        // Abrir una modal desde UI:
	        // Boton debe tener la clase js-abrirmodal y atributo data-opemodal con el valor del id de la modal que se quiera abrir
	        $('.js-abrirmodal').each(function () {
	            $(this).on('click', function (e) {
	
	                var puntero = $(this).data('openmodal');
	                var selectorModal = "#" + puntero;
	
	                e.preventDefault();
	                e.stopPropagation();
	                $('#ap-modal-bg').show(); // opacidad
	                $(selectorModal).show();
	            });
	        });
	
	        //Cerrar modal
	        $('.js-cerrarmodal, .ap-modal-ico-cerrar').on('click', function (e) {
	            e.preventDefault();
	            $(this).parents('.modalbox').hide();
	            $('#ap-modal-bg').hide(); // opacidad
	        });
	
	        //Select-customizados
	        //Coge el texto del option selected y lo mete en el span 'falso'
	        $('.js-selectcustom').each(function () {
	            var textValor = $(this).find('[selected=selected]').text();
	            $(this).find('.js-selectcustom-optionfalse').text(textValor);
	        });
	
	        //Al seleccionar una opcion del combo
	        $('.js-selectcustom').find('select').each(function () {
	            $(this).on('change', function () {
	                $(this).siblings('.js-selectcustom-optionfalse').text($(this).find('option:selected').text());
	            });
	        });
	
	        //Icono Whatsapp en ClubDetalle
	        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
	            $('.ap-detalle-compartir-item.wa').removeClass('novisible');
	        }
	    }
	
	    _createClass(NewslettersStrickyPopups, null, [{
	        key: '_jQueryInterface',
	        value: function _jQueryInterface() {
	            return this.each(function () {
	                new NewslettersStrickyPopups($(this));
	            });
	        }
	    }, {
	        key: 'VERSION',
	        get: function get() {
	            return VERSION;
	        }
	    }]);
	
	    return NewslettersStrickyPopups;
	}();
	
	$.fn[NAME] = NewslettersStrickyPopups._jQueryInterface;
	$.fn[NAME].Constructor = NewslettersStrickyPopups;
	$.fn[NAME].noConflict = function noConflict() {
	    $.fn[NAME] = JQUERY_NO_CONFLICT;
	    return NewslettersStrickyPopups._jQueryInterface;
	};
	
	exports.default = NewslettersStrickyPopups;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._getHeaderHeight = _getHeaderHeight;
	
	var _constants = __webpack_require__(17);
	
	// import LazyLoad from 'lazyload';
	
	var _Voonto = Voonto,
	    Cookies = _Voonto.Cookies,
	    is = _Voonto.is,
	    app = Voonto.getInstance(),
	    _header$ = $(_constants.HEADER_SELECTOR);
	
	$(document).ready(function () {
	  _showBreakingNewsIfProceed();
	  _initEdition();
	
	  _initPlugins($(this));
	  app.on('voonto:reload', function (event, context$) {
	    _initPlugins(context$);
	  });
	
	  setTimeout(function () {
	    $('[data-voc-adver-unfix]').adverUnfix({ offset_top: _getHeaderHeight() });
	    $('[data-voc-animated-underline]').animatedUnderline();
	    $('[data-voc-arrows-display]').arrowsDisplay({ hideOverlapClass: '.swiper-container' });
	    $('[data-voc-close-gallery]').closeGallery();
	    $('body').collapseBootstrapMenus();
	    $('[data-voc-dynamic-grid]').dynamicGrid();
	    $('[data-voc-edition-jumper]').editionJumper();
	    $('[data-voc-goto-home-bubble]').gotoHomeBubble();
	    $('[data-voc-infinite-scroll]').infiniteScroll();
	    $('[data-voc-scroll-progress]').scrollProgress();
	    $('[data-voc-social-sharer]').socialSharer();
	    $('[data-voc-bind-tab]').tabBind();
	
	    $('#tickers-breaking-news').on('closed.bs.alert', _closeBreakingNews);
	    $('[data-voc-vam]').on('vam:isempty vam:inactive', function () {
	      $(this).parent().addClass('voc-no-margins');
	      $(this).remove();
	    });
	
	    //Recalculate height of every adv sticky parent when an adv is rendered.
	    $('[data-voc-vam]').on('vam:viewable', function () {
	      setTimeout(function () {
	        $(document.body).trigger('sticky_kit:recalc');
	      }, 500);
	    });
	
	    $('.voc-content-menu').on('scroll', function (_ref) {
	      var originalEvent = _ref.originalEvent;
	      return originalEvent.stopPropagation();
	    });
	    $('[data-target="#searchBar"]').on('click', function () {
	      setTimeout(function () {
	        $('#searchBar').find('input:first').focus();
	      }, 0);
	    });
	
	    app.load('//platform.twitter.com/widgets.js');
	    app.load('//platform.instagram.com/en_US/embeds.js');
	  }, 0);
	});
	
	/* Private */
	
	function _initPlugins(context$) {
	  if (is.desktop()) {
	    $('.voc-blogs.voc-beach-info', context$).find('.swiper-container').removeAttr('data-voc-carousel-auto').removeClass('swiper-container');
	    $('.voc-blogs.voc-beach-info', context$).find('.swiper-wrapper').removeClass('swiper-wrapper');
	    $('.voc-blogs.voc-ski-info', context$).find('.swiper-container').removeAttr('data-voc-carousel-auto').removeClass('swiper-container');
	    $('.voc-blogs.voc-ski-info', context$).find('.swiper-wrapper').removeClass('swiper-wrapper');
	  }
	
	  setTimeout(function () {
	    $('[data-voc-adver-displacement]').adverDisplacement({ offset_top: _getHeaderHeight() });
	    $('[data-voc-anchor-displacement]', context$).anchorDisplacement();
	    $('[data-voc-btn-displacement]', context$).buttonDisplacement();
	    $('[data-voc-carousel]', context$).carousel(_constants.SWIPER_DEFAULTS);
	    $('[data-voc-carousel-fraction]', context$).carousel(_constants.SWIPER_FRACTION);
	    $('[data-voc-carousel-auto]', context$).carousel(_constants.SWIPER_AUTO);
	    $('[data-voc-carousel-2rows]', context$).carousel(_constants.SWIPER_2ROWS);
	    $('[data-voc-carousel-adv]', context$).carousel(_constants.SWIPER_ADV);
	    $('[data-voc-carousel-nav]', context$).carousel(_constants.SWIPER_NAV);
	    $('[data-voc-carousel-on-plus]', context$).carousel(_constants.SWIPER_ON_PLUS);
	    $('[data-voc-datepicker]', context$).datepicker();
	    $('[data-voc-deactivate-tabs-onclick]', context$).deactivateTabsOnclick();
	    $('[data-voc-deactivate-tabs-resolution]', context$).deactivateTabsResolution();
	    $('[data-voc-dependent-select]', context$).dependentSelect();
	    $('.voc-styled-select', context$).dynamicArrow();
	    $('[data-voc-dynamic-grid]', context$).dynamicGrid();
	    $('[data-voc-fixed-column]', context$).fixedColumn();
	    $('[data-voc-init-swiper-on-tab]', context$).initSwiperOnTab();
	    $('.lazy', context$).lazy();
	    $('[data-voc-match-field]', context$).matchbind();
	    $('[data-voc-molinillo]', context$).molinillo();
	    $('[data-voc-select-display]', context$).selectDisplay();
	    $('[data-voc-select-redirect]', context$).selectRedirect();
	    $('[data-voc-share-selection]', context$).shareSelection({ offset_top: _getHeaderHeight() });
	    $('[data-voc-social-more]', context$).socialMore();
	    $('[data-voc-social-sharer]', context$).socialSharer();
	    $('[data-voc-bind-tab]', context$).tabBind();
	    $('[data-voc-toggle-click]', context$).toggleClick();
	    $('.hemeroteca-filter', context$).on('click', function (e) {
	      return $(e.target).toggleClass('active');
	    });
	    $('[data-voc-vam]', context$).on('vam:isempty vam:inactive', function () {
	      $(this).parent().addClass('voc-no-margins');
	      $(this).remove();
	    });
	
	    // Newsletters popups and stickies
	    $('[data-voc-newsletters]', context$).newslettersStickyPopups();
	  }, 0);
	}
	
	function _initEdition() {
	  var editions = Voonto.getInstance().lookup('vocento.site.editions');
	
	  if (editions.hasEditions && !Cookies.get(_constants.EDITION_COOKIE)) {
	    Cookies.set(_constants.EDITION_COOKIE, editions.current, _constants.EDITION_COOKIE_OPTIONS);
	  }
	}
	
	function _closeBreakingNews() {
	  _header$.removeClass('voc-header-sticker');
	
	  if ('sessionStorage' in window) {
	    window.sessionStorage.setItem('bc-closed', true);
	  }
	}
	
	function _showBreakingNewsIfProceed() {
	  var _bn$ = $('#tickers-breaking-news');
	
	  if (_bn$.length) {
	    if ('sessionStorage' in window) {
	      if (window.sessionStorage.getItem('bc-closed')) {
	        _header$.removeClass('voc-header-sticker');
	        _bn$.remove();
	      } else {
	        _bn$.addClass('voc-tickers').show();
	        _header$.addClass('voc-header-sticker');
	      }
	    } else {
	      _header$.addClass('voc-header-sticker');
	      _bn$.addClass('voc-tickers').show();
	    }
	  } else {
	    _header$.removeClass('voc-header-sticker');
	    _bn$.remove();
	  }
	
	  if (document.location.pathname === '/' && _header$.hasClass('voc-header-sticker')) {
	    _header$.addClass('voc-header-sticker-home');
	  }
	}
	
	function _getHeaderHeight() {
	  var totalHeight = 0;
	
	  _header$.children(':visible').each(function () {
	    if (!$(this).hasClass('voc-header-home')) {
	      totalHeight += $(this).outerHeight();
	    }
	  });
	
	  return totalHeight;
	}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// squido.js